{
  "Total": {
    "ageData": {
      "2015": {
        "total": "148,834",
        "16to19": "4,734",
        "20to24": "14,022",
        "25to34": "32,742",
        "35to44": "31,252",
        "45to54": "32,643",
        "55to64": "24,975",
        "65+": "8,465",
        "medianAge": "24,975"
      }
    },
    "title": "Total",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "148,834",
        "women": "46.8",
        "white": "11.7",
        "black": "5.8",
        "asian": "16.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "109,080",
        "median": "$809",
        "maleWorkers": "60,746",
        "maleMedian": "$895",
        "femaleWorkers": "48,334",
        "femaleMedian": "$726"
      }
    }
  },
  "Management, professional, and related occupations": {
    "ageData": {
      "2015": {
        "total": "57,960",
        "16to19": "384",
        "20to24": "3,073",
        "25to34": "13,154",
        "35to44": "13,553",
        "45to54": "13,668",
        "55to64": "10,392",
        "65+": "3,737",
        "medianAge": "10,392"
      }
    },
    "title": "Management, professional, and related occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "57,960",
        "women": "51.5",
        "white": "9.2",
        "black": "7.7",
        "asian": "9.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "44,844",
        "median": "1,158",
        "maleWorkers": "21,807",
        "maleMedian": "1,383",
        "femaleWorkers": "23,038",
        "femaleMedian": "996"
      }
    }
  },
  "Management, business, and financial operations occupations": {
    "ageData": {
      "2015": {
        "total": "24,108",
        "16to19": "85",
        "20to24": "930",
        "25to34": "4,787",
        "35to44": "5,567",
        "45to54": "6,279",
        "55to64": "4,697",
        "65+": "1,764",
        "medianAge": "4,697"
      }
    },
    "title": "Management, business, and financial operations occupations",
    "depth": 2,
    "parent": "Management, professional, and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "24,108",
        "women": "43.6",
        "white": "8.2",
        "black": "6.3",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "18,422",
        "median": "1,258",
        "maleWorkers": "10,018",
        "maleMedian": "1,436",
        "femaleWorkers": "8,404",
        "femaleMedian": "1,073"
      }
    }
  },
  "Management occupations": {
    "ageData": {
      "2015": {
        "total": "16,994",
        "16to19": "60",
        "20to24": "534",
        "25to34": "3,000",
        "35to44": "3,972",
        "45to54": "4,643",
        "55to64": "3,452",
        "65+": "1,334",
        "medianAge": "3,452"
      }
    },
    "title": "Management occupations",
    "depth": 3,
    "parent": "Management, business, and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "16,994",
        "women": "39.2",
        "white": "7.3",
        "black": "5.6",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12,480",
        "median": "1,351",
        "maleWorkers": "7,332",
        "maleMedian": "1,486",
        "femaleWorkers": "5,147",
        "femaleMedian": "1,139"
      }
    }
  },
  "Chief executives": {
    "ageData": {
      "2015": {
        "total": "1,517",
        "16to19": "0",
        "20to24": "6",
        "25to34": "121",
        "35to44": "286",
        "45to54": "493",
        "55to64": "436",
        "65+": "176",
        "medianAge": "436"
      }
    },
    "title": "Chief executives",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,517",
        "women": "27.9",
        "white": "3.6",
        "black": "4.7",
        "asian": "5.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,046",
        "median": "2,041",
        "maleWorkers": "763",
        "maleMedian": "2,251",
        "femaleWorkers": "283",
        "femaleMedian": "1,836"
      }
    }
  },
  "General and operations managers": {
    "ageData": {
      "2015": {
        "total": "899",
        "16to19": "2",
        "20to24": "27",
        "25to34": "211",
        "35to44": "238",
        "45to54": "247",
        "55to64": "146",
        "65+": "28",
        "medianAge": "146"
      }
    },
    "title": "General and operations managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "899",
        "women": "27.6",
        "white": "6.9",
        "black": "4.7",
        "asian": "10.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "823",
        "median": "1,260",
        "maleWorkers": "621",
        "maleMedian": "1,347",
        "femaleWorkers": "202",
        "femaleMedian": "1,002"
      }
    }
  },
  "Legislators": {
    "ageData": {
      "2015": {
        "total": "13",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "4",
        "45to54": "4",
        "55to64": "2",
        "65+": "2",
        "medianAge": "2"
      }
    },
    "title": "Legislators",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Advertising and promotions managers": {
    "ageData": {
      "2015": {
        "total": "67",
        "16to19": "0",
        "20to24": "10",
        "25to34": "15",
        "35to44": "16",
        "45to54": "13",
        "55to64": "9",
        "65+": "4",
        "medianAge": "9"
      }
    },
    "title": "Advertising and promotions managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "67",
        "women": "53.6",
        "white": "0.0",
        "black": "5.5",
        "asian": "6.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "55",
        "median": "1,050",
        "maleWorkers": "29",
        "maleMedian": "-",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Marketing and sales managers": {
    "ageData": {
      "2015": {
        "total": "1,006",
        "16to19": "3",
        "20to24": "55",
        "25to34": "260",
        "35to44": "261",
        "45to54": "242",
        "55to64": "155",
        "65+": "30",
        "medianAge": "155"
      }
    },
    "title": "Marketing and sales managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,006",
        "women": "43.2",
        "white": "6.2",
        "black": "5.8",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "948",
        "median": "1,462",
        "maleWorkers": "570",
        "maleMedian": "1,603",
        "femaleWorkers": "378",
        "femaleMedian": "1,258"
      }
    }
  },
  "Public relations and fundraising managers": {
    "ageData": {
      "2015": {
        "total": "61",
        "16to19": "0",
        "20to24": "2",
        "25to34": "18",
        "35to44": "15",
        "45to54": "15",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Public relations and fundraising managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "61",
        "women": "59.2",
        "white": "10.6",
        "black": "5.2",
        "asian": "5.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "59",
        "median": "1,557",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "35",
        "femaleMedian": "-"
      }
    }
  },
  "Administrative services managers": {
    "ageData": {
      "2015": {
        "total": "195",
        "16to19": "1",
        "20to24": "3",
        "25to34": "29",
        "35to44": "44",
        "45to54": "59",
        "55to64": "46",
        "65+": "14",
        "medianAge": "46"
      }
    },
    "title": "Administrative services managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "195",
        "women": "47.7",
        "white": "9.9",
        "black": "3.0",
        "asian": "7.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "170",
        "median": "1,191",
        "maleWorkers": "96",
        "maleMedian": "1,451",
        "femaleWorkers": "73",
        "femaleMedian": "981"
      }
    }
  },
  "Computer and information systems managers": {
    "ageData": {
      "2015": {
        "total": "652",
        "16to19": "1",
        "20to24": "11",
        "25to34": "104",
        "35to44": "217",
        "45to54": "197",
        "55to64": "102",
        "65+": "20",
        "medianAge": "102"
      }
    },
    "title": "Computer and information systems managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "652",
        "women": "27.2",
        "white": "5.6",
        "black": "14.2",
        "asian": "4.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "636",
        "median": "1,728",
        "maleWorkers": "466",
        "maleMedian": "1,817",
        "femaleWorkers": "169",
        "femaleMedian": "1,563"
      }
    }
  },
  "Financial managers": {
    "ageData": {
      "2015": {
        "total": "1,197",
        "16to19": "1",
        "20to24": "31",
        "25to34": "243",
        "35to44": "317",
        "45to54": "347",
        "55to64": "200",
        "65+": "58",
        "medianAge": "200"
      }
    },
    "title": "Financial managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,197",
        "women": "49.6",
        "white": "7.2",
        "black": "7.9",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,124",
        "median": "1,408",
        "maleWorkers": "551",
        "maleMedian": "1,732",
        "femaleWorkers": "573",
        "femaleMedian": "1,130"
      }
    }
  },
  "Compensation and benefits managers": {
    "ageData": {
      "2015": {
        "total": "23",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "4",
        "45to54": "8",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Compensation and benefits managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Human resources managers": {
    "ageData": {
      "2015": {
        "total": "290",
        "16to19": "0",
        "20to24": "5",
        "25to34": "49",
        "35to44": "89",
        "45to54": "90",
        "55to64": "47",
        "65+": "9",
        "medianAge": "47"
      }
    },
    "title": "Human resources managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "290",
        "women": "73.3",
        "white": "11.9",
        "black": "2.2",
        "asian": "10.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "254",
        "median": "1,365",
        "maleWorkers": "68",
        "maleMedian": "1,495",
        "femaleWorkers": "186",
        "femaleMedian": "1,274"
      }
    }
  },
  "Training and development managers": {
    "ageData": {
      "2015": {
        "total": "41",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "15",
        "45to54": "11",
        "55to64": "8",
        "65+": "2",
        "medianAge": "8"
      }
    },
    "title": "Training and development managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "41",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial production managers": {
    "ageData": {
      "2015": {
        "total": "280",
        "16to19": "2",
        "20to24": "1",
        "25to34": "48",
        "35to44": "70",
        "45to54": "93",
        "55to64": "59",
        "65+": "7",
        "medianAge": "59"
      }
    },
    "title": "Industrial production managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "280",
        "women": "18.3",
        "white": "5.1",
        "black": "4.3",
        "asian": "6.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "267",
        "median": "1,485",
        "maleWorkers": "221",
        "maleMedian": "1,528",
        "femaleWorkers": "45",
        "femaleMedian": "-"
      }
    }
  },
  "Purchasing managers": {
    "ageData": {
      "2015": {
        "total": "198",
        "16to19": "0",
        "20to24": "6",
        "25to34": "28",
        "35to44": "58",
        "45to54": "49",
        "55to64": "42",
        "65+": "13",
        "medianAge": "42"
      }
    },
    "title": "Purchasing managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "198",
        "women": "44.8",
        "white": "11.4",
        "black": "7.2",
        "asian": "12.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "193",
        "median": "1,348",
        "maleWorkers": "109",
        "maleMedian": "1,404",
        "femaleWorkers": "84",
        "femaleMedian": "1,226"
      }
    }
  },
  "Transportation, storage, and distribution managers": {
    "ageData": {
      "2015": {
        "total": "263",
        "16to19": "1",
        "20to24": "7",
        "25to34": "57",
        "35to44": "66",
        "45to54": "70",
        "55to64": "52",
        "65+": "10",
        "medianAge": "52"
      }
    },
    "title": "Transportation, storage, and distribution managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "263",
        "women": "21.1",
        "white": "8.2",
        "black": "3.4",
        "asian": "19.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "276",
        "median": "966",
        "maleWorkers": "224",
        "maleMedian": "1,006",
        "femaleWorkers": "52",
        "femaleMedian": "749"
      }
    }
  },
  "Farmers, ranchers, and other agricultural managers": {
    "ageData": {
      "2015": {
        "total": "1,052",
        "16to19": "7",
        "20to24": "30",
        "25to34": "128",
        "35to44": "137",
        "45to54": "201",
        "55to64": "272",
        "65+": "276",
        "medianAge": "272"
      }
    },
    "title": "Farmers, ranchers, and other agricultural managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,052",
        "women": "23.9",
        "white": "0.9",
        "black": "0.6",
        "asian": "4.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "129",
        "median": "769",
        "maleWorkers": "106",
        "maleMedian": "847",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Construction managers": {
    "ageData": {
      "2015": {
        "total": "737",
        "16to19": "0",
        "20to24": "22",
        "25to34": "134",
        "35to44": "173",
        "45to54": "194",
        "55to64": "180",
        "65+": "34",
        "medianAge": "180"
      }
    },
    "title": "Construction managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "737",
        "women": "6.7",
        "white": "3.3",
        "black": "3.2",
        "asian": "12.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "471",
        "median": "1,329",
        "maleWorkers": "429",
        "maleMedian": "1,357",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Education administrators": {
    "ageData": {
      "2015": {
        "total": "928",
        "16to19": "4",
        "20to24": "21",
        "25to34": "138",
        "35to44": "261",
        "45to54": "261",
        "55to64": "186",
        "65+": "56",
        "medianAge": "186"
      }
    },
    "title": "Education administrators",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "928",
        "women": "65.7",
        "white": "13.4",
        "black": "3.8",
        "asian": "9.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "778",
        "median": "1,423",
        "maleWorkers": "282",
        "maleMedian": "1,585",
        "femaleWorkers": "496",
        "femaleMedian": "1,252"
      }
    }
  },
  "Architectural and engineering managers": {
    "ageData": {
      "2015": {
        "total": "110",
        "16to19": "0",
        "20to24": "0",
        "25to34": "16",
        "35to44": "26",
        "45to54": "40",
        "55to64": "23",
        "65+": "5",
        "medianAge": "23"
      }
    },
    "title": "Architectural and engineering managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "110",
        "women": "7.4",
        "white": "6.3",
        "black": "7.6",
        "asian": "9.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "110",
        "median": "1,899",
        "maleWorkers": "101",
        "maleMedian": "1,892",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Food service managers": {
    "ageData": {
      "2015": {
        "total": "1,192",
        "16to19": "23",
        "20to24": "151",
        "25to34": "321",
        "35to44": "253",
        "45to54": "257",
        "55to64": "138",
        "65+": "49",
        "medianAge": "138"
      }
    },
    "title": "Food service managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,192",
        "women": "47.1",
        "white": "11.1",
        "black": "10.6",
        "asian": "17.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "763",
        "median": "742",
        "maleWorkers": "389",
        "maleMedian": "820",
        "femaleWorkers": "374",
        "femaleMedian": "680"
      }
    }
  },
  "Funeral service managers": {
    "ageData": {
      "2015": {
        "total": "15",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "4",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Funeral service managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "13",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Gaming managers": {
    "ageData": {
      "2015": {
        "total": "23",
        "16to19": "0",
        "20to24": "1",
        "25to34": "8",
        "35to44": "7",
        "45to54": "3",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Gaming managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "19",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Lodging managers": {
    "ageData": {
      "2015": {
        "total": "159",
        "16to19": "1",
        "20to24": "9",
        "25to34": "31",
        "35to44": "36",
        "45to54": "39",
        "55to64": "25",
        "65+": "19",
        "medianAge": "25"
      }
    },
    "title": "Lodging managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "159",
        "women": "53.5",
        "white": "7.2",
        "black": "10.9",
        "asian": "16.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "123",
        "median": "985",
        "maleWorkers": "54",
        "maleMedian": "1,171",
        "femaleWorkers": "68",
        "femaleMedian": "902"
      }
    }
  },
  "Medical and health services managers": {
    "ageData": {
      "2015": {
        "total": "636",
        "16to19": "0",
        "20to24": "11",
        "25to34": "127",
        "35to44": "140",
        "45to54": "184",
        "55to64": "135",
        "65+": "40",
        "medianAge": "135"
      }
    },
    "title": "Medical and health services managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "636",
        "women": "73.7",
        "white": "13.1",
        "black": "5.2",
        "asian": "8.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "592",
        "median": "1,210",
        "maleWorkers": "154",
        "maleMedian": "1,422",
        "femaleWorkers": "438",
        "femaleMedian": "1,156"
      }
    }
  },
  "Natural sciences managers": {
    "ageData": {
      "2015": {
        "total": "25",
        "16to19": "0",
        "20to24": "2",
        "25to34": "5",
        "35to44": "8",
        "45to54": "6",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Natural sciences managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "24",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Postmasters and mail superintendents": {
    "ageData": {
      "2015": {
        "total": "24",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "2",
        "45to54": "12",
        "55to64": "5",
        "65+": "4",
        "medianAge": "5"
      }
    },
    "title": "Postmasters and mail superintendents",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "24",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Property, real estate, and community association managers": {
    "ageData": {
      "2015": {
        "total": "685",
        "16to19": "2",
        "20to24": "21",
        "25to34": "111",
        "35to44": "128",
        "45to54": "144",
        "55to64": "166",
        "65+": "113",
        "medianAge": "166"
      }
    },
    "title": "Property, real estate, and community association managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "685",
        "women": "50.9",
        "white": "7.6",
        "black": "3.6",
        "asian": "11.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "401",
        "median": "914",
        "maleWorkers": "171",
        "maleMedian": "1,137",
        "femaleWorkers": "230",
        "femaleMedian": "823"
      }
    }
  },
  "Social and community service managers": {
    "ageData": {
      "2015": {
        "total": "378",
        "16to19": "2",
        "20to24": "10",
        "25to34": "93",
        "35to44": "66",
        "45to54": "89",
        "55to64": "81",
        "65+": "36",
        "medianAge": "81"
      }
    },
    "title": "Social and community service managers",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "378",
        "women": "67.4",
        "white": "12.1",
        "black": "5.3",
        "asian": "9.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "305",
        "median": "1,022",
        "maleWorkers": "105",
        "maleMedian": "1,142",
        "femaleWorkers": "200",
        "femaleMedian": "965"
      }
    }
  },
  "Emergency management directors": {
    "ageData": {
      "2015": {
        "total": "10",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "3",
        "45to54": "1",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Emergency management directors",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Managers, all other": {
    "ageData": {
      "2015": {
        "total": "4,315",
        "16to19": "11",
        "20to24": "87",
        "25to34": "692",
        "35to44": "1,027",
        "45to54": "1,269",
        "55to64": "908",
        "65+": "320",
        "medianAge": "908"
      }
    },
    "title": "Managers, all other",
    "depth": 4,
    "parent": "Management occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4,315",
        "women": "34.3",
        "white": "7.2",
        "black": "5.4",
        "asian": "10.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,803",
        "median": "1,408",
        "maleWorkers": "1,717",
        "maleMedian": "1,525",
        "femaleWorkers": "1,085",
        "femaleMedian": "1,213"
      }
    }
  },
  "Business and financial operations occupations": {
    "ageData": {
      "2015": {
        "total": "7,114",
        "16to19": "25",
        "20to24": "396",
        "25to34": "1,788",
        "35to44": "1,595",
        "45to54": "1,636",
        "55to64": "1,245",
        "65+": "430",
        "medianAge": "1,245"
      }
    },
    "title": "Business and financial operations occupations",
    "depth": 3,
    "parent": "Management, business, and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "7,114",
        "women": "54.3",
        "white": "10.3",
        "black": "7.9",
        "asian": "8.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5,942",
        "median": "1,137",
        "maleWorkers": "2,686",
        "maleMedian": "1,327",
        "femaleWorkers": "3,256",
        "femaleMedian": "1,004"
      }
    }
  },
  "Agents and business managers of artists, performers, and athletes": {
    "ageData": {
      "2015": {
        "total": "46",
        "16to19": "1",
        "20to24": "7",
        "25to34": "14",
        "35to44": "8",
        "45to54": "9",
        "55to64": "3",
        "65+": "3",
        "medianAge": "3"
      }
    },
    "title": "Agents and business managers of artists, performers, and athletes",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "46",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "27",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "14",
        "femaleMedian": "-"
      }
    }
  },
  "Buyers and purchasing agents, farm products": {
    "ageData": {
      "2015": {
        "total": "10",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "0",
        "45to54": "1",
        "55to64": "4",
        "65+": "2",
        "medianAge": "4"
      }
    },
    "title": "Buyers and purchasing agents, farm products",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Wholesale and retail buyers, except farm products": {
    "ageData": {
      "2015": {
        "total": "190",
        "16to19": "2",
        "20to24": "18",
        "25to34": "45",
        "35to44": "32",
        "45to54": "37",
        "55to64": "43",
        "65+": "13",
        "medianAge": "43"
      }
    },
    "title": "Wholesale and retail buyers, except farm products",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "190",
        "women": "52.7",
        "white": "6.3",
        "black": "7.5",
        "asian": "11.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "142",
        "median": "926",
        "maleWorkers": "73",
        "maleMedian": "886",
        "femaleWorkers": "69",
        "femaleMedian": "985"
      }
    }
  },
  "Purchasing agents, except wholesale, retail, and farm products": {
    "ageData": {
      "2015": {
        "total": "280",
        "16to19": "0",
        "20to24": "16",
        "25to34": "51",
        "35to44": "63",
        "45to54": "71",
        "55to64": "59",
        "65+": "20",
        "medianAge": "59"
      }
    },
    "title": "Purchasing agents, except wholesale, retail, and farm products",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "280",
        "women": "49.7",
        "white": "6.7",
        "black": "5.8",
        "asian": "11.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "260",
        "median": "1,009",
        "maleWorkers": "136",
        "maleMedian": "1,020",
        "femaleWorkers": "124",
        "femaleMedian": "986"
      }
    }
  },
  "Claims adjusters, appraisers, examiners, and investigators": {
    "ageData": {
      "2015": {
        "total": "321",
        "16to19": "1",
        "20to24": "11",
        "25to34": "89",
        "35to44": "80",
        "45to54": "81",
        "55to64": "48",
        "65+": "11",
        "medianAge": "48"
      }
    },
    "title": "Claims adjusters, appraisers, examiners, and investigators",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "321",
        "women": "55.3",
        "white": "14.6",
        "black": "3.1",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "317",
        "median": "963",
        "maleWorkers": "141",
        "maleMedian": "1,134",
        "femaleWorkers": "176",
        "femaleMedian": "824"
      }
    }
  },
  "Compliance officers": {
    "ageData": {
      "2015": {
        "total": "246",
        "16to19": "2",
        "20to24": "6",
        "25to34": "45",
        "35to44": "59",
        "45to54": "63",
        "55to64": "58",
        "65+": "13",
        "medianAge": "58"
      }
    },
    "title": "Compliance officers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "246",
        "women": "49.0",
        "white": "11.4",
        "black": "4.2",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "235",
        "median": "1,198",
        "maleWorkers": "126",
        "maleMedian": "1,375",
        "femaleWorkers": "109",
        "femaleMedian": "1,025"
      }
    }
  },
  "Cost estimators": {
    "ageData": {
      "2015": {
        "total": "112",
        "16to19": "0",
        "20to24": "5",
        "25to34": "21",
        "35to44": "23",
        "45to54": "25",
        "55to64": "28",
        "65+": "10",
        "medianAge": "28"
      }
    },
    "title": "Cost estimators",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "112",
        "women": "17.8",
        "white": "0.4",
        "black": "3.0",
        "asian": "8.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "95",
        "median": "1,232",
        "maleWorkers": "83",
        "maleMedian": "1,264",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Human resources workers": {
    "ageData": {
      "2015": {
        "total": "662",
        "16to19": "4",
        "20to24": "42",
        "25to34": "193",
        "35to44": "160",
        "45to54": "152",
        "55to64": "88",
        "65+": "23",
        "medianAge": "88"
      }
    },
    "title": "Human resources workers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "662",
        "women": "74.0",
        "white": "15.4",
        "black": "4.9",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "592",
        "median": "1,002",
        "maleWorkers": "151",
        "maleMedian": "1,158",
        "femaleWorkers": "441",
        "femaleMedian": "984"
      }
    }
  },
  "Compensation, benefits, and job analysis specialists": {
    "ageData": {
      "2015": {
        "total": "68",
        "16to19": "0",
        "20to24": "3",
        "25to34": "13",
        "35to44": "14",
        "45to54": "22",
        "55to64": "15",
        "65+": "2",
        "medianAge": "15"
      }
    },
    "title": "Compensation, benefits, and job analysis specialists",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "68",
        "women": "73.0",
        "white": "14.1",
        "black": "6.9",
        "asian": "8.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "63",
        "median": "998",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "50",
        "femaleMedian": "898"
      }
    }
  },
  "Training and development specialists": {
    "ageData": {
      "2015": {
        "total": "118",
        "16to19": "1",
        "20to24": "9",
        "25to34": "29",
        "35to44": "22",
        "45to54": "30",
        "55to64": "24",
        "65+": "4",
        "medianAge": "24"
      }
    },
    "title": "Training and development specialists",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "118",
        "women": "62.1",
        "white": "13.7",
        "black": "2.0",
        "asian": "7.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "107",
        "median": "990",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "65",
        "femaleMedian": "1,037"
      }
    }
  },
  "Logisticians": {
    "ageData": {
      "2015": {
        "total": "117",
        "16to19": "1",
        "20to24": "14",
        "25to34": "34",
        "35to44": "28",
        "45to54": "21",
        "55to64": "18",
        "65+": "2",
        "medianAge": "18"
      }
    },
    "title": "Logisticians",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "117",
        "women": "40.9",
        "white": "14.4",
        "black": "4.2",
        "asian": "20.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "111",
        "median": "1,028",
        "maleWorkers": "66",
        "maleMedian": "1,075",
        "femaleWorkers": "44",
        "femaleMedian": "-"
      }
    }
  },
  "Management analysts": {
    "ageData": {
      "2015": {
        "total": "848",
        "16to19": "2",
        "20to24": "27",
        "25to34": "162",
        "35to44": "187",
        "45to54": "215",
        "55to64": "168",
        "65+": "86",
        "medianAge": "168"
      }
    },
    "title": "Management analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "848",
        "women": "39.7",
        "white": "9.3",
        "black": "10.1",
        "asian": "5.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "529",
        "median": "1,431",
        "maleWorkers": "291",
        "maleMedian": "1,519",
        "femaleWorkers": "237",
        "femaleMedian": "1,348"
      }
    }
  },
  "Meeting, convention, and event planners": {
    "ageData": {
      "2015": {
        "total": "159",
        "16to19": "4",
        "20to24": "28",
        "25to34": "52",
        "35to44": "26",
        "45to54": "21",
        "55to64": "22",
        "65+": "5",
        "medianAge": "22"
      }
    },
    "title": "Meeting, convention, and event planners",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "159",
        "women": "78.6",
        "white": "11.1",
        "black": "5.6",
        "asian": "12.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "117",
        "median": "859",
        "maleWorkers": "27",
        "maleMedian": "-",
        "femaleWorkers": "90",
        "femaleMedian": "840"
      }
    }
  },
  "Fundraisers": {
    "ageData": {
      "2015": {
        "total": "77",
        "16to19": "0",
        "20to24": "8",
        "25to34": "19",
        "35to44": "11",
        "45to54": "20",
        "55to64": "13",
        "65+": "4",
        "medianAge": "13"
      }
    },
    "title": "Fundraisers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "77",
        "women": "73.4",
        "white": "7.2",
        "black": "1.1",
        "asian": "1.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "62",
        "median": "1,136",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "48",
        "femaleMedian": "-"
      }
    }
  },
  "Market research analysts and marketing specialists": {
    "ageData": {
      "2015": {
        "total": "261",
        "16to19": "1",
        "20to24": "27",
        "25to34": "83",
        "35to44": "56",
        "45to54": "59",
        "55to64": "25",
        "65+": "9",
        "medianAge": "25"
      }
    },
    "title": "Market research analysts and marketing specialists",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "261",
        "women": "58.8",
        "white": "4.8",
        "black": "6.9",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "203",
        "median": "1,284",
        "maleWorkers": "85",
        "maleMedian": "1,411",
        "femaleWorkers": "118",
        "femaleMedian": "1,239"
      }
    }
  },
  "Business operations specialists, all other": {
    "ageData": {
      "2015": {
        "total": "213",
        "16to19": "1",
        "20to24": "10",
        "25to34": "46",
        "35to44": "53",
        "45to54": "54",
        "55to64": "42",
        "65+": "7",
        "medianAge": "42"
      }
    },
    "title": "Business operations specialists, all other",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "213",
        "women": "56.7",
        "white": "9.2",
        "black": "7.0",
        "asian": "9.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "186",
        "median": "1,090",
        "maleWorkers": "74",
        "maleMedian": "1,461",
        "femaleWorkers": "112",
        "femaleMedian": "969"
      }
    }
  },
  "Accountants and auditors": {
    "ageData": {
      "2015": {
        "total": "1,732",
        "16to19": "1",
        "20to24": "79",
        "25to34": "450",
        "35to44": "388",
        "45to54": "397",
        "55to64": "302",
        "65+": "115",
        "medianAge": "302"
      }
    },
    "title": "Accountants and auditors",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,732",
        "women": "59.7",
        "white": "9.5",
        "black": "11.3",
        "asian": "7.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,464",
        "median": "1,132",
        "maleWorkers": "618",
        "maleMedian": "1,345",
        "femaleWorkers": "846",
        "femaleMedian": "988"
      }
    }
  },
  "Appraisers and assessors of real estate": {
    "ageData": {
      "2015": {
        "total": "76",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "18",
        "45to54": "21",
        "55to64": "23",
        "65+": "8",
        "medianAge": "23"
      }
    },
    "title": "Appraisers and assessors of real estate",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "76",
        "women": "39.3",
        "white": "5.9",
        "black": "0.9",
        "asian": "3.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Budget analysts": {
    "ageData": {
      "2015": {
        "total": "44",
        "16to19": "0",
        "20to24": "1",
        "25to34": "9",
        "35to44": "8",
        "45to54": "10",
        "55to64": "12",
        "65+": "4",
        "medianAge": "12"
      }
    },
    "title": "Budget analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Credit analysts": {
    "ageData": {
      "2015": {
        "total": "21",
        "16to19": "0",
        "20to24": "2",
        "25to34": "5",
        "35to44": "6",
        "45to54": "4",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Credit analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Financial analysts": {
    "ageData": {
      "2015": {
        "total": "322",
        "16to19": "1",
        "20to24": "25",
        "25to34": "114",
        "35to44": "80",
        "45to54": "54",
        "55to64": "37",
        "65+": "10",
        "medianAge": "37"
      }
    },
    "title": "Financial analysts",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "322",
        "women": "43.0",
        "white": "11.1",
        "black": "16.2",
        "asian": "6.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "295",
        "median": "1,426",
        "maleWorkers": "168",
        "maleMedian": "1,680",
        "femaleWorkers": "127",
        "femaleMedian": "1,171"
      }
    }
  },
  "Personal financial advisors": {
    "ageData": {
      "2015": {
        "total": "498",
        "16to19": "1",
        "20to24": "23",
        "25to34": "136",
        "35to44": "119",
        "45to54": "99",
        "55to64": "87",
        "65+": "34",
        "medianAge": "87"
      }
    },
    "title": "Personal financial advisors",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "498",
        "women": "37.9",
        "white": "7.6",
        "black": "7.4",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "407",
        "median": "1,419",
        "maleWorkers": "248",
        "maleMedian": "1,738",
        "femaleWorkers": "159",
        "femaleMedian": "1,033"
      }
    }
  },
  "Insurance underwriters": {
    "ageData": {
      "2015": {
        "total": "107",
        "16to19": "0",
        "20to24": "4",
        "25to34": "26",
        "35to44": "22",
        "45to54": "26",
        "55to64": "27",
        "65+": "2",
        "medianAge": "27"
      }
    },
    "title": "Insurance underwriters",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "107",
        "women": "58.6",
        "white": "8.9",
        "black": "5.8",
        "asian": "5.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "106",
        "median": "1,149",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "63",
        "femaleMedian": "956"
      }
    }
  },
  "Financial examiners": {
    "ageData": {
      "2015": {
        "total": "15",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "4",
        "45to54": "6",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Financial examiners",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Credit counselors and loan officers": {
    "ageData": {
      "2015": {
        "total": "332",
        "16to19": "2",
        "20to24": "14",
        "25to34": "88",
        "35to44": "85",
        "45to54": "92",
        "55to64": "43",
        "65+": "9",
        "medianAge": "43"
      }
    },
    "title": "Credit counselors and loan officers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "332",
        "women": "54.6",
        "white": "14.0",
        "black": "6.0",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "313",
        "median": "997",
        "maleWorkers": "146",
        "maleMedian": "1,186",
        "femaleWorkers": "166",
        "femaleMedian": "906"
      }
    }
  },
  "Tax examiners and collectors, and revenue agents": {
    "ageData": {
      "2015": {
        "total": "58",
        "16to19": "0",
        "20to24": "0",
        "25to34": "16",
        "35to44": "7",
        "45to54": "15",
        "55to64": "15",
        "65+": "5",
        "medianAge": "15"
      }
    },
    "title": "Tax examiners and collectors, and revenue agents",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "58",
        "women": "65.5",
        "white": "17.0",
        "black": "9.4",
        "asian": "13.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "59",
        "median": "1,051",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Tax preparers": {
    "ageData": {
      "2015": {
        "total": "109",
        "16to19": "1",
        "20to24": "9",
        "25to34": "21",
        "35to44": "19",
        "45to54": "15",
        "55to64": "23",
        "65+": "20",
        "medianAge": "23"
      }
    },
    "title": "Tax preparers",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "109",
        "women": "61.4",
        "white": "14.4",
        "black": "4.7",
        "asian": "18.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "56",
        "median": "892",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "37",
        "femaleMedian": "-"
      }
    }
  },
  "Financial specialists, all other": {
    "ageData": {
      "2015": {
        "total": "71",
        "16to19": "0",
        "20to24": "7",
        "25to34": "17",
        "35to44": "17",
        "45to54": "13",
        "55to64": "11",
        "65+": "6",
        "medianAge": "11"
      }
    },
    "title": "Financial specialists, all other",
    "depth": 4,
    "parent": "Business and financial operations occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "71",
        "women": "54.6",
        "white": "6.7",
        "black": "8.5",
        "asian": "7.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "66",
        "median": "1,162",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "40",
        "femaleMedian": "-"
      }
    }
  },
  "Professional and related occupations": {
    "ageData": {
      "2015": {
        "total": "33,852",
        "16to19": "299",
        "20to24": "2,143",
        "25to34": "8,366",
        "35to44": "7,986",
        "45to54": "7,390",
        "55to64": "5,695",
        "65+": "1,973",
        "medianAge": "5,695"
      }
    },
    "title": "Professional and related occupations",
    "depth": 2,
    "parent": "Management, professional, and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "33,852",
        "women": "57.2",
        "white": "9.8",
        "black": "8.7",
        "asian": "8.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "26,423",
        "median": "1,112",
        "maleWorkers": "11,789",
        "maleMedian": "1,343",
        "femaleWorkers": "14,634",
        "femaleMedian": "963"
      }
    }
  },
  "Computer and mathematical occupations": {
    "ageData": {
      "2015": {
        "total": "4,369",
        "16to19": "20",
        "20to24": "266",
        "25to34": "1,234",
        "35to44": "1,224",
        "45to54": "951",
        "55to64": "565",
        "65+": "109",
        "medianAge": "565"
      }
    },
    "title": "Computer and mathematical occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4,369",
        "women": "24.7",
        "white": "8.6",
        "black": "19.9",
        "asian": "6.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4,009",
        "median": "1,428",
        "maleWorkers": "3,036",
        "maleMedian": "1,503",
        "femaleWorkers": "973",
        "femaleMedian": "1,245"
      }
    }
  },
  "Computer and information research scientists": {
    "ageData": {
      "2015": {
        "total": "24",
        "16to19": "0",
        "20to24": "1",
        "25to34": "7",
        "35to44": "8",
        "45to54": "4",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Computer and information research scientists",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "24",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Computer systems analysts": {
    "ageData": {
      "2015": {
        "total": "552",
        "16to19": "1",
        "20to24": "26",
        "25to34": "142",
        "35to44": "160",
        "45to54": "125",
        "55to64": "82",
        "65+": "17",
        "medianAge": "82"
      }
    },
    "title": "Computer systems analysts",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "552",
        "women": "34.2",
        "white": "9.6",
        "black": "19.6",
        "asian": "6.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "499",
        "median": "1,389",
        "maleWorkers": "325",
        "maleMedian": "1,462",
        "femaleWorkers": "173",
        "femaleMedian": "1,256"
      }
    }
  },
  "Information security analysts": {
    "ageData": {
      "2015": {
        "total": "70",
        "16to19": "0",
        "20to24": "2",
        "25to34": "17",
        "35to44": "19",
        "45to54": "16",
        "55to64": "12",
        "65+": "4",
        "medianAge": "12"
      }
    },
    "title": "Information security analysts",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "70",
        "women": "19.7",
        "white": "3.0",
        "black": "3.4",
        "asian": "5.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "67",
        "median": "1,538",
        "maleWorkers": "56",
        "maleMedian": "1,562",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Computer programmers": {
    "ageData": {
      "2015": {
        "total": "480",
        "16to19": "2",
        "20to24": "28",
        "25to34": "108",
        "35to44": "127",
        "45to54": "123",
        "55to64": "77",
        "65+": "15",
        "medianAge": "77"
      }
    },
    "title": "Computer programmers",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "480",
        "women": "21.0",
        "white": "7.0",
        "black": "18.9",
        "asian": "6.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "450",
        "median": "1,438",
        "maleWorkers": "357",
        "maleMedian": "1,501",
        "femaleWorkers": "93",
        "femaleMedian": "1,302"
      }
    }
  },
  "Software developers, applications and systems software": {
    "ageData": {
      "2015": {
        "total": "1,353",
        "16to19": "1",
        "20to24": "74",
        "25to34": "438",
        "35to44": "387",
        "45to54": "280",
        "55to64": "148",
        "65+": "25",
        "medianAge": "148"
      }
    },
    "title": "Software developers, applications and systems software",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,353",
        "women": "17.9",
        "white": "5.0",
        "black": "33.8",
        "asian": "5.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,287",
        "median": "1,682",
        "maleWorkers": "1,054",
        "maleMedian": "1,751",
        "femaleWorkers": "232",
        "femaleMedian": "1,415"
      }
    }
  },
  "Web developers": {
    "ageData": {
      "2015": {
        "total": "204",
        "16to19": "3",
        "20to24": "29",
        "25to34": "73",
        "35to44": "57",
        "45to54": "28",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Web developers",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "204",
        "women": "34.3",
        "white": "9.1",
        "black": "9.6",
        "asian": "6.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "151",
        "median": "1,165",
        "maleWorkers": "98",
        "maleMedian": "1,233",
        "femaleWorkers": "53",
        "femaleMedian": "1,026"
      }
    }
  },
  "Computer support specialists": {
    "ageData": {
      "2015": {
        "total": "475",
        "16to19": "6",
        "20to24": "40",
        "25to34": "129",
        "35to44": "122",
        "45to54": "96",
        "55to64": "71",
        "65+": "12",
        "medianAge": "71"
      }
    },
    "title": "Computer support specialists",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "475",
        "women": "26.4",
        "white": "12.5",
        "black": "9.6",
        "asian": "8.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "396",
        "median": "1,079",
        "maleWorkers": "291",
        "maleMedian": "1,135",
        "femaleWorkers": "105",
        "femaleMedian": "908"
      }
    }
  },
  "Database administrators": {
    "ageData": {
      "2015": {
        "total": "93",
        "16to19": "0",
        "20to24": "1",
        "25to34": "17",
        "35to44": "20",
        "45to54": "31",
        "55to64": "20",
        "65+": "4",
        "medianAge": "20"
      }
    },
    "title": "Database administrators",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "93",
        "women": "38.0",
        "white": "6.2",
        "black": "9.6",
        "asian": "2.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "90",
        "median": "1,536",
        "maleWorkers": "58",
        "maleMedian": "1,829",
        "femaleWorkers": "32",
        "femaleMedian": "-"
      }
    }
  },
  "Network and computer systems administrators": {
    "ageData": {
      "2015": {
        "total": "218",
        "16to19": "0",
        "20to24": "8",
        "25to34": "64",
        "35to44": "65",
        "45to54": "55",
        "55to64": "23",
        "65+": "3",
        "medianAge": "23"
      }
    },
    "title": "Network and computer systems administrators",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "218",
        "women": "15.9",
        "white": "11.5",
        "black": "10.4",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "208",
        "median": "1,242",
        "maleWorkers": "179",
        "maleMedian": "1,266",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Computer network architects": {
    "ageData": {
      "2015": {
        "total": "114",
        "16to19": "0",
        "20to24": "1",
        "25to34": "24",
        "35to44": "45",
        "45to54": "28",
        "55to64": "10",
        "65+": "6",
        "medianAge": "10"
      }
    },
    "title": "Computer network architects",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "114",
        "women": "12.1",
        "white": "8.9",
        "black": "16.5",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "115",
        "median": "1,552",
        "maleWorkers": "100",
        "maleMedian": "1,577",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Computer occupations, all other": {
    "ageData": {
      "2015": {
        "total": "547",
        "16to19": "8",
        "20to24": "42",
        "25to34": "141",
        "35to44": "148",
        "45to54": "121",
        "55to64": "77",
        "65+": "12",
        "medianAge": "77"
      }
    },
    "title": "Computer occupations, all other",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "547",
        "women": "24.3",
        "white": "11.8",
        "black": "12.0",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "490",
        "median": "1,227",
        "maleWorkers": "374",
        "maleMedian": "1,252",
        "femaleWorkers": "116",
        "femaleMedian": "1,145"
      }
    }
  },
  "Actuaries": {
    "ageData": {
      "2015": {
        "total": "21",
        "16to19": "0",
        "20to24": "0",
        "25to34": "9",
        "35to44": "5",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Actuaries",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "24",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Mathematicians": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "5",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Mathematicians",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Operations research analysts": {
    "ageData": {
      "2015": {
        "total": "123",
        "16to19": "0",
        "20to24": "4",
        "25to34": "34",
        "35to44": "39",
        "45to54": "23",
        "55to64": "18",
        "65+": "5",
        "medianAge": "18"
      }
    },
    "title": "Operations research analysts",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "123",
        "women": "50.7",
        "white": "15.3",
        "black": "10.2",
        "asian": "9.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "122",
        "median": "1,441",
        "maleWorkers": "59",
        "maleMedian": "1,574",
        "femaleWorkers": "63",
        "femaleMedian": "1,325"
      }
    }
  },
  "Statisticians": {
    "ageData": {
      "2015": {
        "total": "86",
        "16to19": "0",
        "20to24": "9",
        "25to34": "30",
        "35to44": "23",
        "45to54": "13",
        "55to64": "9",
        "65+": "3",
        "medianAge": "9"
      }
    },
    "title": "Statisticians",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "86",
        "women": "52.9",
        "white": "12.4",
        "black": "11.4",
        "asian": "3.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "76",
        "median": "1,275",
        "maleWorkers": "37",
        "maleMedian": "-",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous mathematical science occupations": {
    "ageData": {
      "2015": {
        "total": "4",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Miscellaneous mathematical science occupations",
    "depth": 4,
    "parent": "Computer and mathematical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Architecture and engineering occupations": {
    "ageData": {
      "2015": {
        "total": "2,954",
        "16to19": "15",
        "20to24": "189",
        "25to34": "719",
        "35to44": "636",
        "45to54": "708",
        "55to64": "535",
        "65+": "153",
        "medianAge": "535"
      }
    },
    "title": "Architecture and engineering occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,954",
        "women": "15.1",
        "white": "6.0",
        "black": "11.4",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,656",
        "median": "1,424",
        "maleWorkers": "2,272",
        "maleMedian": "1,452",
        "femaleWorkers": "383",
        "femaleMedian": "1,257"
      }
    }
  },
  "Architects, except naval": {
    "ageData": {
      "2015": {
        "total": "203",
        "16to19": "2",
        "20to24": "3",
        "25to34": "51",
        "35to44": "43",
        "45to54": "51",
        "55to64": "34",
        "65+": "19",
        "medianAge": "34"
      }
    },
    "title": "Architects, except naval",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "203",
        "women": "25.7",
        "white": "5.8",
        "black": "7.6",
        "asian": "5.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "138",
        "median": "1,441",
        "maleWorkers": "106",
        "maleMedian": "1,492",
        "femaleWorkers": "31",
        "femaleMedian": "-"
      }
    }
  },
  "Surveyors, cartographers, and photogrammetrists": {
    "ageData": {
      "2015": {
        "total": "38",
        "16to19": "0",
        "20to24": "2",
        "25to34": "7",
        "35to44": "10",
        "45to54": "7",
        "55to64": "10",
        "65+": "2",
        "medianAge": "10"
      }
    },
    "title": "Surveyors, cartographers, and photogrammetrists",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Aerospace engineers": {
    "ageData": {
      "2015": {
        "total": "138",
        "16to19": "0",
        "20to24": "7",
        "25to34": "33",
        "35to44": "22",
        "45to54": "35",
        "55to64": "33",
        "65+": "7",
        "medianAge": "33"
      }
    },
    "title": "Aerospace engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "138",
        "women": "11.3",
        "white": "2.1",
        "black": "18.6",
        "asian": "13.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "140",
        "median": "1,662",
        "maleWorkers": "122",
        "maleMedian": "1,668",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Agricultural engineers": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "2",
        "45to54": "0",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Agricultural engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Biomedical engineers": {
    "ageData": {
      "2015": {
        "total": "16",
        "16to19": "0",
        "20to24": "1",
        "25to34": "6",
        "35to44": "2",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Biomedical engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Chemical engineers": {
    "ageData": {
      "2015": {
        "total": "84",
        "16to19": "0",
        "20to24": "7",
        "25to34": "23",
        "35to44": "19",
        "45to54": "17",
        "55to64": "14",
        "65+": "4",
        "medianAge": "14"
      }
    },
    "title": "Chemical engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "84",
        "women": "14.7",
        "white": "2.8",
        "black": "16.3",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "79",
        "median": "1,532",
        "maleWorkers": "69",
        "maleMedian": "1,583",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Civil engineers": {
    "ageData": {
      "2015": {
        "total": "360",
        "16to19": "0",
        "20to24": "26",
        "25to34": "100",
        "35to44": "64",
        "45to54": "87",
        "55to64": "56",
        "65+": "27",
        "medianAge": "56"
      }
    },
    "title": "Civil engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "360",
        "women": "12.6",
        "white": "3.6",
        "black": "10.2",
        "asian": "9.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "316",
        "median": "1,460",
        "maleWorkers": "275",
        "maleMedian": "1,474",
        "femaleWorkers": "41",
        "femaleMedian": "-"
      }
    }
  },
  "Computer hardware engineers": {
    "ageData": {
      "2015": {
        "total": "72",
        "16to19": "0",
        "20to24": "2",
        "25to34": "11",
        "35to44": "19",
        "45to54": "23",
        "55to64": "14",
        "65+": "2",
        "medianAge": "14"
      }
    },
    "title": "Computer hardware engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "72",
        "women": "12.8",
        "white": "12.1",
        "black": "23.4",
        "asian": "11.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "72",
        "median": "1,876",
        "maleWorkers": "62",
        "maleMedian": "1,871",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical and electronics engineers": {
    "ageData": {
      "2015": {
        "total": "302",
        "16to19": "1",
        "20to24": "8",
        "25to34": "61",
        "35to44": "66",
        "45to54": "88",
        "55to64": "60",
        "65+": "16",
        "medianAge": "60"
      }
    },
    "title": "Electrical and electronics engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "302",
        "women": "12.5",
        "white": "6.0",
        "black": "14.3",
        "asian": "7.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "283",
        "median": "1,778",
        "maleWorkers": "246",
        "maleMedian": "1,819",
        "femaleWorkers": "37",
        "femaleMedian": "-"
      }
    }
  },
  "Environmental engineers": {
    "ageData": {
      "2015": {
        "total": "40",
        "16to19": "1",
        "20to24": "2",
        "25to34": "14",
        "35to44": "11",
        "45to54": "5",
        "55to64": "6",
        "65+": "2",
        "medianAge": "6"
      }
    },
    "title": "Environmental engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "40",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "26",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial engineers, including health and safety": {
    "ageData": {
      "2015": {
        "total": "214",
        "16to19": "0",
        "20to24": "14",
        "25to34": "58",
        "35to44": "44",
        "45to54": "48",
        "55to64": "41",
        "65+": "8",
        "medianAge": "41"
      }
    },
    "title": "Industrial engineers, including health and safety",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "214",
        "women": "20.2",
        "white": "4.2",
        "black": "8.9",
        "asian": "7.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "205",
        "median": "1,447",
        "maleWorkers": "168",
        "maleMedian": "1,430",
        "femaleWorkers": "37",
        "femaleMedian": "-"
      }
    }
  },
  "Marine engineers and naval architects": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "4",
        "45to54": "2",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Marine engineers and naval architects",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Materials engineers": {
    "ageData": {
      "2015": {
        "total": "40",
        "16to19": "0",
        "20to24": "3",
        "25to34": "12",
        "35to44": "7",
        "45to54": "6",
        "55to64": "8",
        "65+": "2",
        "medianAge": "8"
      }
    },
    "title": "Materials engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "40",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "36",
        "median": "-",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Mechanical engineers": {
    "ageData": {
      "2015": {
        "total": "323",
        "16to19": "0",
        "20to24": "22",
        "25to34": "96",
        "35to44": "75",
        "45to54": "74",
        "55to64": "44",
        "65+": "12",
        "medianAge": "44"
      }
    },
    "title": "Mechanical engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "323",
        "women": "8.3",
        "white": "6.2",
        "black": "11.2",
        "asian": "5.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "316",
        "median": "1,534",
        "maleWorkers": "294",
        "maleMedian": "1,550",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Mining and geological engineers, including mining safety engineers": {
    "ageData": {
      "2015": {
        "total": "15",
        "16to19": "0",
        "20to24": "1",
        "25to34": "7",
        "35to44": "2",
        "45to54": "2",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Mining and geological engineers, including mining safety engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Nuclear engineers": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "1",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Nuclear engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Petroleum engineers": {
    "ageData": {
      "2015": {
        "total": "44",
        "16to19": "0",
        "20to24": "4",
        "25to34": "13",
        "35to44": "12",
        "45to54": "7",
        "55to64": "9",
        "65+": "1",
        "medianAge": "9"
      }
    },
    "title": "Petroleum engineers",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "43",
        "median": "-",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Engineers, all other": {
    "ageData": {
      "2015": {
        "total": "440",
        "16to19": "1",
        "20to24": "20",
        "25to34": "95",
        "35to44": "101",
        "45to54": "108",
        "55to64": "91",
        "65+": "23",
        "medianAge": "91"
      }
    },
    "title": "Engineers, all other",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "440",
        "women": "13.6",
        "white": "7.6",
        "black": "14.7",
        "asian": "5.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "393",
        "median": "1,527",
        "maleWorkers": "339",
        "maleMedian": "1,537",
        "femaleWorkers": "54",
        "femaleMedian": "1,448"
      }
    }
  },
  "Drafters": {
    "ageData": {
      "2015": {
        "total": "133",
        "16to19": "1",
        "20to24": "12",
        "25to34": "37",
        "35to44": "27",
        "45to54": "31",
        "55to64": "19",
        "65+": "6",
        "medianAge": "19"
      }
    },
    "title": "Drafters",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "133",
        "women": "21.2",
        "white": "3.7",
        "black": "1.1",
        "asian": "15.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "114",
        "median": "977",
        "maleWorkers": "91",
        "maleMedian": "977",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Engineering technicians, except drafters": {
    "ageData": {
      "2015": {
        "total": "403",
        "16to19": "8",
        "20to24": "49",
        "25to34": "72",
        "35to44": "91",
        "45to54": "97",
        "55to64": "75",
        "65+": "11",
        "medianAge": "75"
      }
    },
    "title": "Engineering technicians, except drafters",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "403",
        "women": "20.3",
        "white": "10.0",
        "black": "10.7",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "352",
        "median": "963",
        "maleWorkers": "284",
        "maleMedian": "984",
        "femaleWorkers": "68",
        "femaleMedian": "827"
      }
    }
  },
  "Surveying and mapping technicians": {
    "ageData": {
      "2015": {
        "total": "65",
        "16to19": "1",
        "20to24": "6",
        "25to34": "17",
        "35to44": "13",
        "45to54": "13",
        "55to64": "8",
        "65+": "7",
        "medianAge": "8"
      }
    },
    "title": "Surveying and mapping technicians",
    "depth": 4,
    "parent": "Architecture and engineering occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "65",
        "women": "5.2",
        "white": "3.5",
        "black": "4.1",
        "asian": "7.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "58",
        "median": "1,012",
        "maleWorkers": "54",
        "maleMedian": "1,031",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Life, physical, and social science occupations": {
    "ageData": {
      "2015": {
        "total": "1,404",
        "16to19": "11",
        "20to24": "118",
        "25to34": "358",
        "35to44": "331",
        "45to54": "267",
        "55to64": "226",
        "65+": "94",
        "medianAge": "226"
      }
    },
    "title": "Life, physical, and social science occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,404",
        "women": "46.6",
        "white": "6.1",
        "black": "14.5",
        "asian": "7.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,176",
        "median": "1,206",
        "maleWorkers": "662",
        "maleMedian": "1,379",
        "femaleWorkers": "514",
        "femaleMedian": "1,067"
      }
    }
  },
  "Agricultural and food scientists": {
    "ageData": {
      "2015": {
        "total": "25",
        "16to19": "0",
        "20to24": "2",
        "25to34": "7",
        "35to44": "4",
        "45to54": "7",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Agricultural and food scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Biological scientists": {
    "ageData": {
      "2015": {
        "total": "86",
        "16to19": "0",
        "20to24": "9",
        "25to34": "19",
        "35to44": "22",
        "45to54": "13",
        "55to64": "20",
        "65+": "3",
        "medianAge": "20"
      }
    },
    "title": "Biological scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "86",
        "women": "42.6",
        "white": "6.6",
        "black": "10.8",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "74",
        "median": "1,233",
        "maleWorkers": "46",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Conservation scientists and foresters": {
    "ageData": {
      "2015": {
        "total": "25",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "7",
        "45to54": "5",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Conservation scientists and foresters",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Medical scientists": {
    "ageData": {
      "2015": {
        "total": "157",
        "16to19": "0",
        "20to24": "13",
        "25to34": "54",
        "35to44": "43",
        "45to54": "27",
        "55to64": "12",
        "65+": "8",
        "medianAge": "12"
      }
    },
    "title": "Medical scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "157",
        "women": "54.9",
        "white": "5.9",
        "black": "35.1",
        "asian": "5.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "151",
        "median": "1,250",
        "maleWorkers": "68",
        "maleMedian": "1,362",
        "femaleWorkers": "84",
        "femaleMedian": "1,082"
      }
    }
  },
  "Life scientists, all other": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Life scientists, all other",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Astronomers and physicists": {
    "ageData": {
      "2015": {
        "total": "19",
        "16to19": "0",
        "20to24": "1",
        "25to34": "6",
        "35to44": "2",
        "45to54": "2",
        "55to64": "4",
        "65+": "4",
        "medianAge": "4"
      }
    },
    "title": "Astronomers and physicists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "19",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Atmospheric and space scientists": {
    "ageData": {
      "2015": {
        "total": "12",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "2",
        "45to54": "3",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Atmospheric and space scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "12",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Chemists and materials scientists": {
    "ageData": {
      "2015": {
        "total": "99",
        "16to19": "0",
        "20to24": "3",
        "25to34": "23",
        "35to44": "25",
        "45to54": "19",
        "55to64": "19",
        "65+": "9",
        "medianAge": "19"
      }
    },
    "title": "Chemists and materials scientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "99",
        "women": "36.1",
        "white": "8.4",
        "black": "13.5",
        "asian": "5.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "93",
        "median": "1,432",
        "maleWorkers": "61",
        "maleMedian": "1,496",
        "femaleWorkers": "33",
        "femaleMedian": "-"
      }
    }
  },
  "Environmental scientists and geoscientists": {
    "ageData": {
      "2015": {
        "total": "92",
        "16to19": "0",
        "20to24": "4",
        "25to34": "23",
        "35to44": "17",
        "45to54": "18",
        "55to64": "23",
        "65+": "7",
        "medianAge": "23"
      }
    },
    "title": "Environmental scientists and geoscientists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "92",
        "women": "27.5",
        "white": "1.3",
        "black": "6.2",
        "asian": "7.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "90",
        "median": "1,423",
        "maleWorkers": "65",
        "maleMedian": "1,740",
        "femaleWorkers": "25",
        "femaleMedian": "-"
      }
    }
  },
  "Physical scientists, all other": {
    "ageData": {
      "2015": {
        "total": "232",
        "16to19": "0",
        "20to24": "18",
        "25to34": "62",
        "35to44": "52",
        "45to54": "51",
        "55to64": "35",
        "65+": "14",
        "medianAge": "35"
      }
    },
    "title": "Physical scientists, all other",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "232",
        "women": "41.4",
        "white": "4.4",
        "black": "23.9",
        "asian": "6.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "189",
        "median": "1,553",
        "maleWorkers": "121",
        "maleMedian": "1,770",
        "femaleWorkers": "68",
        "femaleMedian": "1,170"
      }
    }
  },
  "Economists": {
    "ageData": {
      "2015": {
        "total": "34",
        "16to19": "0",
        "20to24": "1",
        "25to34": "10",
        "35to44": "11",
        "45to54": "6",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Economists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "34",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Survey researchers": {
    "ageData": {
      "2015": {
        "total": "0",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Survey researchers",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "0",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Psychologists": {
    "ageData": {
      "2015": {
        "total": "193",
        "16to19": "0",
        "20to24": "0",
        "25to34": "42",
        "35to44": "53",
        "45to54": "33",
        "55to64": "44",
        "65+": "22",
        "medianAge": "44"
      }
    },
    "title": "Psychologists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "193",
        "women": "70.3",
        "white": "4.1",
        "black": "2.5",
        "asian": "5.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "114",
        "median": "1,367",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "83",
        "femaleMedian": "1,189"
      }
    }
  },
  "Sociologists": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Sociologists",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Urban and regional planners": {
    "ageData": {
      "2015": {
        "total": "25",
        "16to19": "0",
        "20to24": "2",
        "25to34": "4",
        "35to44": "7",
        "45to54": "3",
        "55to64": "7",
        "65+": "2",
        "medianAge": "7"
      }
    },
    "title": "Urban and regional planners",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous social scientists and related workers": {
    "ageData": {
      "2015": {
        "total": "45",
        "16to19": "0",
        "20to24": "4",
        "25to34": "9",
        "35to44": "10",
        "45to54": "12",
        "55to64": "6",
        "65+": "4",
        "medianAge": "6"
      }
    },
    "title": "Miscellaneous social scientists and related workers",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "45",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "19",
        "femaleMedian": "-"
      }
    }
  },
  "Agricultural and food science technicians": {
    "ageData": {
      "2015": {
        "total": "25",
        "16to19": "0",
        "20to24": "2",
        "25to34": "9",
        "35to44": "6",
        "45to54": "3",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Agricultural and food science technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "25",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Biological technicians": {
    "ageData": {
      "2015": {
        "total": "18",
        "16to19": "0",
        "20to24": "1",
        "25to34": "7",
        "35to44": "5",
        "45to54": "4",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Biological technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Chemical technicians": {
    "ageData": {
      "2015": {
        "total": "82",
        "16to19": "0",
        "20to24": "11",
        "25to34": "18",
        "35to44": "26",
        "45to54": "14",
        "55to64": "10",
        "65+": "3",
        "medianAge": "10"
      }
    },
    "title": "Chemical technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "82",
        "women": "40.0",
        "white": "11.7",
        "black": "7.5",
        "asian": "9.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "75",
        "median": "944",
        "maleWorkers": "43",
        "maleMedian": "-",
        "femaleWorkers": "32",
        "femaleMedian": "-"
      }
    }
  },
  "Geological and petroleum technicians": {
    "ageData": {
      "2015": {
        "total": "21",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "2",
        "45to54": "7",
        "55to64": "6",
        "65+": "2",
        "medianAge": "6"
      }
    },
    "title": "Geological and petroleum technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Nuclear technicians": {
    "ageData": {
      "2015": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "2",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Nuclear technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Social science research assistants": {
    "ageData": {
      "2015": {
        "total": "4",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "0",
        "45to54": "1",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Social science research assistants",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous life, physical, and social science technicians": {
    "ageData": {
      "2015": {
        "total": "203",
        "16to19": "9",
        "20to24": "44",
        "25to34": "53",
        "35to44": "34",
        "45to54": "36",
        "55to64": "18",
        "65+": "9",
        "medianAge": "18"
      }
    },
    "title": "Miscellaneous life, physical, and social science technicians",
    "depth": 4,
    "parent": "Life, physical, and social science occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "203",
        "women": "53.9",
        "white": "7.7",
        "black": "12.5",
        "asian": "6.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "157",
        "median": "846",
        "maleWorkers": "79",
        "maleMedian": "1,001",
        "femaleWorkers": "78",
        "femaleMedian": "780"
      }
    }
  },
  "Community and social service occupations": {
    "ageData": {
      "2015": {
        "total": "2,596",
        "16to19": "16",
        "20to24": "134",
        "25to34": "595",
        "35to44": "569",
        "45to54": "599",
        "55to64": "466",
        "65+": "216",
        "medianAge": "466"
      }
    },
    "title": "Community and social service occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,596",
        "women": "65.3",
        "white": "17.4",
        "black": "3.6",
        "asian": "10.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,143",
        "median": "889",
        "maleWorkers": "776",
        "maleMedian": "973",
        "femaleWorkers": "1,367",
        "femaleMedian": "845"
      }
    }
  },
  "Counselors": {
    "ageData": {
      "2015": {
        "total": "802",
        "16to19": "8",
        "20to24": "55",
        "25to34": "195",
        "35to44": "195",
        "45to54": "158",
        "55to64": "144",
        "65+": "47",
        "medianAge": "144"
      }
    },
    "title": "Counselors",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "802",
        "women": "71.4",
        "white": "18.4",
        "black": "2.5",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "635",
        "median": "904",
        "maleWorkers": "184",
        "maleMedian": "908",
        "femaleWorkers": "451",
        "femaleMedian": "902"
      }
    }
  },
  "Social workers": {
    "ageData": {
      "2015": {
        "total": "765",
        "16to19": "2",
        "20to24": "38",
        "25to34": "200",
        "35to44": "190",
        "45to54": "183",
        "55to64": "107",
        "65+": "45",
        "medianAge": "107"
      }
    },
    "title": "Social workers",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "765",
        "women": "83.8",
        "white": "22.0",
        "black": "3.0",
        "asian": "12.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "677",
        "median": "877",
        "maleWorkers": "127",
        "maleMedian": "943",
        "femaleWorkers": "549",
        "femaleMedian": "862"
      }
    }
  },
  "Probation officers and correctional treatment specialists": {
    "ageData": {
      "2015": {
        "total": "99",
        "16to19": "1",
        "20to24": "2",
        "25to34": "22",
        "35to44": "29",
        "45to54": "29",
        "55to64": "12",
        "65+": "4",
        "medianAge": "12"
      }
    },
    "title": "Probation officers and correctional treatment specialists",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "99",
        "women": "55.4",
        "white": "23.3",
        "black": "4.0",
        "asian": "12.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "85",
        "median": "967",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "43",
        "femaleMedian": "-"
      }
    }
  },
  "Social and human service assistants": {
    "ageData": {
      "2015": {
        "total": "194",
        "16to19": "2",
        "20to24": "12",
        "25to34": "53",
        "35to44": "38",
        "45to54": "48",
        "55to64": "33",
        "65+": "9",
        "medianAge": "33"
      }
    },
    "title": "Social and human service assistants",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "194",
        "women": "82.6",
        "white": "21.2",
        "black": "2.2",
        "asian": "16.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "173",
        "median": "676",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "149",
        "femaleMedian": "673"
      }
    }
  },
  "Miscellaneous community and social service specialists, including health educators and community health workers": {
    "ageData": {
      "2015": {
        "total": "117",
        "16to19": "0",
        "20to24": "8",
        "25to34": "37",
        "35to44": "22",
        "45to54": "25",
        "55to64": "19",
        "65+": "5",
        "medianAge": "19"
      }
    },
    "title": "Miscellaneous community and social service specialists, including health educators and community health workers",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "117",
        "women": "70.8",
        "white": "14.2",
        "black": "5.2",
        "asian": "16.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "92",
        "median": "831",
        "maleWorkers": "29",
        "maleMedian": "-",
        "femaleWorkers": "63",
        "femaleMedian": "728"
      }
    }
  },
  "Clergy": {
    "ageData": {
      "2015": {
        "total": "469",
        "16to19": "0",
        "20to24": "10",
        "25to34": "58",
        "35to44": "74",
        "45to54": "125",
        "55to64": "115",
        "65+": "87",
        "medianAge": "115"
      }
    },
    "title": "Clergy",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "469",
        "women": "20.6",
        "white": "10.2",
        "black": "6.6",
        "asian": "7.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "376",
        "median": "1,002",
        "maleWorkers": "316",
        "maleMedian": "1,021",
        "femaleWorkers": "60",
        "femaleMedian": "924"
      }
    }
  },
  "Directors, religious activities and education": {
    "ageData": {
      "2015": {
        "total": "78",
        "16to19": "0",
        "20to24": "6",
        "25to34": "21",
        "35to44": "12",
        "45to54": "15",
        "55to64": "17",
        "65+": "6",
        "medianAge": "17"
      }
    },
    "title": "Directors, religious activities and education",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "78",
        "women": "57.8",
        "white": "7.5",
        "black": "1.1",
        "asian": "5.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "62",
        "median": "929",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "31",
        "femaleMedian": "-"
      }
    }
  },
  "Religious workers, all other": {
    "ageData": {
      "2015": {
        "total": "73",
        "16to19": "3",
        "20to24": "3",
        "25to34": "9",
        "35to44": "10",
        "45to54": "16",
        "55to64": "20",
        "65+": "12",
        "medianAge": "20"
      }
    },
    "title": "Religious workers, all other",
    "depth": 4,
    "parent": "Community and social service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "73",
        "women": "59.0",
        "white": "2.3",
        "black": "5.2",
        "asian": "6.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Legal occupations": {
    "ageData": {
      "2015": {
        "total": "1,803",
        "16to19": "4",
        "20to24": "38",
        "25to34": "402",
        "35to44": "427",
        "45to54": "391",
        "55to64": "347",
        "65+": "193",
        "medianAge": "347"
      }
    },
    "title": "Legal occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,803",
        "women": "50.2",
        "white": "6.8",
        "black": "4.5",
        "asian": "7.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,346",
        "median": "1,391",
        "maleWorkers": "624",
        "maleMedian": "1,877",
        "femaleWorkers": "722",
        "femaleMedian": "1,135"
      }
    }
  },
  "Lawyers": {
    "ageData": {
      "2015": {
        "total": "1,160",
        "16to19": "0",
        "20to24": "4",
        "25to34": "246",
        "35to44": "290",
        "45to54": "256",
        "55to64": "222",
        "65+": "143",
        "medianAge": "222"
      }
    },
    "title": "Lawyers",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,160",
        "women": "34.5",
        "white": "4.6",
        "black": "4.8",
        "asian": "5.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "803",
        "median": "1,886",
        "maleWorkers": "503",
        "maleMedian": "1,914",
        "femaleWorkers": "300",
        "femaleMedian": "1,717"
      }
    }
  },
  "Judicial law clerks": {
    "ageData": {
      "2015": {
        "total": "13",
        "16to19": "0",
        "20to24": "0",
        "25to34": "10",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Judicial law clerks",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Judges, magistrates, and other judicial workers": {
    "ageData": {
      "2015": {
        "total": "58",
        "16to19": "0",
        "20to24": "0",
        "25to34": "7",
        "35to44": "6",
        "45to54": "13",
        "55to64": "18",
        "65+": "13",
        "medianAge": "18"
      }
    },
    "title": "Judges, magistrates, and other judicial workers",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "58",
        "women": "39.0",
        "white": "11.8",
        "black": "6.2",
        "asian": "6.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "54",
        "median": "1,952",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Paralegals and legal assistants": {
    "ageData": {
      "2015": {
        "total": "400",
        "16to19": "4",
        "20to24": "27",
        "25to34": "97",
        "35to44": "93",
        "45to54": "89",
        "55to64": "68",
        "65+": "24",
        "medianAge": "68"
      }
    },
    "title": "Paralegals and legal assistants",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "400",
        "women": "85.4",
        "white": "10.3",
        "black": "3.9",
        "asian": "13.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "341",
        "median": "927",
        "maleWorkers": "47",
        "maleMedian": "-",
        "femaleWorkers": "294",
        "femaleMedian": "910"
      }
    }
  },
  "Miscellaneous legal support workers": {
    "ageData": {
      "2015": {
        "total": "172",
        "16to19": "1",
        "20to24": "7",
        "25to34": "42",
        "35to44": "38",
        "45to54": "32",
        "55to64": "39",
        "65+": "13",
        "medianAge": "39"
      }
    },
    "title": "Miscellaneous legal support workers",
    "depth": 4,
    "parent": "Legal occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "172",
        "women": "76.4",
        "white": "10.9",
        "black": "4.1",
        "asian": "10.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "136",
        "median": "770",
        "maleWorkers": "40",
        "maleMedian": "-",
        "femaleWorkers": "97",
        "femaleMedian": "746"
      }
    }
  },
  "Education, training, and library occupations": {
    "ageData": {
      "2015": {
        "total": "8,908",
        "16to19": "120",
        "20to24": "664",
        "25to34": "1,981",
        "35to44": "2,074",
        "45to54": "1,965",
        "55to64": "1,545",
        "65+": "559",
        "medianAge": "1,545"
      }
    },
    "title": "Education, training, and library occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8,908",
        "women": "73.4",
        "white": "10.4",
        "black": "4.5",
        "asian": "9.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6,884",
        "median": "956",
        "maleWorkers": "1,849",
        "maleMedian": "1,144",
        "femaleWorkers": "5,034",
        "femaleMedian": "907"
      }
    }
  },
  "Postsecondary teachers": {
    "ageData": {
      "2015": {
        "total": "1,341",
        "16to19": "7",
        "20to24": "101",
        "25to34": "289",
        "35to44": "267",
        "45to54": "259",
        "55to64": "262",
        "65+": "155",
        "medianAge": "262"
      }
    },
    "title": "Postsecondary teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,341",
        "women": "46.5",
        "white": "5.1",
        "black": "12.6",
        "asian": "7.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "917",
        "median": "1,258",
        "maleWorkers": "516",
        "maleMedian": "1,405",
        "femaleWorkers": "401",
        "femaleMedian": "1,144"
      }
    }
  },
  "Preschool and kindergarten teachers": {
    "ageData": {
      "2015": {
        "total": "695",
        "16to19": "12",
        "20to24": "78",
        "25to34": "201",
        "35to44": "160",
        "45to54": "134",
        "55to64": "85",
        "65+": "25",
        "medianAge": "85"
      }
    },
    "title": "Preschool and kindergarten teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "695",
        "women": "96.8",
        "white": "16.1",
        "black": "3.4",
        "asian": "12.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "517",
        "median": "616",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "506",
        "femaleMedian": "618"
      }
    }
  },
  "Elementary and middle school teachers": {
    "ageData": {
      "2015": {
        "total": "3,152",
        "16to19": "11",
        "20to24": "147",
        "25to34": "761",
        "35to44": "838",
        "45to54": "744",
        "55to64": "504",
        "65+": "146",
        "medianAge": "504"
      }
    },
    "title": "Elementary and middle school teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,152",
        "women": "80.7",
        "white": "10.8",
        "black": "2.5",
        "asian": "8.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,806",
        "median": "974",
        "maleWorkers": "543",
        "maleMedian": "1,077",
        "femaleWorkers": "2,262",
        "femaleMedian": "957"
      }
    }
  },
  "Secondary school teachers": {
    "ageData": {
      "2015": {
        "total": "1,144",
        "16to19": "6",
        "20to24": "59",
        "25to34": "262",
        "35to44": "291",
        "45to54": "260",
        "55to64": "210",
        "65+": "55",
        "medianAge": "210"
      }
    },
    "title": "Secondary school teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,144",
        "women": "59.2",
        "white": "8.7",
        "black": "2.5",
        "asian": "7.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,048",
        "median": "1,066",
        "maleWorkers": "438",
        "maleMedian": "1,149",
        "femaleWorkers": "610",
        "femaleMedian": "1,006"
      }
    }
  },
  "Special education teachers": {
    "ageData": {
      "2015": {
        "total": "330",
        "16to19": "1",
        "20to24": "9",
        "25to34": "73",
        "35to44": "87",
        "45to54": "82",
        "55to64": "64",
        "65+": "14",
        "medianAge": "64"
      }
    },
    "title": "Special education teachers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "330",
        "women": "87.5",
        "white": "9.5",
        "black": "2.3",
        "asian": "7.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "297",
        "median": "987",
        "maleWorkers": "38",
        "maleMedian": "-",
        "femaleWorkers": "258",
        "femaleMedian": "990"
      }
    }
  },
  "Other teachers and instructors": {
    "ageData": {
      "2015": {
        "total": "876",
        "16to19": "52",
        "20to24": "133",
        "25to34": "170",
        "35to44": "153",
        "45to54": "151",
        "55to64": "137",
        "65+": "81",
        "medianAge": "137"
      }
    },
    "title": "Other teachers and instructors",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "876",
        "women": "62.3",
        "white": "12.1",
        "black": "6.1",
        "asian": "11.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "378",
        "median": "896",
        "maleWorkers": "179",
        "maleMedian": "1,024",
        "femaleWorkers": "199",
        "femaleMedian": "817"
      }
    }
  },
  "Archivists, curators, and museum technicians": {
    "ageData": {
      "2015": {
        "total": "53",
        "16to19": "0",
        "20to24": "5",
        "25to34": "11",
        "35to44": "14",
        "45to54": "10",
        "55to64": "12",
        "65+": "2",
        "medianAge": "12"
      }
    },
    "title": "Archivists, curators, and museum technicians",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "53",
        "women": "60.1",
        "white": "2.7",
        "black": "0.0",
        "asian": "8.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "38",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Librarians": {
    "ageData": {
      "2015": {
        "total": "166",
        "16to19": "1",
        "20to24": "4",
        "25to34": "25",
        "35to44": "35",
        "45to54": "44",
        "55to64": "39",
        "65+": "18",
        "medianAge": "39"
      }
    },
    "title": "Librarians",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "166",
        "women": "83.0",
        "white": "8.5",
        "black": "2.8",
        "asian": "4.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "130",
        "median": "991",
        "maleWorkers": "27",
        "maleMedian": "-",
        "femaleWorkers": "102",
        "femaleMedian": "966"
      }
    }
  },
  "Library technicians": {
    "ageData": {
      "2015": {
        "total": "31",
        "16to19": "6",
        "20to24": "3",
        "25to34": "5",
        "35to44": "5",
        "45to54": "4",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Library technicians",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "31",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Teacher assistants": {
    "ageData": {
      "2015": {
        "total": "960",
        "16to19": "21",
        "20to24": "113",
        "25to34": "154",
        "35to44": "183",
        "45to54": "241",
        "55to64": "202",
        "65+": "46",
        "medianAge": "202"
      }
    },
    "title": "Teacher assistants",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "960",
        "women": "91.4",
        "white": "13.8",
        "black": "3.0",
        "asian": "18.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "614",
        "median": "541",
        "maleWorkers": "48",
        "maleMedian": "-",
        "femaleWorkers": "565",
        "femaleMedian": "530"
      }
    }
  },
  "Other education, training, and library workers": {
    "ageData": {
      "2015": {
        "total": "161",
        "16to19": "3",
        "20to24": "13",
        "25to34": "30",
        "35to44": "40",
        "45to54": "34",
        "55to64": "25",
        "65+": "15",
        "medianAge": "25"
      }
    },
    "title": "Other education, training, and library workers",
    "depth": 4,
    "parent": "Education, training, and library occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "161",
        "women": "73.7",
        "white": "12.5",
        "black": "4.1",
        "asian": "12.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "123",
        "median": "1,001",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "95",
        "femaleMedian": "1,031"
      }
    }
  },
  "Arts, design, entertainment, sports, and media occupations": {
    "ageData": {
      "2015": {
        "total": "3,051",
        "16to19": "79",
        "20to24": "248",
        "25to34": "783",
        "35to44": "662",
        "45to54": "592",
        "55to64": "464",
        "65+": "223",
        "medianAge": "464"
      }
    },
    "title": "Arts, design, entertainment, sports, and media occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,051",
        "women": "47.6",
        "white": "6.3",
        "black": "5.2",
        "asian": "10.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,643",
        "median": "1,001",
        "maleWorkers": "930",
        "maleMedian": "1,088",
        "femaleWorkers": "713",
        "femaleMedian": "942"
      }
    }
  },
  "Artists and related workers": {
    "ageData": {
      "2015": {
        "total": "222",
        "16to19": "0",
        "20to24": "10",
        "25to34": "39",
        "35to44": "41",
        "45to54": "60",
        "55to64": "50",
        "65+": "23",
        "medianAge": "50"
      }
    },
    "title": "Artists and related workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "222",
        "women": "56.9",
        "white": "2.7",
        "black": "4.1",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "58",
        "median": "1,166",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Designers": {
    "ageData": {
      "2015": {
        "total": "899",
        "16to19": "7",
        "20to24": "63",
        "25to34": "257",
        "35to44": "197",
        "45to54": "186",
        "55to64": "127",
        "65+": "62",
        "medianAge": "127"
      }
    },
    "title": "Designers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "899",
        "women": "54.9",
        "white": "3.5",
        "black": "6.9",
        "asian": "12.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "593",
        "median": "993",
        "maleWorkers": "301",
        "maleMedian": "1,099",
        "femaleWorkers": "291",
        "femaleMedian": "918"
      }
    }
  },
  "Actors": {
    "ageData": {
      "2015": {
        "total": "49",
        "16to19": "2",
        "20to24": "5",
        "25to34": "14",
        "35to44": "10",
        "45to54": "8",
        "55to64": "7",
        "65+": "4",
        "medianAge": "7"
      }
    },
    "title": "Actors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "49",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Producers and directors": {
    "ageData": {
      "2015": {
        "total": "169",
        "16to19": "1",
        "20to24": "9",
        "25to34": "55",
        "35to44": "38",
        "45to54": "37",
        "55to64": "25",
        "65+": "4",
        "medianAge": "25"
      }
    },
    "title": "Producers and directors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "169",
        "women": "36.9",
        "white": "5.3",
        "black": "5.6",
        "asian": "6.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "120",
        "median": "1,270",
        "maleWorkers": "67",
        "maleMedian": "1,340",
        "femaleWorkers": "53",
        "femaleMedian": "1,234"
      }
    }
  },
  "Athletes, coaches, umpires, and related workers": {
    "ageData": {
      "2015": {
        "total": "296",
        "16to19": "52",
        "20to24": "50",
        "25to34": "68",
        "35to44": "57",
        "45to54": "32",
        "55to64": "28",
        "65+": "10",
        "medianAge": "28"
      }
    },
    "title": "Athletes, coaches, umpires, and related workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "296",
        "women": "36.1",
        "white": "11.1",
        "black": "2.7",
        "asian": "10.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "147",
        "median": "780",
        "maleWorkers": "108",
        "maleMedian": "818",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Dancers and choreographers": {
    "ageData": {
      "2015": {
        "total": "19",
        "16to19": "1",
        "20to24": "5",
        "25to34": "7",
        "35to44": "3",
        "45to54": "2",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Dancers and choreographers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "19",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Musicians, singers, and related workers": {
    "ageData": {
      "2015": {
        "total": "202",
        "16to19": "3",
        "20to24": "12",
        "25to34": "42",
        "35to44": "41",
        "45to54": "28",
        "55to64": "46",
        "65+": "28",
        "medianAge": "46"
      }
    },
    "title": "Musicians, singers, and related workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "202",
        "women": "34.5",
        "white": "10.5",
        "black": "2.6",
        "asian": "8.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Entertainers and performers, sports and related workers, all other": {
    "ageData": {
      "2015": {
        "total": "41",
        "16to19": "2",
        "20to24": "7",
        "25to34": "12",
        "35to44": "9",
        "45to54": "5",
        "55to64": "2",
        "65+": "4",
        "medianAge": "2"
      }
    },
    "title": "Entertainers and performers, sports and related workers, all other",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "41",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Announcers": {
    "ageData": {
      "2015": {
        "total": "55",
        "16to19": "1",
        "20to24": "4",
        "25to34": "11",
        "35to44": "15",
        "45to54": "10",
        "55to64": "12",
        "65+": "2",
        "medianAge": "12"
      }
    },
    "title": "Announcers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "55",
        "women": "16.5",
        "white": "14.8",
        "black": "5.6",
        "asian": "19.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "25",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "News analysts, reporters and correspondents": {
    "ageData": {
      "2015": {
        "total": "68",
        "16to19": "0",
        "20to24": "2",
        "25to34": "20",
        "35to44": "14",
        "45to54": "16",
        "55to64": "9",
        "65+": "6",
        "medianAge": "9"
      }
    },
    "title": "News analysts, reporters and correspondents",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "68",
        "women": "46.7",
        "white": "6.5",
        "black": "1.7",
        "asian": "13.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "56",
        "median": "1,218",
        "maleWorkers": "29",
        "maleMedian": "-",
        "femaleWorkers": "27",
        "femaleMedian": "-"
      }
    }
  },
  "Public relations specialists": {
    "ageData": {
      "2015": {
        "total": "147",
        "16to19": "0",
        "20to24": "10",
        "25to34": "51",
        "35to44": "31",
        "45to54": "27",
        "55to64": "21",
        "65+": "8",
        "medianAge": "21"
      }
    },
    "title": "Public relations specialists",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "147",
        "women": "61.3",
        "white": "9.8",
        "black": "4.8",
        "asian": "7.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "120",
        "median": "1,211",
        "maleWorkers": "49",
        "maleMedian": "-",
        "femaleWorkers": "71",
        "femaleMedian": "971"
      }
    }
  },
  "Editors": {
    "ageData": {
      "2015": {
        "total": "160",
        "16to19": "2",
        "20to24": "9",
        "25to34": "36",
        "35to44": "47",
        "45to54": "26",
        "55to64": "27",
        "65+": "13",
        "medianAge": "27"
      }
    },
    "title": "Editors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "160",
        "women": "51.0",
        "white": "2.0",
        "black": "7.7",
        "asian": "7.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "108",
        "median": "1,148",
        "maleWorkers": "58",
        "maleMedian": "1,205",
        "femaleWorkers": "50",
        "femaleMedian": "1,125"
      }
    }
  },
  "Technical writers": {
    "ageData": {
      "2015": {
        "total": "68",
        "16to19": "0",
        "20to24": "2",
        "25to34": "11",
        "35to44": "16",
        "45to54": "17",
        "55to64": "16",
        "65+": "5",
        "medianAge": "16"
      }
    },
    "title": "Technical writers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "68",
        "women": "58.2",
        "white": "9.2",
        "black": "1.2",
        "asian": "6.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "52",
        "median": "1,158",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "30",
        "femaleMedian": "-"
      }
    }
  },
  "Writers and authors": {
    "ageData": {
      "2015": {
        "total": "208",
        "16to19": "1",
        "20to24": "12",
        "25to34": "34",
        "35to44": "41",
        "45to54": "55",
        "55to64": "36",
        "65+": "28",
        "medianAge": "36"
      }
    },
    "title": "Writers and authors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "208",
        "women": "59.4",
        "white": "4.9",
        "black": "3.5",
        "asian": "5.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "79",
        "median": "1,232",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous media and communication workers": {
    "ageData": {
      "2015": {
        "total": "84",
        "16to19": "0",
        "20to24": "7",
        "25to34": "16",
        "35to44": "19",
        "45to54": "21",
        "55to64": "14",
        "65+": "7",
        "medianAge": "14"
      }
    },
    "title": "Miscellaneous media and communication workers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "84",
        "women": "67.9",
        "white": "5.8",
        "black": "13.4",
        "asian": "35.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "46",
        "median": "-",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "30",
        "femaleMedian": "-"
      }
    }
  },
  "Broadcast and sound engineering technicians and radio operators": {
    "ageData": {
      "2015": {
        "total": "119",
        "16to19": "3",
        "20to24": "11",
        "25to34": "31",
        "35to44": "26",
        "45to54": "30",
        "55to64": "14",
        "65+": "4",
        "medianAge": "14"
      }
    },
    "title": "Broadcast and sound engineering technicians and radio operators",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "119",
        "women": "9.2",
        "white": "11.3",
        "black": "0.8",
        "asian": "14.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "83",
        "median": "954",
        "maleWorkers": "77",
        "maleMedian": "937",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Photographers": {
    "ageData": {
      "2015": {
        "total": "180",
        "16to19": "4",
        "20to24": "18",
        "25to34": "57",
        "35to44": "45",
        "45to54": "23",
        "55to64": "23",
        "65+": "11",
        "medianAge": "23"
      }
    },
    "title": "Photographers",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "180",
        "women": "49.9",
        "white": "3.3",
        "black": "7.8",
        "asian": "9.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "45",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Television, video, and motion picture camera operators and editors": {
    "ageData": {
      "2015": {
        "total": "64",
        "16to19": "1",
        "20to24": "13",
        "25to34": "21",
        "35to44": "12",
        "45to54": "9",
        "55to64": "6",
        "65+": "2",
        "medianAge": "6"
      }
    },
    "title": "Television, video, and motion picture camera operators and editors",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "64",
        "women": "14.8",
        "white": "4.5",
        "black": "6.0",
        "asian": "15.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "30",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Media and communication equipment workers, all other": {
    "ageData": {
      "2015": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Media and communication equipment workers, all other",
    "depth": 4,
    "parent": "Arts, design, entertainment, sports, and media occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Healthcare practitioners and technical occupations": {
    "ageData": {
      "2015": {
        "total": "8,766",
        "16to19": "33",
        "20to24": "487",
        "25to34": "2,295",
        "35to44": "2,064",
        "45to54": "1,916",
        "55to64": "1,546",
        "65+": "425",
        "medianAge": "1,546"
      }
    },
    "title": "Healthcare practitioners and technical occupations",
    "depth": 3,
    "parent": "Professional and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8,766",
        "women": "75.1",
        "white": "11.5",
        "black": "9.2",
        "asian": "8.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6,566",
        "median": "1,041",
        "maleWorkers": "1,639",
        "maleMedian": "1,272",
        "femaleWorkers": "4,928",
        "femaleMedian": "991"
      }
    }
  },
  "Chiropractors": {
    "ageData": {
      "2015": {
        "total": "75",
        "16to19": "0",
        "20to24": "2",
        "25to34": "10",
        "35to44": "18",
        "45to54": "24",
        "55to64": "14",
        "65+": "7",
        "medianAge": "14"
      }
    },
    "title": "Chiropractors",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "75",
        "women": "29.5",
        "white": "3.2",
        "black": "3.2",
        "asian": "8.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Dentists": {
    "ageData": {
      "2015": {
        "total": "196",
        "16to19": "0",
        "20to24": "1",
        "25to34": "31",
        "35to44": "49",
        "45to54": "38",
        "55to64": "51",
        "65+": "26",
        "medianAge": "51"
      }
    },
    "title": "Dentists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "196",
        "women": "25.9",
        "white": "2.9",
        "black": "16.8",
        "asian": "8.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "59",
        "median": "1,656",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Dietitians and nutritionists": {
    "ageData": {
      "2015": {
        "total": "108",
        "16to19": "0",
        "20to24": "8",
        "25to34": "26",
        "35to44": "18",
        "45to54": "23",
        "55to64": "27",
        "65+": "6",
        "medianAge": "27"
      }
    },
    "title": "Dietitians and nutritionists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "108",
        "women": "94.6",
        "white": "14.2",
        "black": "9.6",
        "asian": "5.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "79",
        "median": "886",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "69",
        "femaleMedian": "879"
      }
    }
  },
  "Optometrists": {
    "ageData": {
      "2015": {
        "total": "39",
        "16to19": "0",
        "20to24": "0",
        "25to34": "12",
        "35to44": "7",
        "45to54": "11",
        "55to64": "4",
        "65+": "3",
        "medianAge": "4"
      }
    },
    "title": "Optometrists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "39",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "19",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Pharmacists": {
    "ageData": {
      "2015": {
        "total": "282",
        "16to19": "0",
        "20to24": "15",
        "25to34": "87",
        "35to44": "61",
        "45to54": "52",
        "55to64": "51",
        "65+": "16",
        "medianAge": "51"
      }
    },
    "title": "Pharmacists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "282",
        "women": "57.0",
        "white": "8.7",
        "black": "15.3",
        "asian": "5.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "206",
        "median": "1,920",
        "maleWorkers": "98",
        "maleMedian": "2,117",
        "femaleWorkers": "108",
        "femaleMedian": "1,811"
      }
    }
  },
  "Physicians and surgeons": {
    "ageData": {
      "2015": {
        "total": "1,007",
        "16to19": "0",
        "20to24": "2",
        "25to34": "223",
        "35to44": "256",
        "45to54": "231",
        "55to64": "192",
        "65+": "103",
        "medianAge": "192"
      }
    },
    "title": "Physicians and surgeons",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,007",
        "women": "37.9",
        "white": "6.4",
        "black": "18.4",
        "asian": "6.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "740",
        "median": "1,824",
        "maleWorkers": "457",
        "maleMedian": "1,915",
        "femaleWorkers": "283",
        "femaleMedian": "1,533"
      }
    }
  },
  "Physician assistants": {
    "ageData": {
      "2015": {
        "total": "74",
        "16to19": "0",
        "20to24": "5",
        "25to34": "29",
        "35to44": "19",
        "45to54": "8",
        "55to64": "10",
        "65+": "3",
        "medianAge": "10"
      }
    },
    "title": "Physician assistants",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "74",
        "women": "72.6",
        "white": "3.7",
        "black": "7.1",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "57",
        "median": "1,368",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "40",
        "femaleMedian": "-"
      }
    }
  },
  "Podiatrists": {
    "ageData": {
      "2015": {
        "total": "15",
        "16to19": "0",
        "20to24": "2",
        "25to34": "2",
        "35to44": "4",
        "45to54": "3",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Podiatrists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Audiologists": {
    "ageData": {
      "2015": {
        "total": "16",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "2",
        "45to54": "5",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Audiologists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Occupational therapists": {
    "ageData": {
      "2015": {
        "total": "116",
        "16to19": "0",
        "20to24": "1",
        "25to34": "38",
        "35to44": "31",
        "45to54": "29",
        "55to64": "13",
        "65+": "3",
        "medianAge": "13"
      }
    },
    "title": "Occupational therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "116",
        "women": "88.0",
        "white": "7.2",
        "black": "8.6",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "74",
        "median": "1,210",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "64",
        "femaleMedian": "1,199"
      }
    }
  },
  "Physical therapists": {
    "ageData": {
      "2015": {
        "total": "274",
        "16to19": "0",
        "20to24": "6",
        "25to34": "84",
        "35to44": "68",
        "45to54": "68",
        "55to64": "40",
        "65+": "9",
        "medianAge": "40"
      }
    },
    "title": "Physical therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "274",
        "women": "72.1",
        "white": "4.3",
        "black": "12.5",
        "asian": "4.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "178",
        "median": "1,265",
        "maleWorkers": "56",
        "maleMedian": "1,347",
        "femaleWorkers": "123",
        "femaleMedian": "1,215"
      }
    }
  },
  "Radiation therapists": {
    "ageData": {
      "2015": {
        "total": "13",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "1",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Radiation therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Recreational therapists": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "3",
        "45to54": "1",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Recreational therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Respiratory therapists": {
    "ageData": {
      "2015": {
        "total": "108",
        "16to19": "0",
        "20to24": "1",
        "25to34": "29",
        "35to44": "25",
        "45to54": "32",
        "55to64": "18",
        "65+": "3",
        "medianAge": "18"
      }
    },
    "title": "Respiratory therapists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "108",
        "women": "66.8",
        "white": "15.2",
        "black": "6.0",
        "asian": "9.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "99",
        "median": "1,000",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "67",
        "femaleMedian": "937"
      }
    }
  },
  "Speech-language pathologists": {
    "ageData": {
      "2015": {
        "total": "158",
        "16to19": "0",
        "20to24": "9",
        "25to34": "49",
        "35to44": "43",
        "45to54": "28",
        "55to64": "23",
        "65+": "5",
        "medianAge": "23"
      }
    },
    "title": "Speech-language pathologists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "158",
        "women": "98.6",
        "white": "4.9",
        "black": "2.9",
        "asian": "7.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "108",
        "median": "1,147",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "106",
        "femaleMedian": "1,148"
      }
    }
  },
  "Exercise physiologists": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "1",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Exercise physiologists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Therapists, all other": {
    "ageData": {
      "2015": {
        "total": "189",
        "16to19": "1",
        "20to24": "15",
        "25to34": "60",
        "35to44": "39",
        "45to54": "37",
        "55to64": "26",
        "65+": "12",
        "medianAge": "26"
      }
    },
    "title": "Therapists, all other",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "189",
        "women": "80.9",
        "white": "7.9",
        "black": "3.8",
        "asian": "15.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "132",
        "median": "944",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "101",
        "femaleMedian": "951"
      }
    }
  },
  "Veterinarians": {
    "ageData": {
      "2015": {
        "total": "90",
        "16to19": "1",
        "20to24": "0",
        "25to34": "24",
        "35to44": "23",
        "45to54": "18",
        "55to64": "17",
        "65+": "6",
        "medianAge": "17"
      }
    },
    "title": "Veterinarians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "90",
        "women": "60.5",
        "white": "3.4",
        "black": "4.7",
        "asian": "2.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "55",
        "median": "1,455",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Registered nurses": {
    "ageData": {
      "2015": {
        "total": "2,973",
        "16to19": "7",
        "20to24": "121",
        "25to34": "715",
        "35to44": "727",
        "45to54": "705",
        "55to64": "577",
        "65+": "120",
        "medianAge": "577"
      }
    },
    "title": "Registered nurses",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,973",
        "women": "89.4",
        "white": "12.2",
        "black": "8.7",
        "asian": "6.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,382",
        "median": "1,116",
        "maleWorkers": "278",
        "maleMedian": "1,222",
        "femaleWorkers": "2,104",
        "femaleMedian": "1,098"
      }
    }
  },
  "Nurse anesthetists": {
    "ageData": {
      "2015": {
        "total": "27",
        "16to19": "0",
        "20to24": "0",
        "25to34": "7",
        "35to44": "8",
        "45to54": "4",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Nurse anesthetists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "27",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Nurse midwives": {
    "ageData": {
      "2015": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "0",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Nurse midwives",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Nurse practitioners": {
    "ageData": {
      "2015": {
        "total": "149",
        "16to19": "0",
        "20to24": "3",
        "25to34": "37",
        "35to44": "42",
        "45to54": "26",
        "55to64": "36",
        "65+": "6",
        "medianAge": "36"
      }
    },
    "title": "Nurse practitioners",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "149",
        "women": "90.8",
        "white": "8.2",
        "black": "3.5",
        "asian": "2.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "115",
        "median": "1,532",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "103",
        "femaleMedian": "1,522"
      }
    }
  },
  "Health diagnosing and treating practitioners, all other": {
    "ageData": {
      "2015": {
        "total": "17",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "4",
        "45to54": "4",
        "55to64": "5",
        "65+": "3",
        "medianAge": "5"
      }
    },
    "title": "Health diagnosing and treating practitioners, all other",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "17",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Clinical laboratory technologists and technicians": {
    "ageData": {
      "2015": {
        "total": "327",
        "16to19": "1",
        "20to24": "29",
        "25to34": "90",
        "35to44": "72",
        "45to54": "57",
        "55to64": "62",
        "65+": "17",
        "medianAge": "62"
      }
    },
    "title": "Clinical laboratory technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "327",
        "women": "76.1",
        "white": "17.3",
        "black": "13.5",
        "asian": "12.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "270",
        "median": "901",
        "maleWorkers": "69",
        "maleMedian": "1,089",
        "femaleWorkers": "201",
        "femaleMedian": "796"
      }
    }
  },
  "Dental hygienists": {
    "ageData": {
      "2015": {
        "total": "177",
        "16to19": "1",
        "20to24": "11",
        "25to34": "47",
        "35to44": "52",
        "45to54": "38",
        "55to64": "25",
        "65+": "4",
        "medianAge": "25"
      }
    },
    "title": "Dental hygienists",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "177",
        "women": "96.4",
        "white": "3.6",
        "black": "6.6",
        "asian": "5.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "86",
        "median": "914",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "80",
        "femaleMedian": "953"
      }
    }
  },
  "Diagnostic related technologists and technicians": {
    "ageData": {
      "2015": {
        "total": "322",
        "16to19": "1",
        "20to24": "13",
        "25to34": "90",
        "35to44": "82",
        "45to54": "78",
        "55to64": "49",
        "65+": "9",
        "medianAge": "49"
      }
    },
    "title": "Diagnostic related technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "322",
        "women": "73.7",
        "white": "7.9",
        "black": "5.2",
        "asian": "8.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "253",
        "median": "964",
        "maleWorkers": "76",
        "maleMedian": "1,106",
        "femaleWorkers": "177",
        "femaleMedian": "908"
      }
    }
  },
  "Emergency medical technicians and paramedics": {
    "ageData": {
      "2015": {
        "total": "220",
        "16to19": "3",
        "20to24": "36",
        "25to34": "83",
        "35to44": "50",
        "45to54": "34",
        "55to64": "10",
        "65+": "3",
        "medianAge": "10"
      }
    },
    "title": "Emergency medical technicians and paramedics",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "220",
        "women": "32.9",
        "white": "10.6",
        "black": "1.2",
        "asian": "8.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "175",
        "median": "811",
        "maleWorkers": "126",
        "maleMedian": "899",
        "femaleWorkers": "49",
        "femaleMedian": "-"
      }
    }
  },
  "Health practitioner support technologists and technicians": {
    "ageData": {
      "2015": {
        "total": "626",
        "16to19": "7",
        "20to24": "112",
        "25to34": "221",
        "35to44": "116",
        "45to54": "97",
        "55to64": "61",
        "65+": "12",
        "medianAge": "61"
      }
    },
    "title": "Health practitioner support technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "626",
        "women": "81.5",
        "white": "14.2",
        "black": "7.5",
        "asian": "13.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "487",
        "median": "636",
        "maleWorkers": "99",
        "maleMedian": "652",
        "femaleWorkers": "389",
        "femaleMedian": "633"
      }
    }
  },
  "Licensed practical and licensed vocational nurses": {
    "ageData": {
      "2015": {
        "total": "670",
        "16to19": "6",
        "20to24": "65",
        "25to34": "165",
        "35to44": "138",
        "45to54": "150",
        "55to64": "117",
        "65+": "29",
        "medianAge": "117"
      }
    },
    "title": "Licensed practical and licensed vocational nurses",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "670",
        "women": "90.1",
        "white": "28.5",
        "black": "5.7",
        "asian": "13.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "508",
        "median": "743",
        "maleWorkers": "48",
        "maleMedian": "-",
        "femaleWorkers": "459",
        "femaleMedian": "737"
      }
    }
  },
  "Medical records and health information technicians": {
    "ageData": {
      "2015": {
        "total": "200",
        "16to19": "3",
        "20to24": "11",
        "25to34": "43",
        "35to44": "41",
        "45to54": "52",
        "55to64": "45",
        "65+": "5",
        "medianAge": "45"
      }
    },
    "title": "Medical records and health information technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "200",
        "women": "89.6",
        "white": "12.1",
        "black": "3.6",
        "asian": "8.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "174",
        "median": "740",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "157",
        "femaleMedian": "723"
      }
    }
  },
  "Opticians, dispensing": {
    "ageData": {
      "2015": {
        "total": "52",
        "16to19": "0",
        "20to24": "3",
        "25to34": "9",
        "35to44": "14",
        "45to54": "13",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Opticians, dispensing",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "52",
        "women": "60.4",
        "white": "8.4",
        "black": "4.0",
        "asian": "13.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous health technologists and technicians": {
    "ageData": {
      "2015": {
        "total": "117",
        "16to19": "1",
        "20to24": "8",
        "25to34": "29",
        "35to44": "27",
        "45to54": "26",
        "55to64": "23",
        "65+": "4",
        "medianAge": "23"
      }
    },
    "title": "Miscellaneous health technologists and technicians",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "117",
        "women": "67.5",
        "white": "14.2",
        "black": "7.8",
        "asian": "11.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "99",
        "median": "671",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "66",
        "femaleMedian": "642"
      }
    }
  },
  "Other healthcare practitioners and technical occupations": {
    "ageData": {
      "2015": {
        "total": "108",
        "16to19": "0",
        "20to24": "5",
        "25to34": "35",
        "35to44": "25",
        "45to54": "16",
        "55to64": "22",
        "65+": "5",
        "medianAge": "22"
      }
    },
    "title": "Other healthcare practitioners and technical occupations",
    "depth": 4,
    "parent": "Healthcare practitioners and technical occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "108",
        "women": "52.7",
        "white": "8.8",
        "black": "3.3",
        "asian": "9.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "78",
        "median": "1,128",
        "maleWorkers": "40",
        "maleMedian": "-",
        "femaleWorkers": "38",
        "femaleMedian": "-"
      }
    }
  },
  "Service occupations": {
    "ageData": {
      "2015": {
        "total": "25,896",
        "16to19": "1,964",
        "20to24": "3,890",
        "25to34": "5,722",
        "35to44": "4,781",
        "45to54": "4,763",
        "55to64": "3,504",
        "65+": "1,272",
        "medianAge": "3,504"
      }
    },
    "title": "Service occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "25,896",
        "women": "56.7",
        "white": "16.8",
        "black": "5.4",
        "asian": "23.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15,279",
        "median": "509",
        "maleWorkers": "7,629",
        "maleMedian": "585",
        "femaleWorkers": "7,650",
        "femaleMedian": "463"
      }
    }
  },
  "Healthcare support occupations": {
    "ageData": {
      "2015": {
        "total": "3,514",
        "16to19": "94",
        "20to24": "459",
        "25to34": "962",
        "35to44": "713",
        "45to54": "685",
        "55to64": "460",
        "65+": "141",
        "medianAge": "460"
      }
    },
    "title": "Healthcare support occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,514",
        "women": "87.6",
        "white": "27.1",
        "black": "5.7",
        "asian": "16.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,395",
        "median": "498",
        "maleWorkers": "320",
        "maleMedian": "577",
        "femaleWorkers": "2,074",
        "femaleMedian": "490"
      }
    }
  },
  "Nursing, psychiatric, and home health aides": {
    "ageData": {
      "2015": {
        "total": "2,032",
        "16to19": "66",
        "20to24": "257",
        "25to34": "497",
        "35to44": "414",
        "45to54": "420",
        "55to64": "284",
        "65+": "93",
        "medianAge": "284"
      }
    },
    "title": "Nursing, psychiatric, and home health aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,032",
        "women": "89.4",
        "white": "37.7",
        "black": "5.6",
        "asian": "14.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,400",
        "median": "467",
        "maleWorkers": "163",
        "maleMedian": "526",
        "femaleWorkers": "1,237",
        "femaleMedian": "457"
      }
    }
  },
  "Occupational therapy assistants and aides": {
    "ageData": {
      "2015": {
        "total": "23",
        "16to19": "0",
        "20to24": "6",
        "25to34": "8",
        "35to44": "5",
        "45to54": "2",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Occupational therapy assistants and aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Physical therapist assistants and aides": {
    "ageData": {
      "2015": {
        "total": "68",
        "16to19": "1",
        "20to24": "8",
        "25to34": "25",
        "35to44": "13",
        "45to54": "14",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Physical therapist assistants and aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "68",
        "women": "67.7",
        "white": "5.6",
        "black": "6.0",
        "asian": "10.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "53",
        "median": "742",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "35",
        "femaleMedian": "-"
      }
    }
  },
  "Massage therapists": {
    "ageData": {
      "2015": {
        "total": "189",
        "16to19": "1",
        "20to24": "11",
        "25to34": "64",
        "35to44": "42",
        "45to54": "31",
        "55to64": "30",
        "65+": "10",
        "medianAge": "30"
      }
    },
    "title": "Massage therapists",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "189",
        "women": "77.9",
        "white": "4.8",
        "black": "9.1",
        "asian": "9.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "22",
        "femaleMedian": "-"
      }
    }
  },
  "Dental assistants": {
    "ageData": {
      "2015": {
        "total": "286",
        "16to19": "5",
        "20to24": "43",
        "25to34": "91",
        "35to44": "62",
        "45to54": "54",
        "55to64": "25",
        "65+": "6",
        "medianAge": "25"
      }
    },
    "title": "Dental assistants",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "286",
        "women": "94.1",
        "white": "9.6",
        "black": "6.6",
        "asian": "23.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "188",
        "median": "531",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "175",
        "femaleMedian": "522"
      }
    }
  },
  "Medical assistants": {
    "ageData": {
      "2015": {
        "total": "524",
        "16to19": "6",
        "20to24": "71",
        "25to34": "181",
        "35to44": "110",
        "45to54": "91",
        "55to64": "51",
        "65+": "13",
        "medianAge": "51"
      }
    },
    "title": "Medical assistants",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "524",
        "women": "90.7",
        "white": "13.0",
        "black": "5.6",
        "asian": "27.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "422",
        "median": "539",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "387",
        "femaleMedian": "530"
      }
    }
  },
  "Medical transcriptionists": {
    "ageData": {
      "2015": {
        "total": "42",
        "16to19": "0",
        "20to24": "4",
        "25to34": "4",
        "35to44": "3",
        "45to54": "13",
        "55to64": "12",
        "65+": "5",
        "medianAge": "12"
      }
    },
    "title": "Medical transcriptionists",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "42",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Pharmacy aides": {
    "ageData": {
      "2015": {
        "total": "36",
        "16to19": "1",
        "20to24": "6",
        "25to34": "11",
        "35to44": "7",
        "45to54": "3",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Pharmacy aides",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "36",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Veterinary assistants and laboratory animal caretakers": {
    "ageData": {
      "2015": {
        "total": "38",
        "16to19": "3",
        "20to24": "10",
        "25to34": "9",
        "35to44": "10",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Veterinary assistants and laboratory animal caretakers",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "Phlebotomists": {
    "ageData": {
      "2015": {
        "total": "106",
        "16to19": "2",
        "20to24": "11",
        "25to34": "29",
        "35to44": "22",
        "45to54": "21",
        "55to64": "18",
        "65+": "3",
        "medianAge": "18"
      }
    },
    "title": "Phlebotomists",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "106",
        "women": "84.1",
        "white": "25.2",
        "black": "3.5",
        "asian": "13.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "91",
        "median": "551",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "76",
        "femaleMedian": "534"
      }
    }
  },
  "Miscellaneous healthcare support occupations, including medical equipment preparers": {
    "ageData": {
      "2015": {
        "total": "170",
        "16to19": "8",
        "20to24": "32",
        "25to34": "42",
        "35to44": "25",
        "45to54": "33",
        "55to64": "25",
        "65+": "6",
        "medianAge": "25"
      }
    },
    "title": "Miscellaneous healthcare support occupations, including medical equipment preparers",
    "depth": 3,
    "parent": "Healthcare support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "170",
        "women": "69.6",
        "white": "25.1",
        "black": "4.1",
        "asian": "8.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "115",
        "median": "524",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "71",
        "femaleMedian": "511"
      }
    }
  },
  "Protective service occupations": {
    "ageData": {
      "2015": {
        "total": "3,109",
        "16to19": "100",
        "20to24": "273",
        "25to34": "723",
        "35to44": "720",
        "45to54": "702",
        "55to64": "430",
        "65+": "161",
        "medianAge": "430"
      }
    },
    "title": "Protective service occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,109",
        "women": "21.3",
        "white": "19.2",
        "black": "2.4",
        "asian": "13.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,729",
        "median": "796",
        "maleWorkers": "2,181",
        "maleMedian": "851",
        "femaleWorkers": "547",
        "femaleMedian": "655"
      }
    }
  },
  "First-line supervisors of correctional officers": {
    "ageData": {
      "2015": {
        "total": "52",
        "16to19": "0",
        "20to24": "0",
        "25to34": "11",
        "35to44": "11",
        "45to54": "22",
        "55to64": "8",
        "65+": "0",
        "medianAge": "8"
      }
    },
    "title": "First-line supervisors of correctional officers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "52",
        "women": "31.4",
        "white": "24.7",
        "black": "2.7",
        "asian": "6.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "57",
        "median": "856",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "First-line supervisors of police and detectives": {
    "ageData": {
      "2015": {
        "total": "110",
        "16to19": "0",
        "20to24": "0",
        "25to34": "8",
        "35to44": "30",
        "45to54": "52",
        "55to64": "15",
        "65+": "5",
        "medianAge": "15"
      }
    },
    "title": "First-line supervisors of police and detectives",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "110",
        "women": "12.8",
        "white": "14.0",
        "black": "1.3",
        "asian": "6.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "114",
        "median": "1,427",
        "maleWorkers": "97",
        "maleMedian": "1,425",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "First-line supervisors of fire fighting and prevention workers": {
    "ageData": {
      "2015": {
        "total": "49",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "12",
        "45to54": "16",
        "55to64": "16",
        "65+": "1",
        "medianAge": "16"
      }
    },
    "title": "First-line supervisors of fire fighting and prevention workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "49",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "First-line supervisors of protective service workers, all other": {
    "ageData": {
      "2015": {
        "total": "81",
        "16to19": "0",
        "20to24": "0",
        "25to34": "13",
        "35to44": "14",
        "45to54": "24",
        "55to64": "19",
        "65+": "11",
        "medianAge": "19"
      }
    },
    "title": "First-line supervisors of protective service workers, all other",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "81",
        "women": "23.2",
        "white": "14.7",
        "black": "2.0",
        "asian": "10.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "72",
        "median": "808",
        "maleWorkers": "56",
        "maleMedian": "825",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Firefighters": {
    "ageData": {
      "2015": {
        "total": "293",
        "16to19": "2",
        "20to24": "14",
        "25to34": "90",
        "35to44": "96",
        "45to54": "63",
        "55to64": "22",
        "65+": "6",
        "medianAge": "22"
      }
    },
    "title": "Firefighters",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "293",
        "women": "5.9",
        "white": "8.4",
        "black": "1.1",
        "asian": "7.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "260",
        "median": "1,033",
        "maleWorkers": "245",
        "maleMedian": "1,052",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Fire inspectors": {
    "ageData": {
      "2015": {
        "total": "19",
        "16to19": "0",
        "20to24": "0",
        "25to34": "8",
        "35to44": "3",
        "45to54": "4",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Fire inspectors",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "19",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Bailiffs, correctional officers, and jailers": {
    "ageData": {
      "2015": {
        "total": "443",
        "16to19": "5",
        "20to24": "54",
        "25to34": "117",
        "35to44": "102",
        "45to54": "106",
        "55to64": "49",
        "65+": "10",
        "medianAge": "49"
      }
    },
    "title": "Bailiffs, correctional officers, and jailers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "443",
        "women": "23.8",
        "white": "26.0",
        "black": "1.2",
        "asian": "11.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "453",
        "median": "754",
        "maleWorkers": "341",
        "maleMedian": "779",
        "femaleWorkers": "112",
        "femaleMedian": "686"
      }
    }
  },
  "Detectives and criminal investigators": {
    "ageData": {
      "2015": {
        "total": "144",
        "16to19": "0",
        "20to24": "3",
        "25to34": "25",
        "35to44": "43",
        "45to54": "44",
        "55to64": "25",
        "65+": "3",
        "medianAge": "25"
      }
    },
    "title": "Detectives and criminal investigators",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "144",
        "women": "27.2",
        "white": "8.5",
        "black": "0.8",
        "asian": "11.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "141",
        "median": "1,159",
        "maleWorkers": "100",
        "maleMedian": "1,265",
        "femaleWorkers": "41",
        "femaleMedian": "-"
      }
    }
  },
  "Fish and game wardens": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Fish and game wardens",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Parking enforcement workers": {
    "ageData": {
      "2015": {
        "total": "10",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "1",
        "45to54": "2",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Parking enforcement workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Police and sheriff's patrol officers": {
    "ageData": {
      "2015": {
        "total": "688",
        "16to19": "1",
        "20to24": "39",
        "25to34": "191",
        "35to44": "215",
        "45to54": "165",
        "55to64": "61",
        "65+": "16",
        "medianAge": "61"
      }
    },
    "title": "Police and sheriff's patrol officers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "688",
        "women": "13.6",
        "white": "13.5",
        "black": "2.0",
        "asian": "15.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "655",
        "median": "1,002",
        "maleWorkers": "569",
        "maleMedian": "1,001",
        "femaleWorkers": "86",
        "femaleMedian": "1,009"
      }
    }
  },
  "Transit and railroad police": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Transit and railroad police",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Animal control workers": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "2",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Animal control workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Private detectives and investigators": {
    "ageData": {
      "2015": {
        "total": "100",
        "16to19": "0",
        "20to24": "4",
        "25to34": "23",
        "35to44": "24",
        "45to54": "18",
        "55to64": "20",
        "65+": "10",
        "medianAge": "20"
      }
    },
    "title": "Private detectives and investigators",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "100",
        "women": "38.4",
        "white": "12.7",
        "black": "5.0",
        "asian": "14.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "85",
        "median": "843",
        "maleWorkers": "49",
        "maleMedian": "-",
        "femaleWorkers": "36",
        "femaleMedian": "-"
      }
    }
  },
  "Security guards and gaming surveillance officers": {
    "ageData": {
      "2015": {
        "total": "869",
        "16to19": "18",
        "20to24": "114",
        "25to34": "202",
        "35to44": "142",
        "45to54": "163",
        "55to64": "160",
        "65+": "72",
        "medianAge": "160"
      }
    },
    "title": "Security guards and gaming surveillance officers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "869",
        "women": "22.0",
        "white": "28.8",
        "black": "4.0",
        "asian": "18.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "708",
        "median": "567",
        "maleWorkers": "555",
        "maleMedian": "592",
        "femaleWorkers": "153",
        "femaleMedian": "515"
      }
    }
  },
  "Crossing guards": {
    "ageData": {
      "2015": {
        "total": "57",
        "16to19": "0",
        "20to24": "4",
        "25to34": "5",
        "35to44": "9",
        "45to54": "6",
        "55to64": "16",
        "65+": "17",
        "medianAge": "16"
      }
    },
    "title": "Crossing guards",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "57",
        "women": "59.8",
        "white": "33.2",
        "black": "3.1",
        "asian": "17.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "13",
        "maleMedian": "-",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Transportation security screeners": {
    "ageData": {
      "2015": {
        "total": "38",
        "16to19": "0",
        "20to24": "4",
        "25to34": "12",
        "35to44": "5",
        "45to54": "11",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Transportation security screeners",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Lifeguards and other recreational, and all other protective service workers": {
    "ageData": {
      "2015": {
        "total": "144",
        "16to19": "74",
        "20to24": "36",
        "25to34": "10",
        "35to44": "8",
        "45to54": "5",
        "55to64": "5",
        "65+": "6",
        "medianAge": "5"
      }
    },
    "title": "Lifeguards and other recreational, and all other protective service workers",
    "depth": 3,
    "parent": "Protective service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "144",
        "women": "43.7",
        "white": "9.1",
        "black": "1.5",
        "asian": "12.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Food preparation and serving related occupations": {
    "ageData": {
      "2015": {
        "total": "8,142",
        "16to19": "1,281",
        "20to24": "1,917",
        "25to34": "1,837",
        "35to44": "1,181",
        "45to54": "1,048",
        "55to64": "648",
        "65+": "230",
        "medianAge": "648"
      }
    },
    "title": "Food preparation and serving related occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8,142",
        "women": "54.5",
        "white": "13.8",
        "black": "6.1",
        "asian": "25.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4,124",
        "median": "441",
        "maleWorkers": "2,133",
        "maleMedian": "481",
        "femaleWorkers": "1,991",
        "femaleMedian": "414"
      }
    }
  },
  "Chefs and head cooks": {
    "ageData": {
      "2015": {
        "total": "415",
        "16to19": "8",
        "20to24": "43",
        "25to34": "124",
        "35to44": "99",
        "45to54": "79",
        "55to64": "53",
        "65+": "10",
        "medianAge": "53"
      }
    },
    "title": "Chefs and head cooks",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "415",
        "women": "19.6",
        "white": "15.2",
        "black": "16.8",
        "asian": "19.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "340",
        "median": "619",
        "maleWorkers": "285",
        "maleMedian": "656",
        "femaleWorkers": "55",
        "femaleMedian": "492"
      }
    }
  },
  "First-line supervisors of food preparation and serving workers": {
    "ageData": {
      "2015": {
        "total": "527",
        "16to19": "21",
        "20to24": "95",
        "25to34": "141",
        "35to44": "89",
        "45to54": "103",
        "55to64": "63",
        "65+": "15",
        "medianAge": "63"
      }
    },
    "title": "First-line supervisors of food preparation and serving workers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "527",
        "women": "57.4",
        "white": "14.9",
        "black": "3.8",
        "asian": "16.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "378",
        "median": "498",
        "maleWorkers": "156",
        "maleMedian": "621",
        "femaleWorkers": "222",
        "femaleMedian": "458"
      }
    }
  },
  "Cooks": {
    "ageData": {
      "2015": {
        "total": "2,091",
        "16to19": "251",
        "20to24": "371",
        "25to34": "483",
        "35to44": "371",
        "45to54": "362",
        "55to64": "180",
        "65+": "73",
        "medianAge": "180"
      }
    },
    "title": "Cooks",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,091",
        "women": "39.9",
        "white": "18.5",
        "black": "5.3",
        "asian": "35.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,302",
        "median": "416",
        "maleWorkers": "808",
        "maleMedian": "427",
        "femaleWorkers": "494",
        "femaleMedian": "400"
      }
    }
  },
  "Food preparation workers": {
    "ageData": {
      "2015": {
        "total": "858",
        "16to19": "172",
        "20to24": "206",
        "25to34": "152",
        "35to44": "111",
        "45to54": "112",
        "55to64": "75",
        "65+": "30",
        "medianAge": "75"
      }
    },
    "title": "Food preparation workers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "858",
        "women": "59.1",
        "white": "15.1",
        "black": "5.6",
        "asian": "27.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "366",
        "median": "402",
        "maleWorkers": "174",
        "maleMedian": "414",
        "femaleWorkers": "192",
        "femaleMedian": "388"
      }
    }
  },
  "Bartenders": {
    "ageData": {
      "2015": {
        "total": "451",
        "16to19": "3",
        "20to24": "82",
        "25to34": "174",
        "35to44": "91",
        "45to54": "59",
        "55to64": "32",
        "65+": "11",
        "medianAge": "32"
      }
    },
    "title": "Bartenders",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "451",
        "women": "59.8",
        "white": "4.4",
        "black": "3.3",
        "asian": "13.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "252",
        "median": "521",
        "maleWorkers": "110",
        "maleMedian": "569",
        "femaleWorkers": "142",
        "femaleMedian": "493"
      }
    }
  },
  "Combined food preparation and serving workers, including fast food": {
    "ageData": {
      "2015": {
        "total": "420",
        "16to19": "95",
        "20to24": "126",
        "25to34": "69",
        "35to44": "39",
        "45to54": "38",
        "55to64": "34",
        "65+": "18",
        "medianAge": "34"
      }
    },
    "title": "Combined food preparation and serving workers, including fast food",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "420",
        "women": "63.4",
        "white": "21.6",
        "black": "3.7",
        "asian": "17.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "173",
        "median": "391",
        "maleWorkers": "67",
        "maleMedian": "401",
        "femaleWorkers": "107",
        "femaleMedian": "380"
      }
    }
  },
  "Counter attendants, cafeteria, food concession, and coffee shop": {
    "ageData": {
      "2015": {
        "total": "233",
        "16to19": "116",
        "20to24": "51",
        "25to34": "27",
        "35to44": "16",
        "45to54": "11",
        "55to64": "7",
        "65+": "5",
        "medianAge": "7"
      }
    },
    "title": "Counter attendants, cafeteria, food concession, and coffee shop",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "233",
        "women": "66.7",
        "white": "10.7",
        "black": "6.2",
        "asian": "18.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "56",
        "median": "354",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Waiters and waitresses": {
    "ageData": {
      "2015": {
        "total": "2,057",
        "16to19": "310",
        "20to24": "686",
        "25to34": "522",
        "35to44": "241",
        "45to54": "155",
        "55to64": "113",
        "65+": "30",
        "medianAge": "113"
      }
    },
    "title": "Waiters and waitresses",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,057",
        "women": "70.1",
        "white": "8.2",
        "black": "6.9",
        "asian": "21.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "868",
        "median": "451",
        "maleWorkers": "305",
        "maleMedian": "501",
        "femaleWorkers": "563",
        "femaleMedian": "411"
      }
    }
  },
  "Food servers, nonrestaurant": {
    "ageData": {
      "2015": {
        "total": "190",
        "16to19": "22",
        "20to24": "35",
        "25to34": "34",
        "35to44": "31",
        "45to54": "34",
        "55to64": "24",
        "65+": "10",
        "medianAge": "24"
      }
    },
    "title": "Food servers, nonrestaurant",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "190",
        "women": "70.9",
        "white": "20.6",
        "black": "8.7",
        "asian": "19.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "93",
        "median": "509",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "62",
        "femaleMedian": "485"
      }
    }
  },
  "Dining room and cafeteria attendants and bartender helpers": {
    "ageData": {
      "2015": {
        "total": "321",
        "16to19": "93",
        "20to24": "61",
        "25to34": "44",
        "35to44": "36",
        "45to54": "41",
        "55to64": "31",
        "65+": "13",
        "medianAge": "31"
      }
    },
    "title": "Dining room and cafeteria attendants and bartender helpers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "321",
        "women": "44.2",
        "white": "13.9",
        "black": "6.1",
        "asian": "29.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "107",
        "median": "403",
        "maleWorkers": "59",
        "maleMedian": "389",
        "femaleWorkers": "48",
        "femaleMedian": "-"
      }
    }
  },
  "Dishwashers": {
    "ageData": {
      "2015": {
        "total": "281",
        "16to19": "62",
        "20to24": "64",
        "25to34": "39",
        "35to44": "39",
        "45to54": "44",
        "55to64": "25",
        "65+": "8",
        "medianAge": "25"
      }
    },
    "title": "Dishwashers",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "281",
        "women": "21.3",
        "white": "14.7",
        "black": "5.1",
        "asian": "39.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "117",
        "median": "398",
        "maleWorkers": "98",
        "maleMedian": "401",
        "femaleWorkers": "19",
        "femaleMedian": "-"
      }
    }
  },
  "Hosts and hostesses, restaurant, lounge, and coffee shop": {
    "ageData": {
      "2015": {
        "total": "293",
        "16to19": "127",
        "20to24": "95",
        "25to34": "28",
        "35to44": "17",
        "45to54": "11",
        "55to64": "10",
        "65+": "6",
        "medianAge": "10"
      }
    },
    "title": "Hosts and hostesses, restaurant, lounge, and coffee shop",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "293",
        "women": "82.1",
        "white": "11.2",
        "black": "3.6",
        "asian": "19.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "66",
        "median": "400",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "58",
        "femaleMedian": "397"
      }
    }
  },
  "Food preparation and serving related workers, all other": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "1",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "1",
        "65+": "2",
        "medianAge": "1"
      }
    },
    "title": "Food preparation and serving related workers, all other",
    "depth": 3,
    "parent": "Food preparation and serving related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Building and grounds cleaning and maintenance occupations": {
    "ageData": {
      "2015": {
        "total": "5,716",
        "16to19": "191",
        "20to24": "469",
        "25to34": "1,064",
        "35to44": "1,144",
        "45to54": "1,350",
        "55to64": "1,136",
        "65+": "361",
        "medianAge": "1,136"
      }
    },
    "title": "Building and grounds cleaning and maintenance occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5,716",
        "women": "41.1",
        "white": "14.5",
        "black": "2.9",
        "asian": "38.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3,605",
        "median": "486",
        "maleWorkers": "2,330",
        "maleMedian": "517",
        "femaleWorkers": "1,275",
        "femaleMedian": "419"
      }
    }
  },
  "First-line supervisors of housekeeping and janitorial workers": {
    "ageData": {
      "2015": {
        "total": "293",
        "16to19": "0",
        "20to24": "9",
        "25to34": "48",
        "35to44": "63",
        "45to54": "84",
        "55to64": "69",
        "65+": "20",
        "medianAge": "69"
      }
    },
    "title": "First-line supervisors of housekeeping and janitorial workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "293",
        "women": "40.6",
        "white": "19.7",
        "black": "2.4",
        "asian": "20.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "172",
        "median": "620",
        "maleWorkers": "108",
        "maleMedian": "700",
        "femaleWorkers": "64",
        "femaleMedian": "571"
      }
    }
  },
  "First-line supervisors of landscaping, lawn service, and groundskeeping workers": {
    "ageData": {
      "2015": {
        "total": "215",
        "16to19": "1",
        "20to24": "12",
        "25to34": "47",
        "35to44": "56",
        "45to54": "53",
        "55to64": "37",
        "65+": "9",
        "medianAge": "37"
      }
    },
    "title": "First-line supervisors of landscaping, lawn service, and groundskeeping workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "215",
        "women": "6.6",
        "white": "4.0",
        "black": "2.0",
        "asian": "23.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "80",
        "median": "649",
        "maleWorkers": "79",
        "maleMedian": "653",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Janitors and building cleaners": {
    "ageData": {
      "2015": {
        "total": "2,263",
        "16to19": "75",
        "20to24": "174",
        "25to34": "375",
        "35to44": "384",
        "45to54": "535",
        "55to64": "543",
        "65+": "178",
        "medianAge": "543"
      }
    },
    "title": "Janitors and building cleaners",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,263",
        "women": "34.3",
        "white": "17.6",
        "black": "3.4",
        "asian": "31.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,536",
        "median": "507",
        "maleWorkers": "1,111",
        "maleMedian": "547",
        "femaleWorkers": "425",
        "femaleMedian": "429"
      }
    }
  },
  "Maids and housekeeping cleaners": {
    "ageData": {
      "2015": {
        "total": "1,510",
        "16to19": "36",
        "20to24": "99",
        "25to34": "243",
        "35to44": "355",
        "45to54": "413",
        "55to64": "284",
        "65+": "81",
        "medianAge": "284"
      }
    },
    "title": "Maids and housekeeping cleaners",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,510",
        "women": "89.3",
        "white": "16.1",
        "black": "4.4",
        "asian": "48.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "876",
        "median": "416",
        "maleWorkers": "134",
        "maleMedian": "475",
        "femaleWorkers": "742",
        "femaleMedian": "407"
      }
    }
  },
  "Pest control workers": {
    "ageData": {
      "2015": {
        "total": "85",
        "16to19": "3",
        "20to24": "5",
        "25to34": "20",
        "35to44": "18",
        "45to54": "21",
        "55to64": "14",
        "65+": "4",
        "medianAge": "14"
      }
    },
    "title": "Pest control workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "85",
        "women": "4.7",
        "white": "13.0",
        "black": "1.3",
        "asian": "14.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "77",
        "median": "585",
        "maleWorkers": "74",
        "maleMedian": "591",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Grounds maintenance workers": {
    "ageData": {
      "2015": {
        "total": "1,349",
        "16to19": "76",
        "20to24": "170",
        "25to34": "332",
        "35to44": "269",
        "45to54": "244",
        "55to64": "190",
        "65+": "69",
        "medianAge": "190"
      }
    },
    "title": "Grounds maintenance workers",
    "depth": 3,
    "parent": "Building and grounds cleaning and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,349",
        "women": "6.4",
        "white": "7.9",
        "black": "0.9",
        "asian": "44.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "862",
        "median": "469",
        "maleWorkers": "824",
        "maleMedian": "473",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Personal care and service occupations": {
    "ageData": {
      "2015": {
        "total": "5,415",
        "16to19": "297",
        "20to24": "772",
        "25to34": "1,136",
        "35to44": "1,023",
        "45to54": "978",
        "55to64": "830",
        "65+": "378",
        "medianAge": "830"
      }
    },
    "title": "Personal care and service occupations",
    "depth": 2,
    "parent": "Service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5,415",
        "women": "76.8",
        "white": "15.6",
        "black": "8.5",
        "asian": "15.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,427",
        "median": "498",
        "maleWorkers": "664",
        "maleMedian": "597",
        "femaleWorkers": "1,763",
        "femaleMedian": "475"
      }
    }
  },
  "First-line supervisors of gaming workers": {
    "ageData": {
      "2015": {
        "total": "168",
        "16to19": "6",
        "20to24": "10",
        "25to34": "41",
        "35to44": "43",
        "45to54": "32",
        "55to64": "23",
        "65+": "14",
        "medianAge": "23"
      }
    },
    "title": "First-line supervisors of gaming workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "168",
        "women": "46.6",
        "white": "4.8",
        "black": "5.1",
        "asian": "8.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "117",
        "median": "769",
        "maleWorkers": "65",
        "maleMedian": "900",
        "femaleWorkers": "52",
        "femaleMedian": "680"
      }
    }
  },
  "First-line supervisors of personal service workers": {
    "ageData": {
      "2015": {
        "total": "185",
        "16to19": "0",
        "20to24": "4",
        "25to34": "44",
        "35to44": "50",
        "45to54": "41",
        "55to64": "34",
        "65+": "12",
        "medianAge": "34"
      }
    },
    "title": "First-line supervisors of personal service workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "185",
        "women": "71.0",
        "white": "11.9",
        "black": "16.2",
        "asian": "8.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "60",
        "median": "608",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "35",
        "femaleMedian": "-"
      }
    }
  },
  "Animal trainers": {
    "ageData": {
      "2015": {
        "total": "54",
        "16to19": "1",
        "20to24": "4",
        "25to34": "12",
        "35to44": "12",
        "45to54": "8",
        "55to64": "14",
        "65+": "3",
        "medianAge": "14"
      }
    },
    "title": "Animal trainers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "54",
        "women": "50.9",
        "white": "1.2",
        "black": "0.0",
        "asian": "11.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Nonfarm animal caretakers": {
    "ageData": {
      "2015": {
        "total": "252",
        "16to19": "20",
        "20to24": "56",
        "25to34": "58",
        "35to44": "38",
        "45to54": "41",
        "55to64": "29",
        "65+": "10",
        "medianAge": "29"
      }
    },
    "title": "Nonfarm animal caretakers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "252",
        "women": "67.9",
        "white": "5.4",
        "black": "1.8",
        "asian": "13.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "100",
        "median": "505",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "68",
        "femaleMedian": "501"
      }
    }
  },
  "Gaming services workers": {
    "ageData": {
      "2015": {
        "total": "89",
        "16to19": "1",
        "20to24": "7",
        "25to34": "17",
        "35to44": "21",
        "45to54": "17",
        "55to64": "19",
        "65+": "6",
        "medianAge": "19"
      }
    },
    "title": "Gaming services workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "89",
        "women": "52.2",
        "white": "8.0",
        "black": "22.0",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "69",
        "median": "676",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Motion picture projectionists": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "2",
        "45to54": "2",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Motion picture projectionists",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Ushers, lobby attendants, and ticket takers": {
    "ageData": {
      "2015": {
        "total": "44",
        "16to19": "12",
        "20to24": "15",
        "25to34": "6",
        "35to44": "2",
        "45to54": "2",
        "55to64": "2",
        "65+": "5",
        "medianAge": "2"
      }
    },
    "title": "Ushers, lobby attendants, and ticket takers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous entertainment attendants and related workers": {
    "ageData": {
      "2015": {
        "total": "221",
        "16to19": "52",
        "20to24": "62",
        "25to34": "35",
        "35to44": "15",
        "45to54": "16",
        "55to64": "21",
        "65+": "21",
        "medianAge": "21"
      }
    },
    "title": "Miscellaneous entertainment attendants and related workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "221",
        "women": "39.2",
        "white": "12.8",
        "black": "2.1",
        "asian": "15.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "69",
        "median": "485",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Embalmers and funeral attendants": {
    "ageData": {
      "2015": {
        "total": "9",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "3",
        "45to54": "1",
        "55to64": "1",
        "65+": "3",
        "medianAge": "1"
      }
    },
    "title": "Embalmers and funeral attendants",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Morticians, undertakers, and funeral directors": {
    "ageData": {
      "2015": {
        "total": "35",
        "16to19": "0",
        "20to24": "1",
        "25to34": "6",
        "35to44": "7",
        "45to54": "8",
        "55to64": "8",
        "65+": "5",
        "medianAge": "8"
      }
    },
    "title": "Morticians, undertakers, and funeral directors",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "35",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Barbers": {
    "ageData": {
      "2015": {
        "total": "116",
        "16to19": "1",
        "20to24": "4",
        "25to34": "28",
        "35to44": "38",
        "45to54": "24",
        "55to64": "11",
        "65+": "10",
        "medianAge": "11"
      }
    },
    "title": "Barbers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "116",
        "women": "22.1",
        "white": "40.7",
        "black": "6.4",
        "asian": "20.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "46",
        "median": "-",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Hairdressers, hairstylists, and cosmetologists": {
    "ageData": {
      "2015": {
        "total": "707",
        "16to19": "6",
        "20to24": "80",
        "25to34": "182",
        "35to44": "154",
        "45to54": "133",
        "55to64": "97",
        "65+": "55",
        "medianAge": "97"
      }
    },
    "title": "Hairdressers, hairstylists, and cosmetologists",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "707",
        "women": "94.2",
        "white": "12.3",
        "black": "3.9",
        "asian": "15.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "253",
        "median": "461",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "229",
        "femaleMedian": "463"
      }
    }
  },
  "Miscellaneous personal appearance workers": {
    "ageData": {
      "2015": {
        "total": "324",
        "16to19": "2",
        "20to24": "26",
        "25to34": "74",
        "35to44": "102",
        "45to54": "78",
        "55to64": "34",
        "65+": "7",
        "medianAge": "34"
      }
    },
    "title": "Miscellaneous personal appearance workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "324",
        "women": "85.3",
        "white": "7.0",
        "black": "56.5",
        "asian": "8.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "191",
        "median": "501",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "159",
        "femaleMedian": "497"
      }
    }
  },
  "Baggage porters, bellhops, and concierges": {
    "ageData": {
      "2015": {
        "total": "76",
        "16to19": "2",
        "20to24": "11",
        "25to34": "19",
        "35to44": "13",
        "45to54": "19",
        "55to64": "8",
        "65+": "3",
        "medianAge": "8"
      }
    },
    "title": "Baggage porters, bellhops, and concierges",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "76",
        "women": "16.1",
        "white": "21.0",
        "black": "10.5",
        "asian": "32.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "75",
        "median": "608",
        "maleWorkers": "63",
        "maleMedian": "606",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Tour and travel guides": {
    "ageData": {
      "2015": {
        "total": "54",
        "16to19": "3",
        "20to24": "14",
        "25to34": "6",
        "35to44": "10",
        "45to54": "6",
        "55to64": "8",
        "65+": "8",
        "medianAge": "8"
      }
    },
    "title": "Tour and travel guides",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "54",
        "women": "54.3",
        "white": "3.4",
        "black": "10.1",
        "asian": "5.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Childcare workers": {
    "ageData": {
      "2015": {
        "total": "1,206",
        "16to19": "113",
        "20to24": "236",
        "25to34": "250",
        "35to44": "179",
        "45to54": "182",
        "55to64": "176",
        "65+": "70",
        "medianAge": "176"
      }
    },
    "title": "Childcare workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,206",
        "women": "94.9",
        "white": "15.3",
        "black": "3.3",
        "asian": "19.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "407",
        "median": "437",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "393",
        "femaleMedian": "430"
      }
    }
  },
  "Personal care aides": {
    "ageData": {
      "2015": {
        "total": "1,251",
        "16to19": "29",
        "20to24": "140",
        "25to34": "226",
        "35to44": "215",
        "45to54": "269",
        "55to64": "263",
        "65+": "109",
        "medianAge": "263"
      }
    },
    "title": "Personal care aides",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,251",
        "women": "85.1",
        "white": "24.2",
        "black": "8.1",
        "asian": "17.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "680",
        "median": "462",
        "maleWorkers": "128",
        "maleMedian": "537",
        "femaleWorkers": "552",
        "femaleMedian": "441"
      }
    }
  },
  "Recreation and fitness workers": {
    "ageData": {
      "2015": {
        "total": "429",
        "16to19": "35",
        "20to24": "65",
        "25to34": "86",
        "35to44": "83",
        "45to54": "73",
        "55to64": "65",
        "65+": "22",
        "medianAge": "65"
      }
    },
    "title": "Recreation and fitness workers",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "429",
        "women": "61.6",
        "white": "10.7",
        "black": "2.1",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "185",
        "median": "555",
        "maleWorkers": "78",
        "maleMedian": "684",
        "femaleWorkers": "107",
        "femaleMedian": "526"
      }
    }
  },
  "Residential advisors": {
    "ageData": {
      "2015": {
        "total": "38",
        "16to19": "5",
        "20to24": "13",
        "25to34": "6",
        "35to44": "5",
        "45to54": "4",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Residential advisors",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "24",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Personal care and service workers, all other": {
    "ageData": {
      "2015": {
        "total": "149",
        "16to19": "8",
        "20to24": "22",
        "25to34": "42",
        "35to44": "33",
        "45to54": "21",
        "55to64": "12",
        "65+": "11",
        "medianAge": "12"
      }
    },
    "title": "Personal care and service workers, all other",
    "depth": 3,
    "parent": "Personal care and service occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "149",
        "women": "49.8",
        "white": "15.6",
        "black": "4.9",
        "asian": "20.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "67",
        "median": "499",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "32",
        "femaleMedian": "-"
      }
    }
  },
  "Sales and office occupations": {
    "ageData": {
      "2015": {
        "total": "33,598",
        "16to19": "1,617",
        "20to24": "4,181",
        "25to34": "7,017",
        "35to44": "6,016",
        "45to54": "6,940",
        "55to64": "5,738",
        "65+": "2,090",
        "medianAge": "5,738"
      }
    },
    "title": "Sales and office occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "33,598",
        "women": "61.5",
        "white": "12.3",
        "black": "5.2",
        "asian": "15.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23,620",
        "median": "673",
        "maleWorkers": "9,384",
        "maleMedian": "777",
        "femaleWorkers": "14,236",
        "femaleMedian": "627"
      }
    }
  },
  "Sales and related occupations": {
    "ageData": {
      "2015": {
        "total": "15,700",
        "16to19": "1,113",
        "20to24": "2,118",
        "25to34": "3,215",
        "35to44": "2,667",
        "45to54": "3,057",
        "55to64": "2,459",
        "65+": "1,071",
        "medianAge": "2,459"
      }
    },
    "title": "Sales and related occupations",
    "depth": 2,
    "parent": "Sales and office occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15,700",
        "women": "49.3",
        "white": "10.6",
        "black": "5.7",
        "asian": "15.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9,725",
        "median": "716",
        "maleWorkers": "5,423",
        "maleMedian": "880",
        "femaleWorkers": "4,303",
        "femaleMedian": "578"
      }
    }
  },
  "First-line supervisors of retail sales workers": {
    "ageData": {
      "2015": {
        "total": "3,245",
        "16to19": "29",
        "20to24": "274",
        "25to34": "750",
        "35to44": "689",
        "45to54": "766",
        "55to64": "544",
        "65+": "192",
        "medianAge": "544"
      }
    },
    "title": "First-line supervisors of retail sales workers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,245",
        "women": "44.0",
        "white": "9.5",
        "black": "6.1",
        "asian": "13.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,326",
        "median": "711",
        "maleWorkers": "1,296",
        "maleMedian": "825",
        "femaleWorkers": "1,030",
        "femaleMedian": "614"
      }
    }
  },
  "First-line supervisors of non-retail sales workers": {
    "ageData": {
      "2015": {
        "total": "1,242",
        "16to19": "4",
        "20to24": "29",
        "25to34": "195",
        "35to44": "297",
        "45to54": "359",
        "55to64": "277",
        "65+": "81",
        "medianAge": "277"
      }
    },
    "title": "First-line supervisors of non-retail sales workers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,242",
        "women": "28.7",
        "white": "6.2",
        "black": "5.9",
        "asian": "12.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "835",
        "median": "1,028",
        "maleWorkers": "556",
        "maleMedian": "1,140",
        "femaleWorkers": "280",
        "femaleMedian": "896"
      }
    }
  },
  "Cashiers": {
    "ageData": {
      "2015": {
        "total": "3,246",
        "16to19": "714",
        "20to24": "833",
        "25to34": "594",
        "35to44": "302",
        "45to54": "355",
        "55to64": "310",
        "65+": "139",
        "medianAge": "310"
      }
    },
    "title": "Cashiers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,246",
        "women": "72.5",
        "white": "17.4",
        "black": "6.8",
        "asian": "20.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,342",
        "median": "415",
        "maleWorkers": "411",
        "maleMedian": "471",
        "femaleWorkers": "931",
        "femaleMedian": "405"
      }
    }
  },
  "Counter and rental clerks": {
    "ageData": {
      "2015": {
        "total": "109",
        "16to19": "10",
        "20to24": "16",
        "25to34": "29",
        "35to44": "17",
        "45to54": "20",
        "55to64": "10",
        "65+": "7",
        "medianAge": "10"
      }
    },
    "title": "Counter and rental clerks",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "109",
        "women": "50.9",
        "white": "12.2",
        "black": "2.9",
        "asian": "18.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "73",
        "median": "594",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "37",
        "femaleMedian": "-"
      }
    }
  },
  "Parts salespersons": {
    "ageData": {
      "2015": {
        "total": "124",
        "16to19": "4",
        "20to24": "22",
        "25to34": "28",
        "35to44": "23",
        "45to54": "18",
        "55to64": "22",
        "65+": "7",
        "medianAge": "22"
      }
    },
    "title": "Parts salespersons",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "124",
        "women": "12.4",
        "white": "5.0",
        "black": "1.5",
        "asian": "18.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "92",
        "median": "601",
        "maleWorkers": "82",
        "maleMedian": "600",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Retail salespersons": {
    "ageData": {
      "2015": {
        "total": "3,346",
        "16to19": "304",
        "20to24": "668",
        "25to34": "710",
        "35to44": "461",
        "45to54": "483",
        "55to64": "473",
        "65+": "247",
        "medianAge": "473"
      }
    },
    "title": "Retail salespersons",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,346",
        "women": "49.4",
        "white": "12.8",
        "black": "6.3",
        "asian": "17.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,918",
        "median": "590",
        "maleWorkers": "1,159",
        "maleMedian": "694",
        "femaleWorkers": "759",
        "femaleMedian": "494"
      }
    }
  },
  "Advertising sales agents": {
    "ageData": {
      "2015": {
        "total": "200",
        "16to19": "1",
        "20to24": "18",
        "25to34": "54",
        "35to44": "41",
        "45to54": "47",
        "55to64": "28",
        "65+": "11",
        "medianAge": "28"
      }
    },
    "title": "Advertising sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "200",
        "women": "49.7",
        "white": "9.4",
        "black": "4.8",
        "asian": "11.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "161",
        "median": "925",
        "maleWorkers": "78",
        "maleMedian": "1,155",
        "femaleWorkers": "83",
        "femaleMedian": "729"
      }
    }
  },
  "Insurance sales agents": {
    "ageData": {
      "2015": {
        "total": "615",
        "16to19": "3",
        "20to24": "35",
        "25to34": "126",
        "35to44": "116",
        "45to54": "155",
        "55to64": "113",
        "65+": "68",
        "medianAge": "113"
      }
    },
    "title": "Insurance sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "615",
        "women": "51.2",
        "white": "7.3",
        "black": "3.5",
        "asian": "12.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "427",
        "median": "815",
        "maleWorkers": "194",
        "maleMedian": "1,028",
        "femaleWorkers": "232",
        "femaleMedian": "717"
      }
    }
  },
  "Securities, commodities, and financial services sales agents": {
    "ageData": {
      "2015": {
        "total": "258",
        "16to19": "1",
        "20to24": "19",
        "25to34": "59",
        "35to44": "58",
        "45to54": "61",
        "55to64": "45",
        "65+": "15",
        "medianAge": "45"
      }
    },
    "title": "Securities, commodities, and financial services sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "258",
        "women": "26.2",
        "white": "4.8",
        "black": "5.8",
        "asian": "7.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "211",
        "median": "1,155",
        "maleWorkers": "146",
        "maleMedian": "1,461",
        "femaleWorkers": "65",
        "femaleMedian": "767"
      }
    }
  },
  "Travel agents": {
    "ageData": {
      "2015": {
        "total": "89",
        "16to19": "0",
        "20to24": "2",
        "25to34": "18",
        "35to44": "11",
        "45to54": "21",
        "55to64": "26",
        "65+": "11",
        "medianAge": "26"
      }
    },
    "title": "Travel agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "89",
        "women": "75.9",
        "white": "3.3",
        "black": "17.7",
        "asian": "8.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "62",
        "median": "711",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "53",
        "femaleMedian": "685"
      }
    }
  },
  "Sales representatives, services, all other": {
    "ageData": {
      "2015": {
        "total": "479",
        "16to19": "7",
        "20to24": "35",
        "25to34": "119",
        "35to44": "118",
        "45to54": "103",
        "55to64": "81",
        "65+": "17",
        "medianAge": "81"
      }
    },
    "title": "Sales representatives, services, all other",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "479",
        "women": "34.8",
        "white": "5.7",
        "black": "2.8",
        "asian": "13.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "406",
        "median": "966",
        "maleWorkers": "268",
        "maleMedian": "1,147",
        "femaleWorkers": "139",
        "femaleMedian": "699"
      }
    }
  },
  "Sales representatives, wholesale and manufacturing": {
    "ageData": {
      "2015": {
        "total": "1,281",
        "16to19": "10",
        "20to24": "69",
        "25to34": "276",
        "35to44": "253",
        "45to54": "341",
        "55to64": "256",
        "65+": "77",
        "medianAge": "256"
      }
    },
    "title": "Sales representatives, wholesale and manufacturing",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,281",
        "women": "27.9",
        "white": "4.0",
        "black": "3.3",
        "asian": "10.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,138",
        "median": "1,020",
        "maleWorkers": "843",
        "maleMedian": "1,066",
        "femaleWorkers": "295",
        "femaleMedian": "917"
      }
    }
  },
  "Models, demonstrators, and product promoters": {
    "ageData": {
      "2015": {
        "total": "68",
        "16to19": "4",
        "20to24": "14",
        "25to34": "10",
        "35to44": "11",
        "45to54": "5",
        "55to64": "9",
        "65+": "15",
        "medianAge": "9"
      }
    },
    "title": "Models, demonstrators, and product promoters",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "68",
        "women": "70.7",
        "white": "5.6",
        "black": "6.5",
        "asian": "15.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Real estate brokers and sales agents": {
    "ageData": {
      "2015": {
        "total": "906",
        "16to19": "5",
        "20to24": "32",
        "25to34": "134",
        "35to44": "187",
        "45to54": "204",
        "55to64": "196",
        "65+": "148",
        "medianAge": "196"
      }
    },
    "title": "Real estate brokers and sales agents",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "906",
        "women": "55.5",
        "white": "5.7",
        "black": "4.9",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "463",
        "median": "837",
        "maleWorkers": "197",
        "maleMedian": "1,052",
        "femaleWorkers": "266",
        "femaleMedian": "735"
      }
    }
  },
  "Sales engineers": {
    "ageData": {
      "2015": {
        "total": "42",
        "16to19": "0",
        "20to24": "0",
        "25to34": "8",
        "35to44": "11",
        "45to54": "14",
        "55to64": "7",
        "65+": "3",
        "medianAge": "7"
      }
    },
    "title": "Sales engineers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "42",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Telemarketers": {
    "ageData": {
      "2015": {
        "total": "60",
        "16to19": "4",
        "20to24": "14",
        "25to34": "19",
        "35to44": "6",
        "45to54": "7",
        "55to64": "6",
        "65+": "2",
        "medianAge": "6"
      }
    },
    "title": "Telemarketers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "60",
        "women": "64.3",
        "white": "25.9",
        "black": "2.2",
        "asian": "27.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Door-to-door sales workers, news and street vendors, and related workers": {
    "ageData": {
      "2015": {
        "total": "156",
        "16to19": "3",
        "20to24": "15",
        "25to34": "37",
        "35to44": "28",
        "45to54": "40",
        "55to64": "21",
        "65+": "11",
        "medianAge": "21"
      }
    },
    "title": "Door-to-door sales workers, news and street vendors, and related workers",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "156",
        "women": "67.0",
        "white": "10.5",
        "black": "2.5",
        "asian": "21.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Sales and related workers, all other": {
    "ageData": {
      "2015": {
        "total": "236",
        "16to19": "11",
        "20to24": "23",
        "25to34": "49",
        "35to44": "39",
        "45to54": "59",
        "55to64": "34",
        "65+": "21",
        "medianAge": "34"
      }
    },
    "title": "Sales and related workers, all other",
    "depth": 3,
    "parent": "Sales and related occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "236",
        "women": "46.8",
        "white": "6.5",
        "black": "3.9",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "158",
        "median": "916",
        "maleWorkers": "89",
        "maleMedian": "1,088",
        "femaleWorkers": "70",
        "femaleMedian": "727"
      }
    }
  },
  "Office and administrative support occupations": {
    "ageData": {
      "2015": {
        "total": "17,897",
        "16to19": "504",
        "20to24": "2,063",
        "25to34": "3,801",
        "35to44": "3,349",
        "45to54": "3,883",
        "55to64": "3,278",
        "65+": "1,020",
        "medianAge": "3,278"
      }
    },
    "title": "Office and administrative support occupations",
    "depth": 2,
    "parent": "Sales and office occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "17,897",
        "women": "72.2",
        "white": "13.9",
        "black": "4.7",
        "asian": "15.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "13,894",
        "median": "656",
        "maleWorkers": "3,961",
        "maleMedian": "693",
        "femaleWorkers": "9,933",
        "femaleMedian": "646"
      }
    }
  },
  "First-line supervisors of office and administrative support workers": {
    "ageData": {
      "2015": {
        "total": "1,474",
        "16to19": "5",
        "20to24": "61",
        "25to34": "274",
        "35to44": "353",
        "45to54": "397",
        "55to64": "315",
        "65+": "68",
        "medianAge": "315"
      }
    },
    "title": "First-line supervisors of office and administrative support workers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,474",
        "women": "68.3",
        "white": "11.7",
        "black": "4.7",
        "asian": "13.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,297",
        "median": "812",
        "maleWorkers": "434",
        "maleMedian": "878",
        "femaleWorkers": "863",
        "femaleMedian": "781"
      }
    }
  },
  "Switchboard operators, including answering service": {
    "ageData": {
      "2015": {
        "total": "16",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "3",
        "45to54": "3",
        "55to64": "3",
        "65+": "2",
        "medianAge": "3"
      }
    },
    "title": "Switchboard operators, including answering service",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Telephone operators": {
    "ageData": {
      "2015": {
        "total": "34",
        "16to19": "0",
        "20to24": "10",
        "25to34": "6",
        "35to44": "7",
        "45to54": "3",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Telephone operators",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "34",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Communications equipment operators, all other": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "0",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Communications equipment operators, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Bill and account collectors": {
    "ageData": {
      "2015": {
        "total": "168",
        "16to19": "1",
        "20to24": "16",
        "25to34": "45",
        "35to44": "49",
        "45to54": "23",
        "55to64": "28",
        "65+": "6",
        "medianAge": "28"
      }
    },
    "title": "Bill and account collectors",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "168",
        "women": "68.3",
        "white": "20.6",
        "black": "3.9",
        "asian": "18.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "152",
        "median": "657",
        "maleWorkers": "54",
        "maleMedian": "674",
        "femaleWorkers": "98",
        "femaleMedian": "648"
      }
    }
  },
  "Billing and posting clerks": {
    "ageData": {
      "2015": {
        "total": "473",
        "16to19": "3",
        "20to24": "24",
        "25to34": "98",
        "35to44": "119",
        "45to54": "125",
        "55to64": "79",
        "65+": "25",
        "medianAge": "79"
      }
    },
    "title": "Billing and posting clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "473",
        "women": "90.1",
        "white": "13.0",
        "black": "3.3",
        "asian": "13.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "406",
        "median": "657",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "366",
        "femaleMedian": "664"
      }
    }
  },
  "Bookkeeping, accounting, and auditing clerks": {
    "ageData": {
      "2015": {
        "total": "1,182",
        "16to19": "4",
        "20to24": "59",
        "25to34": "164",
        "35to44": "229",
        "45to54": "302",
        "55to64": "284",
        "65+": "140",
        "medianAge": "284"
      }
    },
    "title": "Bookkeeping, accounting, and auditing clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,182",
        "women": "89.8",
        "white": "7.5",
        "black": "4.9",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "769",
        "median": "692",
        "maleWorkers": "87",
        "maleMedian": "690",
        "femaleWorkers": "682",
        "femaleMedian": "692"
      }
    }
  },
  "Gaming cage workers": {
    "ageData": {
      "2015": {
        "total": "14",
        "16to19": "0",
        "20to24": "4",
        "25to34": "4",
        "35to44": "2",
        "45to54": "1",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Gaming cage workers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Payroll and timekeeping clerks": {
    "ageData": {
      "2015": {
        "total": "138",
        "16to19": "1",
        "20to24": "9",
        "25to34": "23",
        "35to44": "31",
        "45to54": "45",
        "55to64": "24",
        "65+": "6",
        "medianAge": "24"
      }
    },
    "title": "Payroll and timekeeping clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "138",
        "women": "89.3",
        "white": "7.3",
        "black": "4.8",
        "asian": "15.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "128",
        "median": "757",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "111",
        "femaleMedian": "751"
      }
    }
  },
  "Procurement clerks": {
    "ageData": {
      "2015": {
        "total": "40",
        "16to19": "0",
        "20to24": "6",
        "25to34": "6",
        "35to44": "4",
        "45to54": "10",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Procurement clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "40",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "15",
        "maleMedian": "-",
        "femaleWorkers": "21",
        "femaleMedian": "-"
      }
    }
  },
  "Tellers": {
    "ageData": {
      "2015": {
        "total": "357",
        "16to19": "10",
        "20to24": "92",
        "25to34": "102",
        "35to44": "46",
        "45to54": "56",
        "55to64": "40",
        "65+": "12",
        "medianAge": "40"
      }
    },
    "title": "Tellers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "357",
        "women": "87.3",
        "white": "8.4",
        "black": "6.4",
        "asian": "20.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "264",
        "median": "514",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "231",
        "femaleMedian": "516"
      }
    }
  },
  "Financial clerks, all other": {
    "ageData": {
      "2015": {
        "total": "69",
        "16to19": "0",
        "20to24": "6",
        "25to34": "18",
        "35to44": "13",
        "45to54": "19",
        "55to64": "9",
        "65+": "3",
        "medianAge": "9"
      }
    },
    "title": "Financial clerks, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "69",
        "women": "63.3",
        "white": "24.6",
        "black": "7.6",
        "asian": "7.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "61",
        "median": "767",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "32",
        "femaleMedian": "-"
      }
    }
  },
  "Brokerage clerks": {
    "ageData": {
      "2015": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Brokerage clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Correspondence clerks": {
    "ageData": {
      "2015": {
        "total": "3",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Correspondence clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Court, municipal, and license clerks": {
    "ageData": {
      "2015": {
        "total": "71",
        "16to19": "0",
        "20to24": "2",
        "25to34": "15",
        "35to44": "15",
        "45to54": "18",
        "55to64": "16",
        "65+": "6",
        "medianAge": "16"
      }
    },
    "title": "Court, municipal, and license clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "71",
        "women": "87.0",
        "white": "11.9",
        "black": "3.3",
        "asian": "16.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "60",
        "median": "755",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "51",
        "femaleMedian": "743"
      }
    }
  },
  "Credit authorizers, checkers, and clerks": {
    "ageData": {
      "2015": {
        "total": "52",
        "16to19": "1",
        "20to24": "3",
        "25to34": "15",
        "35to44": "12",
        "45to54": "13",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Credit authorizers, checkers, and clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "52",
        "women": "72.9",
        "white": "10.4",
        "black": "2.5",
        "asian": "15.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "29",
        "femaleMedian": "-"
      }
    }
  },
  "Customer service representatives": {
    "ageData": {
      "2015": {
        "total": "2,271",
        "16to19": "124",
        "20to24": "403",
        "25to34": "583",
        "35to44": "390",
        "45to54": "402",
        "55to64": "287",
        "65+": "83",
        "medianAge": "287"
      }
    },
    "title": "Customer service representatives",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,271",
        "women": "65.1",
        "white": "16.6",
        "black": "4.7",
        "asian": "18.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,760",
        "median": "621",
        "maleWorkers": "611",
        "maleMedian": "690",
        "femaleWorkers": "1,149",
        "femaleMedian": "604"
      }
    }
  },
  "Eligibility interviewers, government programs": {
    "ageData": {
      "2015": {
        "total": "74",
        "16to19": "0",
        "20to24": "2",
        "25to34": "19",
        "35to44": "21",
        "45to54": "14",
        "55to64": "15",
        "65+": "4",
        "medianAge": "15"
      }
    },
    "title": "Eligibility interviewers, government programs",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "74",
        "women": "77.3",
        "white": "25.1",
        "black": "2.3",
        "asian": "33.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "67",
        "median": "781",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "50",
        "femaleMedian": "805"
      }
    }
  },
  "File clerks": {
    "ageData": {
      "2015": {
        "total": "203",
        "16to19": "11",
        "20to24": "28",
        "25to34": "45",
        "35to44": "35",
        "45to54": "36",
        "55to64": "31",
        "65+": "17",
        "medianAge": "31"
      }
    },
    "title": "File clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "203",
        "women": "82.2",
        "white": "12.9",
        "black": "4.2",
        "asian": "13.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "145",
        "median": "634",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "120",
        "femaleMedian": "627"
      }
    }
  },
  "Hotel, motel, and resort desk clerks": {
    "ageData": {
      "2015": {
        "total": "156",
        "16to19": "5",
        "20to24": "37",
        "25to34": "58",
        "35to44": "24",
        "45to54": "15",
        "55to64": "11",
        "65+": "6",
        "medianAge": "11"
      }
    },
    "title": "Hotel, motel, and resort desk clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "156",
        "women": "59.5",
        "white": "18.0",
        "black": "10.7",
        "asian": "18.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "127",
        "median": "481",
        "maleWorkers": "58",
        "maleMedian": "486",
        "femaleWorkers": "69",
        "femaleMedian": "467"
      }
    }
  },
  "Interviewers, except eligibility and loan": {
    "ageData": {
      "2015": {
        "total": "151",
        "16to19": "3",
        "20to24": "22",
        "25to34": "33",
        "35to44": "28",
        "45to54": "33",
        "55to64": "23",
        "65+": "10",
        "medianAge": "23"
      }
    },
    "title": "Interviewers, except eligibility and loan",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "151",
        "women": "83.2",
        "white": "16.1",
        "black": "3.7",
        "asian": "18.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "105",
        "median": "615",
        "maleWorkers": "16",
        "maleMedian": "-",
        "femaleWorkers": "89",
        "femaleMedian": "617"
      }
    }
  },
  "Library assistants, clerical": {
    "ageData": {
      "2015": {
        "total": "98",
        "16to19": "8",
        "20to24": "23",
        "25to34": "15",
        "35to44": "13",
        "45to54": "20",
        "55to64": "10",
        "65+": "9",
        "medianAge": "10"
      }
    },
    "title": "Library assistants, clerical",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "98",
        "women": "77.3",
        "white": "8.0",
        "black": "7.5",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Loan interviewers and clerks": {
    "ageData": {
      "2015": {
        "total": "139",
        "16to19": "0",
        "20to24": "9",
        "25to34": "42",
        "35to44": "40",
        "45to54": "26",
        "55to64": "18",
        "65+": "4",
        "medianAge": "18"
      }
    },
    "title": "Loan interviewers and clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "139",
        "women": "83.5",
        "white": "12.8",
        "black": "4.1",
        "asian": "16.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "134",
        "median": "710",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "109",
        "femaleMedian": "722"
      }
    }
  },
  "New accounts clerks": {
    "ageData": {
      "2015": {
        "total": "26",
        "16to19": "1",
        "20to24": "3",
        "25to34": "6",
        "35to44": "4",
        "45to54": "4",
        "55to64": "8",
        "65+": "0",
        "medianAge": "8"
      }
    },
    "title": "New accounts clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "26",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "Order clerks": {
    "ageData": {
      "2015": {
        "total": "84",
        "16to19": "2",
        "20to24": "9",
        "25to34": "23",
        "35to44": "17",
        "45to54": "15",
        "55to64": "14",
        "65+": "4",
        "medianAge": "14"
      }
    },
    "title": "Order clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "84",
        "women": "65.6",
        "white": "14.5",
        "black": "4.4",
        "asian": "16.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "74",
        "median": "599",
        "maleWorkers": "26",
        "maleMedian": "-",
        "femaleWorkers": "48",
        "femaleMedian": "-"
      }
    }
  },
  "Human resources assistants, except payroll and timekeeping": {
    "ageData": {
      "2015": {
        "total": "59",
        "16to19": "0",
        "20to24": "8",
        "25to34": "17",
        "35to44": "13",
        "45to54": "12",
        "55to64": "7",
        "65+": "2",
        "medianAge": "7"
      }
    },
    "title": "Human resources assistants, except payroll and timekeeping",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "59",
        "women": "82.9",
        "white": "18.9",
        "black": "3.5",
        "asian": "7.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "50",
        "median": "737",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "40",
        "femaleMedian": "-"
      }
    }
  },
  "Receptionists and information clerks": {
    "ageData": {
      "2015": {
        "total": "1,232",
        "16to19": "52",
        "20to24": "222",
        "25to34": "278",
        "35to44": "200",
        "45to54": "203",
        "55to64": "188",
        "65+": "89",
        "medianAge": "188"
      }
    },
    "title": "Receptionists and information clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,232",
        "women": "90.6",
        "white": "13.4",
        "black": "3.7",
        "asian": "17.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "852",
        "median": "575",
        "maleWorkers": "72",
        "maleMedian": "619",
        "femaleWorkers": "781",
        "femaleMedian": "569"
      }
    }
  },
  "Reservation and transportation ticket agents and travel clerks": {
    "ageData": {
      "2015": {
        "total": "111",
        "16to19": "2",
        "20to24": "14",
        "25to34": "28",
        "35to44": "20",
        "45to54": "25",
        "55to64": "18",
        "65+": "4",
        "medianAge": "18"
      }
    },
    "title": "Reservation and transportation ticket agents and travel clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "111",
        "women": "61.3",
        "white": "16.4",
        "black": "6.4",
        "asian": "18.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "95",
        "median": "713",
        "maleWorkers": "34",
        "maleMedian": "-",
        "femaleWorkers": "61",
        "femaleMedian": "680"
      }
    }
  },
  "Information and record clerks, all other": {
    "ageData": {
      "2015": {
        "total": "127",
        "16to19": "1",
        "20to24": "15",
        "25to34": "27",
        "35to44": "27",
        "45to54": "27",
        "55to64": "24",
        "65+": "6",
        "medianAge": "24"
      }
    },
    "title": "Information and record clerks, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "127",
        "women": "76.9",
        "white": "17.7",
        "black": "7.5",
        "asian": "13.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "100",
        "median": "618",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "78",
        "femaleMedian": "616"
      }
    }
  },
  "Cargo and freight agents": {
    "ageData": {
      "2015": {
        "total": "21",
        "16to19": "0",
        "20to24": "2",
        "25to34": "4",
        "35to44": "3",
        "45to54": "7",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Cargo and freight agents",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Couriers and messengers": {
    "ageData": {
      "2015": {
        "total": "235",
        "16to19": "7",
        "20to24": "21",
        "25to34": "51",
        "35to44": "41",
        "45to54": "58",
        "55to64": "44",
        "65+": "12",
        "medianAge": "44"
      }
    },
    "title": "Couriers and messengers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "235",
        "women": "14.3",
        "white": "20.4",
        "black": "4.0",
        "asian": "18.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "153",
        "median": "752",
        "maleWorkers": "134",
        "maleMedian": "750",
        "femaleWorkers": "19",
        "femaleMedian": "-"
      }
    }
  },
  "Dispatchers": {
    "ageData": {
      "2015": {
        "total": "277",
        "16to19": "3",
        "20to24": "28",
        "25to34": "72",
        "35to44": "63",
        "45to54": "67",
        "55to64": "37",
        "65+": "8",
        "medianAge": "37"
      }
    },
    "title": "Dispatchers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "277",
        "women": "56.3",
        "white": "13.4",
        "black": "2.3",
        "asian": "12.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "250",
        "median": "698",
        "maleWorkers": "109",
        "maleMedian": "759",
        "femaleWorkers": "141",
        "femaleMedian": "655"
      }
    }
  },
  "Meter readers, utilities": {
    "ageData": {
      "2015": {
        "total": "41",
        "16to19": "1",
        "20to24": "4",
        "25to34": "6",
        "35to44": "11",
        "45to54": "12",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Meter readers, utilities",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "41",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "34",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Postal service clerks": {
    "ageData": {
      "2015": {
        "total": "130",
        "16to19": "0",
        "20to24": "9",
        "25to34": "15",
        "35to44": "16",
        "45to54": "33",
        "55to64": "48",
        "65+": "8",
        "medianAge": "48"
      }
    },
    "title": "Postal service clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "130",
        "women": "46.0",
        "white": "33.5",
        "black": "8.7",
        "asian": "6.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "127",
        "median": "927",
        "maleWorkers": "76",
        "maleMedian": "974",
        "femaleWorkers": "51",
        "femaleMedian": "833"
      }
    }
  },
  "Postal service mail carriers": {
    "ageData": {
      "2015": {
        "total": "320",
        "16to19": "2",
        "20to24": "10",
        "25to34": "54",
        "35to44": "50",
        "45to54": "100",
        "55to64": "93",
        "65+": "13",
        "medianAge": "93"
      }
    },
    "title": "Postal service mail carriers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "320",
        "women": "41.2",
        "white": "20.3",
        "black": "6.8",
        "asian": "13.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "302",
        "median": "954",
        "maleWorkers": "187",
        "maleMedian": "1,021",
        "femaleWorkers": "115",
        "femaleMedian": "854"
      }
    }
  },
  "Postal service mail sorters, processors, and processing machine operators": {
    "ageData": {
      "2015": {
        "total": "64",
        "16to19": "0",
        "20to24": "6",
        "25to34": "7",
        "35to44": "8",
        "45to54": "23",
        "55to64": "17",
        "65+": "3",
        "medianAge": "17"
      }
    },
    "title": "Postal service mail sorters, processors, and processing machine operators",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "64",
        "women": "50.0",
        "white": "29.9",
        "black": "8.1",
        "asian": "9.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "53",
        "median": "828",
        "maleWorkers": "27",
        "maleMedian": "-",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Production, planning, and expediting clerks": {
    "ageData": {
      "2015": {
        "total": "286",
        "16to19": "2",
        "20to24": "19",
        "25to34": "68",
        "35to44": "63",
        "45to54": "72",
        "55to64": "56",
        "65+": "7",
        "medianAge": "56"
      }
    },
    "title": "Production, planning, and expediting clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "286",
        "women": "55.0",
        "white": "10.3",
        "black": "4.6",
        "asian": "12.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "256",
        "median": "838",
        "maleWorkers": "116",
        "maleMedian": "978",
        "femaleWorkers": "141",
        "femaleMedian": "732"
      }
    }
  },
  "Shipping, receiving, and traffic clerks": {
    "ageData": {
      "2015": {
        "total": "575",
        "16to19": "11",
        "20to24": "78",
        "25to34": "145",
        "35to44": "110",
        "45to54": "117",
        "55to64": "91",
        "65+": "22",
        "medianAge": "91"
      }
    },
    "title": "Shipping, receiving, and traffic clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "575",
        "women": "29.5",
        "white": "14.7",
        "black": "3.5",
        "asian": "27.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "502",
        "median": "591",
        "maleWorkers": "354",
        "maleMedian": "604",
        "femaleWorkers": "148",
        "femaleMedian": "566"
      }
    }
  },
  "Stock clerks and order fillers": {
    "ageData": {
      "2015": {
        "total": "1,529",
        "16to19": "142",
        "20to24": "325",
        "25to34": "331",
        "35to44": "223",
        "45to54": "256",
        "55to64": "187",
        "65+": "65",
        "medianAge": "187"
      }
    },
    "title": "Stock clerks and order fillers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,529",
        "women": "35.8",
        "white": "18.2",
        "black": "4.5",
        "asian": "20.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,027",
        "median": "520",
        "maleWorkers": "651",
        "maleMedian": "537",
        "femaleWorkers": "376",
        "femaleMedian": "506"
      }
    }
  },
  "Weighers, measurers, checkers, and samplers, recordkeeping": {
    "ageData": {
      "2015": {
        "total": "72",
        "16to19": "1",
        "20to24": "7",
        "25to34": "18",
        "35to44": "17",
        "45to54": "17",
        "55to64": "11",
        "65+": "0",
        "medianAge": "11"
      }
    },
    "title": "Weighers, measurers, checkers, and samplers, recordkeeping",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "72",
        "women": "57.8",
        "white": "13.1",
        "black": "6.6",
        "asian": "23.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "59",
        "median": "629",
        "maleWorkers": "29",
        "maleMedian": "-",
        "femaleWorkers": "31",
        "femaleMedian": "-"
      }
    }
  },
  "Secretaries and administrative assistants": {
    "ageData": {
      "2015": {
        "total": "2,870",
        "16to19": "20",
        "20to24": "169",
        "25to34": "497",
        "35to44": "552",
        "45to54": "724",
        "55to64": "687",
        "65+": "221",
        "medianAge": "687"
      }
    },
    "title": "Secretaries and administrative assistants",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2,870",
        "women": "94.5",
        "white": "10.4",
        "black": "3.5",
        "asian": "11.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,223",
        "median": "687",
        "maleWorkers": "124",
        "maleMedian": "786",
        "femaleWorkers": "2,099",
        "femaleMedian": "683"
      }
    }
  },
  "Computer operators": {
    "ageData": {
      "2015": {
        "total": "69",
        "16to19": "0",
        "20to24": "5",
        "25to34": "15",
        "35to44": "14",
        "45to54": "17",
        "55to64": "15",
        "65+": "2",
        "medianAge": "15"
      }
    },
    "title": "Computer operators",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "69",
        "women": "46.8",
        "white": "13.5",
        "black": "5.3",
        "asian": "13.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "58",
        "median": "751",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "33",
        "femaleMedian": "-"
      }
    }
  },
  "Data entry keyers": {
    "ageData": {
      "2015": {
        "total": "281",
        "16to19": "7",
        "20to24": "34",
        "25to34": "75",
        "35to44": "52",
        "45to54": "50",
        "55to64": "45",
        "65+": "19",
        "medianAge": "45"
      }
    },
    "title": "Data entry keyers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "281",
        "women": "74.3",
        "white": "13.8",
        "black": "7.7",
        "asian": "15.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "223",
        "median": "619",
        "maleWorkers": "55",
        "maleMedian": "589",
        "femaleWorkers": "169",
        "femaleMedian": "638"
      }
    }
  },
  "Word processors and typists": {
    "ageData": {
      "2015": {
        "total": "103",
        "16to19": "2",
        "20to24": "7",
        "25to34": "15",
        "35to44": "20",
        "45to54": "21",
        "55to64": "28",
        "65+": "11",
        "medianAge": "28"
      }
    },
    "title": "Word processors and typists",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "103",
        "women": "92.1",
        "white": "15.0",
        "black": "5.0",
        "asian": "9.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "68",
        "median": "650",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "62",
        "femaleMedian": "639"
      }
    }
  },
  "Desktop publishers": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Desktop publishers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Insurance claims and policy processing clerks": {
    "ageData": {
      "2015": {
        "total": "287",
        "16to19": "1",
        "20to24": "23",
        "25to34": "76",
        "35to44": "62",
        "45to54": "59",
        "55to64": "53",
        "65+": "12",
        "medianAge": "53"
      }
    },
    "title": "Insurance claims and policy processing clerks",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "287",
        "women": "77.1",
        "white": "17.7",
        "black": "5.0",
        "asian": "7.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "259",
        "median": "689",
        "maleWorkers": "56",
        "maleMedian": "762",
        "femaleWorkers": "203",
        "femaleMedian": "675"
      }
    }
  },
  "Mail clerks and mail machine operators, except postal service": {
    "ageData": {
      "2015": {
        "total": "81",
        "16to19": "2",
        "20to24": "10",
        "25to34": "10",
        "35to44": "10",
        "45to54": "21",
        "55to64": "24",
        "65+": "4",
        "medianAge": "24"
      }
    },
    "title": "Mail clerks and mail machine operators, except postal service",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "81",
        "women": "59.4",
        "white": "25.1",
        "black": "10.9",
        "asian": "18.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "63",
        "median": "563",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "39",
        "femaleMedian": "-"
      }
    }
  },
  "Office clerks, general": {
    "ageData": {
      "2015": {
        "total": "1,288",
        "16to19": "57",
        "20to24": "173",
        "25to34": "255",
        "35to44": "219",
        "45to54": "256",
        "55to64": "245",
        "65+": "84",
        "medianAge": "245"
      }
    },
    "title": "Office clerks, general",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,288",
        "women": "82.3",
        "white": "13.4",
        "black": "6.7",
        "asian": "18.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "929",
        "median": "620",
        "maleWorkers": "156",
        "maleMedian": "609",
        "femaleWorkers": "773",
        "femaleMedian": "622"
      }
    }
  },
  "Office machine operators, except computer": {
    "ageData": {
      "2015": {
        "total": "37",
        "16to19": "1",
        "20to24": "4",
        "25to34": "7",
        "35to44": "6",
        "45to54": "13",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Office machine operators, except computer",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "37",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "31",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Proofreaders and copy markers": {
    "ageData": {
      "2015": {
        "total": "8",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "0",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Proofreaders and copy markers",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Statistical assistants": {
    "ageData": {
      "2015": {
        "total": "17",
        "16to19": "0",
        "20to24": "4",
        "25to34": "2",
        "35to44": "5",
        "45to54": "2",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Statistical assistants",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "17",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Office and administrative support workers, all other": {
    "ageData": {
      "2015": {
        "total": "477",
        "16to19": "7",
        "20to24": "35",
        "25to34": "126",
        "35to44": "87",
        "45to54": "108",
        "55to64": "94",
        "65+": "19",
        "medianAge": "94"
      }
    },
    "title": "Office and administrative support workers, all other",
    "depth": 3,
    "parent": "Office and administrative support occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "477",
        "women": "77.4",
        "white": "12.9",
        "black": "3.9",
        "asian": "13.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "391",
        "median": "745",
        "maleWorkers": "93",
        "maleMedian": "852",
        "femaleWorkers": "298",
        "femaleMedian": "718"
      }
    }
  },
  "Natural resources, construction, and maintenance occupations": {
    "ageData": {
      "2015": {
        "total": "13,733",
        "16to19": "293",
        "20to24": "1,169",
        "25to34": "3,248",
        "35to44": "3,258",
        "45to54": "3,099",
        "55to64": "2,187",
        "65+": "478",
        "medianAge": "2,187"
      }
    },
    "title": "Natural resources, construction, and maintenance occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "13,733",
        "women": "4.7",
        "white": "7.3",
        "black": "1.9",
        "asian": "29.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "10,834",
        "median": "761",
        "maleWorkers": "10,381",
        "maleMedian": "770",
        "femaleWorkers": "453",
        "femaleMedian": "580"
      }
    }
  },
  "Farming, fishing, and forestry occupations": {
    "ageData": {
      "2015": {
        "total": "1,073",
        "16to19": "78",
        "20to24": "113",
        "25to34": "268",
        "35to44": "226",
        "45to54": "193",
        "55to64": "145",
        "65+": "50",
        "medianAge": "145"
      }
    },
    "title": "Farming, fishing, and forestry occupations",
    "depth": 2,
    "parent": "Natural resources, construction, and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,073",
        "women": "24.2",
        "white": "5.1",
        "black": "1.3",
        "asian": "45.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "810",
        "median": "464",
        "maleWorkers": "637",
        "maleMedian": "477",
        "femaleWorkers": "174",
        "femaleMedian": "437"
      }
    }
  },
  "First-line supervisors of farming, fishing, and forestry workers": {
    "ageData": {
      "2015": {
        "total": "54",
        "16to19": "0",
        "20to24": "3",
        "25to34": "14",
        "35to44": "10",
        "45to54": "9",
        "55to64": "13",
        "65+": "4",
        "medianAge": "13"
      }
    },
    "title": "First-line supervisors of farming, fishing, and forestry workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "54",
        "women": "21.2",
        "white": "1.4",
        "black": "0.0",
        "asian": "41.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "42",
        "median": "-",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Agricultural inspectors": {
    "ageData": {
      "2015": {
        "total": "18",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "2",
        "45to54": "3",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Agricultural inspectors",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Animal breeders": {
    "ageData": {
      "2015": {
        "total": "8",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Animal breeders",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Graders and sorters, agricultural products": {
    "ageData": {
      "2015": {
        "total": "97",
        "16to19": "3",
        "20to24": "10",
        "25to34": "27",
        "35to44": "20",
        "45to54": "16",
        "55to64": "18",
        "65+": "2",
        "medianAge": "18"
      }
    },
    "title": "Graders and sorters, agricultural products",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "97",
        "women": "61.7",
        "white": "18.6",
        "black": "3.8",
        "asian": "54.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "83",
        "median": "486",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "51",
        "femaleMedian": "468"
      }
    }
  },
  "Miscellaneous agricultural workers": {
    "ageData": {
      "2015": {
        "total": "789",
        "16to19": "71",
        "20to24": "93",
        "25to34": "198",
        "35to44": "167",
        "45to54": "135",
        "55to64": "89",
        "65+": "36",
        "medianAge": "89"
      }
    },
    "title": "Miscellaneous agricultural workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "789",
        "women": "21.9",
        "white": "3.5",
        "black": "1.1",
        "asian": "50.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "613",
        "median": "445",
        "maleWorkers": "511",
        "maleMedian": "460",
        "femaleWorkers": "102",
        "femaleMedian": "398"
      }
    }
  },
  "Fishers and related fishing workers": {
    "ageData": {
      "2015": {
        "total": "39",
        "16to19": "3",
        "20to24": "3",
        "25to34": "8",
        "35to44": "7",
        "45to54": "11",
        "55to64": "7",
        "65+": "0",
        "medianAge": "7"
      }
    },
    "title": "Fishers and related fishing workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "39",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "11",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Hunters and trappers": {
    "ageData": {
      "2015": {
        "total": "0",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Hunters and trappers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "0",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Forest and conservation workers": {
    "ageData": {
      "2015": {
        "total": "18",
        "16to19": "1",
        "20to24": "1",
        "25to34": "5",
        "35to44": "4",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Forest and conservation workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Logging workers": {
    "ageData": {
      "2015": {
        "total": "51",
        "16to19": "0",
        "20to24": "3",
        "25to34": "9",
        "35to44": "13",
        "45to54": "15",
        "55to64": "7",
        "65+": "5",
        "medianAge": "7"
      }
    },
    "title": "Logging workers",
    "depth": 3,
    "parent": "Farming, fishing, and forestry occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "51",
        "women": "2.8",
        "white": "10.4",
        "black": "0.0",
        "asian": "11.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "31",
        "median": "-",
        "maleWorkers": "31",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Construction and extraction occupations": {
    "ageData": {
      "2015": {
        "total": "7,652",
        "16to19": "142",
        "20to24": "630",
        "25to34": "1,857",
        "35to44": "1,918",
        "45to54": "1,702",
        "55to64": "1,155",
        "65+": "248",
        "medianAge": "1,155"
      }
    },
    "title": "Construction and extraction occupations",
    "depth": 2,
    "parent": "Natural resources, construction, and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "7,652",
        "women": "2.7",
        "white": "6.9",
        "black": "1.3",
        "asian": "33.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5,722",
        "median": "749",
        "maleWorkers": "5,586",
        "maleMedian": "751",
        "femaleWorkers": "137",
        "femaleMedian": "704"
      }
    }
  },
  "First-line supervisors of construction trades and extraction workers": {
    "ageData": {
      "2015": {
        "total": "712",
        "16to19": "3",
        "20to24": "18",
        "25to34": "120",
        "35to44": "180",
        "45to54": "215",
        "55to64": "147",
        "65+": "28",
        "medianAge": "147"
      }
    },
    "title": "First-line supervisors of construction trades and extraction workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "712",
        "women": "3.3",
        "white": "6.2",
        "black": "1.2",
        "asian": "16.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "560",
        "median": "1,040",
        "maleWorkers": "540",
        "maleMedian": "1,047",
        "femaleWorkers": "20",
        "femaleMedian": "-"
      }
    }
  },
  "Boilermakers": {
    "ageData": {
      "2015": {
        "total": "20",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "5",
        "45to54": "4",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Boilermakers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "20",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Brickmasons, blockmasons, and stonemasons": {
    "ageData": {
      "2015": {
        "total": "172",
        "16to19": "3",
        "20to24": "11",
        "25to34": "54",
        "35to44": "49",
        "45to54": "31",
        "55to64": "20",
        "65+": "5",
        "medianAge": "20"
      }
    },
    "title": "Brickmasons, blockmasons, and stonemasons",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "172",
        "women": "0.7",
        "white": "5.3",
        "black": "0.0",
        "asian": "43.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "122",
        "median": "652",
        "maleWorkers": "122",
        "maleMedian": "652",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Carpenters": {
    "ageData": {
      "2015": {
        "total": "1,281",
        "16to19": "15",
        "20to24": "96",
        "25to34": "295",
        "35to44": "336",
        "45to54": "302",
        "55to64": "195",
        "65+": "41",
        "medianAge": "195"
      }
    },
    "title": "Carpenters",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,281",
        "women": "1.8",
        "white": "5.4",
        "black": "1.2",
        "asian": "32.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "802",
        "median": "687",
        "maleWorkers": "792",
        "maleMedian": "687",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Carpet, floor, and tile installers and finishers": {
    "ageData": {
      "2015": {
        "total": "156",
        "16to19": "2",
        "20to24": "7",
        "25to34": "45",
        "35to44": "45",
        "45to54": "29",
        "55to64": "22",
        "65+": "7",
        "medianAge": "22"
      }
    },
    "title": "Carpet, floor, and tile installers and finishers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "156",
        "women": "1.7",
        "white": "6.2",
        "black": "2.1",
        "asian": "47.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "89",
        "median": "637",
        "maleWorkers": "89",
        "maleMedian": "634",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Cement masons, concrete finishers, and terrazzo workers": {
    "ageData": {
      "2015": {
        "total": "54",
        "16to19": "1",
        "20to24": "5",
        "25to34": "15",
        "35to44": "14",
        "45to54": "9",
        "55to64": "7",
        "65+": "3",
        "medianAge": "7"
      }
    },
    "title": "Cement masons, concrete finishers, and terrazzo workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "54",
        "women": "0.2",
        "white": "12.1",
        "black": "0.0",
        "asian": "49.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Construction laborers": {
    "ageData": {
      "2015": {
        "total": "1,649",
        "16to19": "52",
        "20to24": "179",
        "25to34": "435",
        "35to44": "425",
        "45to54": "318",
        "55to64": "198",
        "65+": "41",
        "medianAge": "198"
      }
    },
    "title": "Construction laborers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,649",
        "women": "2.9",
        "white": "8.1",
        "black": "1.9",
        "asian": "45.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,181",
        "median": "639",
        "maleWorkers": "1,155",
        "maleMedian": "642",
        "femaleWorkers": "25",
        "femaleMedian": "-"
      }
    }
  },
  "Paving, surfacing, and tamping equipment operators": {
    "ageData": {
      "2015": {
        "total": "12",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "2",
        "45to54": "4",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Paving, surfacing, and tamping equipment operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "12",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "10",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Pile-driver operators": {
    "ageData": {
      "2015": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Pile-driver operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Operating engineers and other construction equipment operators": {
    "ageData": {
      "2015": {
        "total": "357",
        "16to19": "3",
        "20to24": "25",
        "25to34": "85",
        "35to44": "69",
        "45to54": "89",
        "55to64": "68",
        "65+": "19",
        "medianAge": "68"
      }
    },
    "title": "Operating engineers and other construction equipment operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "357",
        "women": "1.9",
        "white": "7.5",
        "black": "0.1",
        "asian": "21.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "324",
        "median": "856",
        "maleWorkers": "318",
        "maleMedian": "859",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Drywall installers, ceiling tile installers, and tapers": {
    "ageData": {
      "2015": {
        "total": "151",
        "16to19": "0",
        "20to24": "11",
        "25to34": "43",
        "35to44": "59",
        "45to54": "22",
        "55to64": "11",
        "65+": "4",
        "medianAge": "11"
      }
    },
    "title": "Drywall installers, ceiling tile installers, and tapers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "151",
        "women": "1.6",
        "white": "5.5",
        "black": "0.2",
        "asian": "61.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "121",
        "median": "596",
        "maleWorkers": "119",
        "maleMedian": "595",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Electricians": {
    "ageData": {
      "2015": {
        "total": "773",
        "16to19": "14",
        "20to24": "78",
        "25to34": "185",
        "35to44": "178",
        "45to54": "173",
        "55to64": "122",
        "65+": "23",
        "medianAge": "122"
      }
    },
    "title": "Electricians",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "773",
        "women": "2.3",
        "white": "8.8",
        "black": "1.9",
        "asian": "19.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "651",
        "median": "888",
        "maleWorkers": "632",
        "maleMedian": "891",
        "femaleWorkers": "19",
        "femaleMedian": "-"
      }
    }
  },
  "Glaziers": {
    "ageData": {
      "2015": {
        "total": "47",
        "16to19": "1",
        "20to24": "8",
        "25to34": "8",
        "35to44": "12",
        "45to54": "9",
        "55to64": "8",
        "65+": "1",
        "medianAge": "8"
      }
    },
    "title": "Glaziers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "47",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Insulation workers": {
    "ageData": {
      "2015": {
        "total": "49",
        "16to19": "1",
        "20to24": "4",
        "25to34": "14",
        "35to44": "13",
        "45to54": "9",
        "55to64": "7",
        "65+": "0",
        "medianAge": "7"
      }
    },
    "title": "Insulation workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "49",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "43",
        "median": "-",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Painters, construction and maintenance": {
    "ageData": {
      "2015": {
        "total": "572",
        "16to19": "10",
        "20to24": "39",
        "25to34": "124",
        "35to44": "158",
        "45to54": "136",
        "55to64": "86",
        "65+": "19",
        "medianAge": "86"
      }
    },
    "title": "Painters, construction and maintenance",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "572",
        "women": "5.7",
        "white": "5.6",
        "black": "1.8",
        "asian": "49.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "344",
        "median": "585",
        "maleWorkers": "330",
        "maleMedian": "587",
        "femaleWorkers": "14",
        "femaleMedian": "-"
      }
    }
  },
  "Paperhangers": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Paperhangers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Pipelayers, plumbers, pipefitters, and steamfitters": {
    "ageData": {
      "2015": {
        "total": "573",
        "16to19": "9",
        "20to24": "37",
        "25to34": "143",
        "35to44": "140",
        "45to54": "132",
        "55to64": "89",
        "65+": "24",
        "medianAge": "89"
      }
    },
    "title": "Pipelayers, plumbers, pipefitters, and steamfitters",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "573",
        "women": "0.7",
        "white": "6.8",
        "black": "1.1",
        "asian": "25.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "456",
        "median": "863",
        "maleWorkers": "455",
        "maleMedian": "862",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Plasterers and stucco masons": {
    "ageData": {
      "2015": {
        "total": "28",
        "16to19": "1",
        "20to24": "3",
        "25to34": "8",
        "35to44": "9",
        "45to54": "3",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Plasterers and stucco masons",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "28",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "20",
        "median": "-",
        "maleWorkers": "19",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Reinforcing iron and rebar workers": {
    "ageData": {
      "2015": {
        "total": "10",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "1",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Reinforcing iron and rebar workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Roofers": {
    "ageData": {
      "2015": {
        "total": "221",
        "16to19": "6",
        "20to24": "22",
        "25to34": "73",
        "35to44": "59",
        "45to54": "37",
        "55to64": "21",
        "65+": "4",
        "medianAge": "21"
      }
    },
    "title": "Roofers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "221",
        "women": "2.3",
        "white": "6.0",
        "black": "1.4",
        "asian": "51.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "171",
        "median": "584",
        "maleWorkers": "170",
        "maleMedian": "580",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Sheet metal workers": {
    "ageData": {
      "2015": {
        "total": "122",
        "16to19": "3",
        "20to24": "11",
        "25to34": "28",
        "35to44": "31",
        "45to54": "24",
        "55to64": "23",
        "65+": "3",
        "medianAge": "23"
      }
    },
    "title": "Sheet metal workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "122",
        "women": "4.5",
        "white": "2.4",
        "black": "0.7",
        "asian": "15.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "106",
        "median": "766",
        "maleWorkers": "100",
        "maleMedian": "776",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Structural iron and steel workers": {
    "ageData": {
      "2015": {
        "total": "58",
        "16to19": "1",
        "20to24": "2",
        "25to34": "14",
        "35to44": "12",
        "45to54": "18",
        "55to64": "10",
        "65+": "1",
        "medianAge": "10"
      }
    },
    "title": "Structural iron and steel workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "58",
        "women": "2.2",
        "white": "6.4",
        "black": "2.8",
        "asian": "19.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "54",
        "median": "869",
        "maleWorkers": "52",
        "maleMedian": "864",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Solar photovoltaic installers": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "3",
        "45to54": "2",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Solar photovoltaic installers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers, construction trades": {
    "ageData": {
      "2015": {
        "total": "52",
        "16to19": "5",
        "20to24": "13",
        "25to34": "13",
        "35to44": "8",
        "45to54": "8",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Helpers, construction trades",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "52",
        "women": "1.3",
        "white": "7.0",
        "black": "2.8",
        "asian": "44.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "47",
        "median": "-",
        "maleWorkers": "47",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Construction and building inspectors": {
    "ageData": {
      "2015": {
        "total": "90",
        "16to19": "0",
        "20to24": "2",
        "25to34": "14",
        "35to44": "18",
        "45to54": "24",
        "55to64": "22",
        "65+": "10",
        "medianAge": "22"
      }
    },
    "title": "Construction and building inspectors",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "90",
        "women": "9.9",
        "white": "9.5",
        "black": "1.0",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "67",
        "median": "939",
        "maleWorkers": "58",
        "maleMedian": "965",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Elevator installers and repairers": {
    "ageData": {
      "2015": {
        "total": "30",
        "16to19": "0",
        "20to24": "2",
        "25to34": "8",
        "35to44": "8",
        "45to54": "6",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Elevator installers and repairers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "30",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Fence erectors": {
    "ageData": {
      "2015": {
        "total": "34",
        "16to19": "2",
        "20to24": "3",
        "25to34": "8",
        "35to44": "11",
        "45to54": "6",
        "55to64": "1",
        "65+": "2",
        "medianAge": "1"
      }
    },
    "title": "Fence erectors",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "34",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "33",
        "median": "-",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Hazardous materials removal workers": {
    "ageData": {
      "2015": {
        "total": "42",
        "16to19": "1",
        "20to24": "4",
        "25to34": "11",
        "35to44": "6",
        "45to54": "12",
        "55to64": "8",
        "65+": "0",
        "medianAge": "8"
      }
    },
    "title": "Hazardous materials removal workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "42",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Highway maintenance workers": {
    "ageData": {
      "2015": {
        "total": "103",
        "16to19": "4",
        "20to24": "8",
        "25to34": "15",
        "35to44": "10",
        "45to54": "33",
        "55to64": "29",
        "65+": "4",
        "medianAge": "29"
      }
    },
    "title": "Highway maintenance workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "103",
        "women": "2.0",
        "white": "13.4",
        "black": "0.9",
        "asian": "16.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "91",
        "median": "754",
        "maleWorkers": "91",
        "maleMedian": "755",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Rail-track laying and maintenance equipment operators": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "2",
        "45to54": "3",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Rail-track laying and maintenance equipment operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Septic tank servicers and sewer pipe cleaners": {
    "ageData": {
      "2015": {
        "total": "12",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "1",
        "45to54": "3",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Septic tank servicers and sewer pipe cleaners",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "12",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous construction and related workers": {
    "ageData": {
      "2015": {
        "total": "32",
        "16to19": "0",
        "20to24": "2",
        "25to34": "8",
        "35to44": "7",
        "45to54": "9",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Miscellaneous construction and related workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "32",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "25",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Derrick, rotary drill, and service unit operators, oil, gas, and mining": {
    "ageData": {
      "2015": {
        "total": "34",
        "16to19": "1",
        "20to24": "4",
        "25to34": "14",
        "35to44": "7",
        "45to54": "5",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Derrick, rotary drill, and service unit operators, oil, gas, and mining",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "34",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "28",
        "median": "-",
        "maleWorkers": "27",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Earth drillers, except oil and gas": {
    "ageData": {
      "2015": {
        "total": "29",
        "16to19": "1",
        "20to24": "2",
        "25to34": "7",
        "35to44": "9",
        "45to54": "6",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Earth drillers, except oil and gas",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "30",
        "median": "-",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Explosives workers, ordnance handling experts, and blasters": {
    "ageData": {
      "2015": {
        "total": "9",
        "16to19": "1",
        "20to24": "0",
        "25to34": "3",
        "35to44": "1",
        "45to54": "3",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Explosives workers, ordnance handling experts, and blasters",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Mining machine operators": {
    "ageData": {
      "2015": {
        "total": "67",
        "16to19": "1",
        "20to24": "11",
        "25to34": "20",
        "35to44": "19",
        "45to54": "9",
        "55to64": "7",
        "65+": "0",
        "medianAge": "7"
      }
    },
    "title": "Mining machine operators",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "67",
        "women": "2.5",
        "white": "4.1",
        "black": "0.0",
        "asian": "16.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "68",
        "median": "1,106",
        "maleWorkers": "65",
        "maleMedian": "1,098",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Roof bolters, mining": {
    "ageData": {
      "2015": {
        "total": "2",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Roof bolters, mining",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Roustabouts, oil and gas": {
    "ageData": {
      "2015": {
        "total": "9",
        "16to19": "1",
        "20to24": "1",
        "25to34": "3",
        "35to44": "2",
        "45to54": "0",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Roustabouts, oil and gas",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers--extraction workers": {
    "ageData": {
      "2015": {
        "total": "4",
        "16to19": "0",
        "20to24": "2",
        "25to34": "1",
        "35to44": "0",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Helpers--extraction workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Other extraction workers": {
    "ageData": {
      "2015": {
        "total": "64",
        "16to19": "2",
        "20to24": "9",
        "25to34": "26",
        "35to44": "9",
        "45to54": "7",
        "55to64": "9",
        "65+": "1",
        "medianAge": "9"
      }
    },
    "title": "Other extraction workers",
    "depth": 3,
    "parent": "Construction and extraction occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "64",
        "women": "3.8",
        "white": "3.1",
        "black": "0.5",
        "asian": "26.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "61",
        "median": "900",
        "maleWorkers": "58",
        "maleMedian": "918",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Installation, maintenance, and repair occupations": {
    "ageData": {
      "2015": {
        "total": "5,008",
        "16to19": "73",
        "20to24": "426",
        "25to34": "1,123",
        "35to44": "1,114",
        "45to54": "1,204",
        "55to64": "888",
        "65+": "180",
        "medianAge": "888"
      }
    },
    "title": "Installation, maintenance, and repair occupations",
    "depth": 2,
    "parent": "Natural resources, construction, and maintenance occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5,008",
        "women": "3.5",
        "white": "8.3",
        "black": "3.1",
        "asian": "18.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4,301",
        "median": "839",
        "maleWorkers": "4,159",
        "maleMedian": "842",
        "femaleWorkers": "143",
        "femaleMedian": "761"
      }
    }
  },
  "First-line supervisors of mechanics, installers, and repairers": {
    "ageData": {
      "2015": {
        "total": "262",
        "16to19": "0",
        "20to24": "1",
        "25to34": "32",
        "35to44": "63",
        "45to54": "86",
        "55to64": "72",
        "65+": "7",
        "medianAge": "72"
      }
    },
    "title": "First-line supervisors of mechanics, installers, and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "262",
        "women": "6.1",
        "white": "8.5",
        "black": "3.3",
        "asian": "11.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "270",
        "median": "1,032",
        "maleWorkers": "252",
        "maleMedian": "1,033",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Computer, automated teller, and office machine repairers": {
    "ageData": {
      "2015": {
        "total": "241",
        "16to19": "6",
        "20to24": "22",
        "25to34": "63",
        "35to44": "54",
        "45to54": "47",
        "55to64": "40",
        "65+": "7",
        "medianAge": "40"
      }
    },
    "title": "Computer, automated teller, and office machine repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "241",
        "women": "13.2",
        "white": "18.4",
        "black": "8.2",
        "asian": "9.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "194",
        "median": "856",
        "maleWorkers": "166",
        "maleMedian": "865",
        "femaleWorkers": "28",
        "femaleMedian": "-"
      }
    }
  },
  "Radio and telecommunications equipment installers and repairers": {
    "ageData": {
      "2015": {
        "total": "158",
        "16to19": "2",
        "20to24": "19",
        "25to34": "42",
        "35to44": "36",
        "45to54": "33",
        "55to64": "22",
        "65+": "4",
        "medianAge": "22"
      }
    },
    "title": "Radio and telecommunications equipment installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "158",
        "women": "8.5",
        "white": "11.7",
        "black": "8.2",
        "asian": "11.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "139",
        "median": "862",
        "maleWorkers": "126",
        "maleMedian": "879",
        "femaleWorkers": "13",
        "femaleMedian": "-"
      }
    }
  },
  "Avionics technicians": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "1",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Avionics technicians",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electric motor, power tool, and related repairers": {
    "ageData": {
      "2015": {
        "total": "23",
        "16to19": "0",
        "20to24": "3",
        "25to34": "4",
        "35to44": "6",
        "45to54": "7",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Electric motor, power tool, and related repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "22",
        "median": "-",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical and electronics installers and repairers, transportation equipment": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Electrical and electronics installers and repairers, transportation equipment",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical and electronics repairers, industrial and utility": {
    "ageData": {
      "2015": {
        "total": "20",
        "16to19": "0",
        "20to24": "0",
        "25to34": "5",
        "35to44": "5",
        "45to54": "5",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Electrical and electronics repairers, industrial and utility",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "20",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electronic equipment installers and repairers, motor vehicles": {
    "ageData": {
      "2015": {
        "total": "18",
        "16to19": "0",
        "20to24": "3",
        "25to34": "4",
        "35to44": "1",
        "45to54": "5",
        "55to64": "5",
        "65+": "0",
        "medianAge": "5"
      }
    },
    "title": "Electronic equipment installers and repairers, motor vehicles",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "18",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Electronic home entertainment equipment installers and repairers": {
    "ageData": {
      "2015": {
        "total": "38",
        "16to19": "1",
        "20to24": "3",
        "25to34": "11",
        "35to44": "8",
        "45to54": "8",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Electronic home entertainment equipment installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "38",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "30",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Security and fire alarm systems installers": {
    "ageData": {
      "2015": {
        "total": "74",
        "16to19": "1",
        "20to24": "8",
        "25to34": "14",
        "35to44": "21",
        "45to54": "13",
        "55to64": "15",
        "65+": "2",
        "medianAge": "15"
      }
    },
    "title": "Security and fire alarm systems installers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "74",
        "women": "3.8",
        "white": "6.0",
        "black": "1.0",
        "asian": "23.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "67",
        "median": "911",
        "maleWorkers": "65",
        "maleMedian": "913",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Aircraft mechanics and service technicians": {
    "ageData": {
      "2015": {
        "total": "140",
        "16to19": "0",
        "20to24": "7",
        "25to34": "32",
        "35to44": "27",
        "45to54": "34",
        "55to64": "35",
        "65+": "6",
        "medianAge": "35"
      }
    },
    "title": "Aircraft mechanics and service technicians",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "140",
        "women": "5.2",
        "white": "8.3",
        "black": "3.1",
        "asian": "13.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "133",
        "median": "1,025",
        "maleWorkers": "125",
        "maleMedian": "1,032",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive body and related repairers": {
    "ageData": {
      "2015": {
        "total": "154",
        "16to19": "5",
        "20to24": "15",
        "25to34": "30",
        "35to44": "37",
        "45to54": "42",
        "55to64": "18",
        "65+": "7",
        "medianAge": "18"
      }
    },
    "title": "Automotive body and related repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "154",
        "women": "0.6",
        "white": "5.4",
        "black": "0.6",
        "asian": "22.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "120",
        "median": "846",
        "maleWorkers": "118",
        "maleMedian": "849",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive glass installers and repairers": {
    "ageData": {
      "2015": {
        "total": "22",
        "16to19": "1",
        "20to24": "4",
        "25to34": "4",
        "35to44": "4",
        "45to54": "5",
        "55to64": "3",
        "65+": "2",
        "medianAge": "3"
      }
    },
    "title": "Automotive glass installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "22",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive service technicians and mechanics": {
    "ageData": {
      "2015": {
        "total": "924",
        "16to19": "20",
        "20to24": "109",
        "25to34": "214",
        "35to44": "222",
        "45to54": "195",
        "55to64": "136",
        "65+": "28",
        "medianAge": "136"
      }
    },
    "title": "Automotive service technicians and mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "924",
        "women": "1.5",
        "white": "8.2",
        "black": "4.0",
        "asian": "25.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "710",
        "median": "722",
        "maleWorkers": "694",
        "maleMedian": "724",
        "femaleWorkers": "16",
        "femaleMedian": "-"
      }
    }
  },
  "Bus and truck mechanics and diesel engine specialists": {
    "ageData": {
      "2015": {
        "total": "345",
        "16to19": "3",
        "20to24": "31",
        "25to34": "84",
        "35to44": "82",
        "45to54": "82",
        "55to64": "51",
        "65+": "12",
        "medianAge": "51"
      }
    },
    "title": "Bus and truck mechanics and diesel engine specialists",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "345",
        "women": "0.1",
        "white": "7.5",
        "black": "2.6",
        "asian": "15.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "327",
        "median": "831",
        "maleWorkers": "327",
        "maleMedian": "830",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Heavy vehicle and mobile equipment service technicians and mechanics": {
    "ageData": {
      "2015": {
        "total": "233",
        "16to19": "2",
        "20to24": "21",
        "25to34": "55",
        "35to44": "41",
        "45to54": "66",
        "55to64": "39",
        "65+": "10",
        "medianAge": "39"
      }
    },
    "title": "Heavy vehicle and mobile equipment service technicians and mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "233",
        "women": "0.0",
        "white": "4.8",
        "black": "1.5",
        "asian": "14.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "206",
        "median": "928",
        "maleWorkers": "206",
        "maleMedian": "928",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Small engine mechanics": {
    "ageData": {
      "2015": {
        "total": "54",
        "16to19": "0",
        "20to24": "6",
        "25to34": "17",
        "35to44": "6",
        "45to54": "12",
        "55to64": "7",
        "65+": "5",
        "medianAge": "7"
      }
    },
    "title": "Small engine mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "54",
        "women": "3.1",
        "white": "0.0",
        "black": "1.3",
        "asian": "10.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers": {
    "ageData": {
      "2015": {
        "total": "81",
        "16to19": "8",
        "20to24": "15",
        "25to34": "26",
        "35to44": "15",
        "45to54": "8",
        "55to64": "5",
        "65+": "4",
        "medianAge": "5"
      }
    },
    "title": "Miscellaneous vehicle and mobile equipment mechanics, installers, and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "81",
        "women": "1.9",
        "white": "4.5",
        "black": "1.0",
        "asian": "24.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "66",
        "median": "592",
        "maleWorkers": "65",
        "maleMedian": "591",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Control and valve installers and repairers": {
    "ageData": {
      "2015": {
        "total": "29",
        "16to19": "0",
        "20to24": "1",
        "25to34": "7",
        "35to44": "6",
        "45to54": "8",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Control and valve installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "23",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Heating, air conditioning, and refrigeration mechanics and installers": {
    "ageData": {
      "2015": {
        "total": "408",
        "16to19": "3",
        "20to24": "40",
        "25to34": "115",
        "35to44": "92",
        "45to54": "88",
        "55to64": "61",
        "65+": "9",
        "medianAge": "61"
      }
    },
    "title": "Heating, air conditioning, and refrigeration mechanics and installers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "408",
        "women": "1.7",
        "white": "7.6",
        "black": "2.2",
        "asian": "21.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "341",
        "median": "806",
        "maleWorkers": "337",
        "maleMedian": "810",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Home appliance repairers": {
    "ageData": {
      "2015": {
        "total": "53",
        "16to19": "1",
        "20to24": "2",
        "25to34": "10",
        "35to44": "11",
        "45to54": "10",
        "55to64": "13",
        "65+": "5",
        "medianAge": "13"
      }
    },
    "title": "Home appliance repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "53",
        "women": "3.8",
        "white": "3.7",
        "black": "6.0",
        "asian": "26.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "36",
        "median": "-",
        "maleWorkers": "36",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial and refractory machinery mechanics": {
    "ageData": {
      "2015": {
        "total": "425",
        "16to19": "3",
        "20to24": "27",
        "25to34": "72",
        "35to44": "82",
        "45to54": "130",
        "55to64": "102",
        "65+": "10",
        "medianAge": "102"
      }
    },
    "title": "Industrial and refractory machinery mechanics",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "425",
        "women": "3.6",
        "white": "6.6",
        "black": "1.5",
        "asian": "13.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "394",
        "median": "895",
        "maleWorkers": "383",
        "maleMedian": "894",
        "femaleWorkers": "11",
        "femaleMedian": "-"
      }
    }
  },
  "Maintenance and repair workers, general": {
    "ageData": {
      "2015": {
        "total": "527",
        "16to19": "4",
        "20to24": "33",
        "25to34": "97",
        "35to44": "104",
        "45to54": "137",
        "55to64": "119",
        "65+": "32",
        "medianAge": "119"
      }
    },
    "title": "Maintenance and repair workers, general",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "527",
        "women": "3.2",
        "white": "11.2",
        "black": "2.4",
        "asian": "21.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "469",
        "median": "773",
        "maleWorkers": "459",
        "maleMedian": "771",
        "femaleWorkers": "10",
        "femaleMedian": "-"
      }
    }
  },
  "Maintenance workers, machinery": {
    "ageData": {
      "2015": {
        "total": "29",
        "16to19": "1",
        "20to24": "2",
        "25to34": "8",
        "35to44": "6",
        "45to54": "6",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Maintenance workers, machinery",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "31",
        "median": "-",
        "maleWorkers": "30",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Millwrights": {
    "ageData": {
      "2015": {
        "total": "57",
        "16to19": "0",
        "20to24": "2",
        "25to34": "14",
        "35to44": "15",
        "45to54": "16",
        "55to64": "9",
        "65+": "1",
        "medianAge": "9"
      }
    },
    "title": "Millwrights",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "57",
        "women": "3.3",
        "white": "5.6",
        "black": "0.5",
        "asian": "8.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "49",
        "median": "-",
        "maleWorkers": "48",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical power-line installers and repairers": {
    "ageData": {
      "2015": {
        "total": "119",
        "16to19": "0",
        "20to24": "12",
        "25to34": "25",
        "35to44": "29",
        "45to54": "31",
        "55to64": "18",
        "65+": "4",
        "medianAge": "18"
      }
    },
    "title": "Electrical power-line installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "119",
        "women": "1.2",
        "white": "5.2",
        "black": "1.7",
        "asian": "11.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "113",
        "median": "1,105",
        "maleWorkers": "112",
        "maleMedian": "1,105",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Telecommunications line installers and repairers": {
    "ageData": {
      "2015": {
        "total": "177",
        "16to19": "1",
        "20to24": "12",
        "25to34": "49",
        "35to44": "60",
        "45to54": "32",
        "55to64": "23",
        "65+": "0",
        "medianAge": "23"
      }
    },
    "title": "Telecommunications line installers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "177",
        "women": "6.0",
        "white": "12.9",
        "black": "3.1",
        "asian": "19.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "157",
        "median": "882",
        "maleWorkers": "148",
        "maleMedian": "880",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Precision instrument and equipment repairers": {
    "ageData": {
      "2015": {
        "total": "66",
        "16to19": "0",
        "20to24": "2",
        "25to34": "8",
        "35to44": "17",
        "45to54": "20",
        "55to64": "14",
        "65+": "5",
        "medianAge": "14"
      }
    },
    "title": "Precision instrument and equipment repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "66",
        "women": "4.8",
        "white": "6.3",
        "black": "3.3",
        "asian": "10.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "64",
        "median": "996",
        "maleWorkers": "60",
        "maleMedian": "1,009",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Wind turbine service technicians": {
    "ageData": {
      "2015": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "1",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Wind turbine service technicians",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "3",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Coin, vending, and amusement machine servicers and repairers": {
    "ageData": {
      "2015": {
        "total": "48",
        "16to19": "1",
        "20to24": "3",
        "25to34": "11",
        "35to44": "11",
        "45to54": "9",
        "55to64": "11",
        "65+": "2",
        "medianAge": "11"
      }
    },
    "title": "Coin, vending, and amusement machine servicers and repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "48",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "38",
        "median": "-",
        "maleWorkers": "34",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Commercial divers": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Commercial divers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Locksmiths and safe repairers": {
    "ageData": {
      "2015": {
        "total": "21",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "4",
        "45to54": "3",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Locksmiths and safe repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "21",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Manufactured building and mobile home installers": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "1",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Manufactured building and mobile home installers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Riggers": {
    "ageData": {
      "2015": {
        "total": "10",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "1",
        "45to54": "1",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Riggers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Signal and track switch repairers": {
    "ageData": {
      "2015": {
        "total": "8",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "3",
        "45to54": "2",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Signal and track switch repairers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers--installation, maintenance, and repair workers": {
    "ageData": {
      "2015": {
        "total": "28",
        "16to19": "7",
        "20to24": "5",
        "25to34": "6",
        "35to44": "2",
        "45to54": "7",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Helpers--installation, maintenance, and repair workers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "28",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Other installation, maintenance, and repair workers": {
    "ageData": {
      "2015": {
        "total": "200",
        "16to19": "2",
        "20to24": "15",
        "25to34": "46",
        "35to44": "40",
        "45to54": "52",
        "55to64": "35",
        "65+": "10",
        "medianAge": "35"
      }
    },
    "title": "Other installation, maintenance, and repair workers",
    "depth": 3,
    "parent": "Installation, maintenance, and repair occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "200",
        "women": "5.8",
        "white": "5.1",
        "black": "2.1",
        "asian": "25.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "150",
        "median": "792",
        "maleWorkers": "144",
        "maleMedian": "810",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Production, transportation, and material moving occupations": {
    "ageData": {
      "2015": {
        "total": "17,647",
        "16to19": "477",
        "20to24": "1,709",
        "25to34": "3,601",
        "35to44": "3,645",
        "45to54": "4,172",
        "55to64": "3,154",
        "65+": "888",
        "medianAge": "3,154"
      }
    },
    "title": "Production, transportation, and material moving occupations",
    "depth": 1,
    "parent": "",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "17,647",
        "women": "21.8",
        "white": "15.3",
        "black": "4.7",
        "asian": "22.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "14,504",
        "median": "656",
        "maleWorkers": "11,546",
        "maleMedian": "704",
        "femaleWorkers": "2,958",
        "femaleMedian": "512"
      }
    }
  },
  "Production occupations": {
    "ageData": {
      "2015": {
        "total": "8,522",
        "16to19": "156",
        "20to24": "776",
        "25to34": "1,860",
        "35to44": "1,809",
        "45to54": "2,051",
        "55to64": "1,517",
        "65+": "354",
        "medianAge": "1,517"
      }
    },
    "title": "Production occupations",
    "depth": 2,
    "parent": "Production, transportation, and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8,522",
        "women": "28.8",
        "white": "12.5",
        "black": "6.2",
        "asian": "22.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "7,551",
        "median": "663",
        "maleWorkers": "5,548",
        "maleMedian": "729",
        "femaleWorkers": "2,003",
        "femaleMedian": "519"
      }
    }
  },
  "First-line supervisors of production and operating workers": {
    "ageData": {
      "2015": {
        "total": "817",
        "16to19": "1",
        "20to24": "24",
        "25to34": "159",
        "35to44": "182",
        "45to54": "264",
        "55to64": "159",
        "65+": "28",
        "medianAge": "159"
      }
    },
    "title": "First-line supervisors of production and operating workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "817",
        "women": "18.6",
        "white": "8.0",
        "black": "4.6",
        "asian": "16.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "783",
        "median": "875",
        "maleWorkers": "650",
        "maleMedian": "924",
        "femaleWorkers": "133",
        "femaleMedian": "623"
      }
    }
  },
  "Aircraft structure, surfaces, rigging, and systems assemblers": {
    "ageData": {
      "2015": {
        "total": "14",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "2",
        "45to54": "3",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Aircraft structure, surfaces, rigging, and systems assemblers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Electrical, electronics, and electromechanical assemblers": {
    "ageData": {
      "2015": {
        "total": "133",
        "16to19": "2",
        "20to24": "18",
        "25to34": "25",
        "35to44": "23",
        "45to54": "29",
        "55to64": "27",
        "65+": "9",
        "medianAge": "27"
      }
    },
    "title": "Electrical, electronics, and electromechanical assemblers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "133",
        "women": "51.4",
        "white": "16.9",
        "black": "22.0",
        "asian": "22.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "123",
        "median": "554",
        "maleWorkers": "59",
        "maleMedian": "566",
        "femaleWorkers": "64",
        "femaleMedian": "544"
      }
    }
  },
  "Engine and other machine assemblers": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "3",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Engine and other machine assemblers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Structural metal fabricators and fitters": {
    "ageData": {
      "2015": {
        "total": "32",
        "16to19": "0",
        "20to24": "4",
        "25to34": "10",
        "35to44": "5",
        "45to54": "6",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Structural metal fabricators and fitters",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "32",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "31",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous assemblers and fabricators": {
    "ageData": {
      "2015": {
        "total": "1,026",
        "16to19": "23",
        "20to24": "114",
        "25to34": "244",
        "35to44": "219",
        "45to54": "216",
        "55to64": "169",
        "65+": "41",
        "medianAge": "169"
      }
    },
    "title": "Miscellaneous assemblers and fabricators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,026",
        "women": "38.6",
        "white": "16.1",
        "black": "6.9",
        "asian": "22.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "950",
        "median": "581",
        "maleWorkers": "573",
        "maleMedian": "637",
        "femaleWorkers": "377",
        "femaleMedian": "512"
      }
    }
  },
  "Bakers": {
    "ageData": {
      "2015": {
        "total": "231",
        "16to19": "10",
        "20to24": "33",
        "25to34": "55",
        "35to44": "30",
        "45to54": "56",
        "55to64": "35",
        "65+": "12",
        "medianAge": "35"
      }
    },
    "title": "Bakers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "231",
        "women": "60.8",
        "white": "15.4",
        "black": "9.6",
        "asian": "23.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "150",
        "median": "505",
        "maleWorkers": "69",
        "maleMedian": "570",
        "femaleWorkers": "80",
        "femaleMedian": "475"
      }
    }
  },
  "Butchers and other meat, poultry, and fish processing workers": {
    "ageData": {
      "2015": {
        "total": "302",
        "16to19": "5",
        "20to24": "35",
        "25to34": "78",
        "35to44": "65",
        "45to54": "63",
        "55to64": "43",
        "65+": "13",
        "medianAge": "43"
      }
    },
    "title": "Butchers and other meat, poultry, and fish processing workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "302",
        "women": "25.7",
        "white": "22.4",
        "black": "8.0",
        "asian": "35.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "247",
        "median": "542",
        "maleWorkers": "187",
        "maleMedian": "582",
        "femaleWorkers": "60",
        "femaleMedian": "463"
      }
    }
  },
  "Food and tobacco roasting, baking, and drying machine operators and tenders": {
    "ageData": {
      "2015": {
        "total": "14",
        "16to19": "0",
        "20to24": "3",
        "25to34": "6",
        "35to44": "2",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Food and tobacco roasting, baking, and drying machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "14",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Food batchmakers": {
    "ageData": {
      "2015": {
        "total": "101",
        "16to19": "6",
        "20to24": "13",
        "25to34": "31",
        "35to44": "22",
        "45to54": "20",
        "55to64": "8",
        "65+": "2",
        "medianAge": "8"
      }
    },
    "title": "Food batchmakers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "101",
        "women": "72.3",
        "white": "14.1",
        "black": "7.0",
        "asian": "29.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "79",
        "median": "500",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "54",
        "femaleMedian": "489"
      }
    }
  },
  "Food cooking machine operators and tenders": {
    "ageData": {
      "2015": {
        "total": "13",
        "16to19": "1",
        "20to24": "1",
        "25to34": "5",
        "35to44": "2",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Food cooking machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "13",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Food processing workers, all other": {
    "ageData": {
      "2015": {
        "total": "135",
        "16to19": "2",
        "20to24": "17",
        "25to34": "39",
        "35to44": "31",
        "45to54": "25",
        "55to64": "16",
        "65+": "6",
        "medianAge": "16"
      }
    },
    "title": "Food processing workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "135",
        "women": "34.2",
        "white": "16.6",
        "black": "7.6",
        "asian": "35.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "132",
        "median": "594",
        "maleWorkers": "82",
        "maleMedian": "679",
        "femaleWorkers": "50",
        "femaleMedian": "508"
      }
    }
  },
  "Computer control programmers and operators": {
    "ageData": {
      "2015": {
        "total": "88",
        "16to19": "2",
        "20to24": "10",
        "25to34": "15",
        "35to44": "26",
        "45to54": "22",
        "55to64": "13",
        "65+": "1",
        "medianAge": "13"
      }
    },
    "title": "Computer control programmers and operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "88",
        "women": "3.9",
        "white": "8.4",
        "black": "3.7",
        "asian": "9.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "83",
        "median": "833",
        "maleWorkers": "81",
        "maleMedian": "857",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Extruding and drawing machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "9",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "1",
        "45to54": "3",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Extruding and drawing machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Forging machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "8",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "1",
        "45to54": "2",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Forging machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "8",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Rolling machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "15",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "3",
        "45to54": "4",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Rolling machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Cutting, punching, and press machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "82",
        "16to19": "2",
        "20to24": "11",
        "25to34": "16",
        "35to44": "20",
        "45to54": "18",
        "55to64": "14",
        "65+": "1",
        "medianAge": "14"
      }
    },
    "title": "Cutting, punching, and press machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "82",
        "women": "21.6",
        "white": "20.1",
        "black": "1.4",
        "asian": "14.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "78",
        "median": "633",
        "maleWorkers": "62",
        "maleMedian": "674",
        "femaleWorkers": "15",
        "femaleMedian": "-"
      }
    }
  },
  "Drilling and boring machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "1",
        "45to54": "1",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Drilling and boring machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "51",
        "16to19": "2",
        "20to24": "9",
        "25to34": "13",
        "35to44": "9",
        "45to54": "12",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Grinding, lapping, polishing, and buffing machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "51",
        "women": "10.3",
        "white": "11.5",
        "black": "0.2",
        "asian": "29.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "41",
        "median": "-",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Lathe and turning machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "1",
        "45to54": "4",
        "55to64": "3",
        "65+": "0",
        "medianAge": "3"
      }
    },
    "title": "Lathe and turning machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Milling and planing machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "0",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Milling and planing machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "0",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Machinists": {
    "ageData": {
      "2015": {
        "total": "363",
        "16to19": "3",
        "20to24": "29",
        "25to34": "73",
        "35to44": "68",
        "45to54": "92",
        "55to64": "85",
        "65+": "14",
        "medianAge": "85"
      }
    },
    "title": "Machinists",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "363",
        "women": "6.7",
        "white": "3.1",
        "black": "6.1",
        "asian": "13.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "338",
        "median": "834",
        "maleWorkers": "320",
        "maleMedian": "840",
        "femaleWorkers": "17",
        "femaleMedian": "-"
      }
    }
  },
  "Metal furnace operators, tenders, pourers, and casters": {
    "ageData": {
      "2015": {
        "total": "30",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "7",
        "45to54": "9",
        "55to64": "6",
        "65+": "2",
        "medianAge": "6"
      }
    },
    "title": "Metal furnace operators, tenders, pourers, and casters",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "30",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Model makers and patternmakers, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "3",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Model makers and patternmakers, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Molders and molding machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "46",
        "16to19": "1",
        "20to24": "3",
        "25to34": "15",
        "35to44": "9",
        "45to54": "7",
        "55to64": "9",
        "65+": "1",
        "medianAge": "9"
      }
    },
    "title": "Molders and molding machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "46",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "47",
        "median": "-",
        "maleWorkers": "39",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Multiple machine tool setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Multiple machine tool setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Tool and die makers": {
    "ageData": {
      "2015": {
        "total": "47",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "10",
        "45to54": "15",
        "55to64": "17",
        "65+": "3",
        "medianAge": "17"
      }
    },
    "title": "Tool and die makers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "47",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "49",
        "median": "-",
        "maleWorkers": "49",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Welding, soldering, and brazing workers": {
    "ageData": {
      "2015": {
        "total": "615",
        "16to19": "15",
        "20to24": "69",
        "25to34": "162",
        "35to44": "140",
        "45to54": "140",
        "55to64": "76",
        "65+": "13",
        "medianAge": "76"
      }
    },
    "title": "Welding, soldering, and brazing workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "615",
        "women": "4.2",
        "white": "7.1",
        "black": "3.3",
        "asian": "23.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "568",
        "median": "760",
        "maleWorkers": "545",
        "maleMedian": "767",
        "femaleWorkers": "23",
        "femaleMedian": "-"
      }
    }
  },
  "Heat treating equipment setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Heat treating equipment setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Layout workers, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "1",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Layout workers, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Plating and coating machine setters, operators, and tenders, metal and plastic": {
    "ageData": {
      "2015": {
        "total": "23",
        "16to19": "1",
        "20to24": "4",
        "25to34": "4",
        "35to44": "8",
        "45to54": "5",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Plating and coating machine setters, operators, and tenders, metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "24",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Tool grinders, filers, and sharpeners": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "0",
        "45to54": "0",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Tool grinders, filers, and sharpeners",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Metal workers and plastic workers, all other": {
    "ageData": {
      "2015": {
        "total": "376",
        "16to19": "4",
        "20to24": "46",
        "25to34": "80",
        "35to44": "72",
        "45to54": "95",
        "55to64": "68",
        "65+": "12",
        "medianAge": "68"
      }
    },
    "title": "Metal workers and plastic workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "376",
        "women": "22.5",
        "white": "17.6",
        "black": "6.3",
        "asian": "22.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "351",
        "median": "639",
        "maleWorkers": "278",
        "maleMedian": "678",
        "femaleWorkers": "72",
        "femaleMedian": "581"
      }
    }
  },
  "Prepress technicians and workers": {
    "ageData": {
      "2015": {
        "total": "22",
        "16to19": "0",
        "20to24": "2",
        "25to34": "3",
        "35to44": "4",
        "45to54": "7",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Prepress technicians and workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "22",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Printing press operators": {
    "ageData": {
      "2015": {
        "total": "180",
        "16to19": "4",
        "20to24": "13",
        "25to34": "37",
        "35to44": "44",
        "45to54": "42",
        "55to64": "34",
        "65+": "5",
        "medianAge": "34"
      }
    },
    "title": "Printing press operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "180",
        "women": "20.0",
        "white": "9.0",
        "black": "3.6",
        "asian": "22.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "160",
        "median": "707",
        "maleWorkers": "134",
        "maleMedian": "729",
        "femaleWorkers": "26",
        "femaleMedian": "-"
      }
    }
  },
  "Print binding and finishing workers": {
    "ageData": {
      "2015": {
        "total": "20",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "5",
        "45to54": "3",
        "55to64": "6",
        "65+": "5",
        "medianAge": "6"
      }
    },
    "title": "Print binding and finishing workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "20",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "16",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Laundry and dry-cleaning workers": {
    "ageData": {
      "2015": {
        "total": "192",
        "16to19": "3",
        "20to24": "16",
        "25to34": "33",
        "35to44": "31",
        "45to54": "48",
        "55to64": "39",
        "65+": "23",
        "medianAge": "39"
      }
    },
    "title": "Laundry and dry-cleaning workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "192",
        "women": "60.8",
        "white": "17.7",
        "black": "10.8",
        "asian": "31.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "133",
        "median": "466",
        "maleWorkers": "53",
        "maleMedian": "487",
        "femaleWorkers": "80",
        "femaleMedian": "460"
      }
    }
  },
  "Pressers, textile, garment, and related materials": {
    "ageData": {
      "2015": {
        "total": "34",
        "16to19": "0",
        "20to24": "3",
        "25to34": "7",
        "35to44": "7",
        "45to54": "9",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Pressers, textile, garment, and related materials",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "34",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "12",
        "femaleMedian": "-"
      }
    }
  },
  "Sewing machine operators": {
    "ageData": {
      "2015": {
        "total": "196",
        "16to19": "1",
        "20to24": "7",
        "25to34": "24",
        "35to44": "54",
        "45to54": "48",
        "55to64": "52",
        "65+": "10",
        "medianAge": "52"
      }
    },
    "title": "Sewing machine operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "196",
        "women": "74.8",
        "white": "9.7",
        "black": "12.4",
        "asian": "41.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "147",
        "median": "493",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "105",
        "femaleMedian": "476"
      }
    }
  },
  "Shoe and leather workers and repairers": {
    "ageData": {
      "2015": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "2",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Shoe and leather workers and repairers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Shoe machine operators and tenders": {
    "ageData": {
      "2015": {
        "total": "2",
        "16to19": "1",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Shoe machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "2",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Tailors, dressmakers, and sewers": {
    "ageData": {
      "2015": {
        "total": "83",
        "16to19": "2",
        "20to24": "4",
        "25to34": "6",
        "35to44": "13",
        "45to54": "18",
        "55to64": "25",
        "65+": "16",
        "medianAge": "25"
      }
    },
    "title": "Tailors, dressmakers, and sewers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "83",
        "women": "82.2",
        "white": "5.3",
        "black": "17.1",
        "asian": "22.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "27",
        "femaleMedian": "-"
      }
    }
  },
  "Textile bleaching and dyeing machine operators and tenders": {
    "ageData": {
      "2015": {
        "total": "3",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "0",
        "45to54": "1",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Textile bleaching and dyeing machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Textile cutting machine setters, operators, and tenders": {
    "ageData": {
      "2015": {
        "total": "9",
        "16to19": "0",
        "20to24": "1",
        "25to34": "2",
        "35to44": "2",
        "45to54": "1",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Textile cutting machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Textile knitting and weaving machine setters, operators, and tenders": {
    "ageData": {
      "2015": {
        "total": "9",
        "16to19": "0",
        "20to24": "3",
        "25to34": "2",
        "35to44": "2",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Textile knitting and weaving machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Textile winding, twisting, and drawing out machine setters, operators, and tenders": {
    "ageData": {
      "2015": {
        "total": "9",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "2",
        "45to54": "3",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Textile winding, twisting, and drawing out machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers": {
    "ageData": {
      "2015": {
        "total": "0",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Extruding and forming machine setters, operators, and tenders, synthetic and glass fibers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "0",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Fabric and apparel patternmakers": {
    "ageData": {
      "2015": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "0",
        "45to54": "2",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Fabric and apparel patternmakers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Upholsterers": {
    "ageData": {
      "2015": {
        "total": "40",
        "16to19": "0",
        "20to24": "2",
        "25to34": "7",
        "35to44": "10",
        "45to54": "7",
        "55to64": "12",
        "65+": "1",
        "medianAge": "12"
      }
    },
    "title": "Upholsterers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "40",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Textile, apparel, and furnishings workers, all other": {
    "ageData": {
      "2015": {
        "total": "16",
        "16to19": "0",
        "20to24": "1",
        "25to34": "4",
        "35to44": "2",
        "45to54": "4",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Textile, apparel, and furnishings workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "16",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "16",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Cabinetmakers and bench carpenters": {
    "ageData": {
      "2015": {
        "total": "60",
        "16to19": "2",
        "20to24": "1",
        "25to34": "12",
        "35to44": "11",
        "45to54": "11",
        "55to64": "18",
        "65+": "5",
        "medianAge": "18"
      }
    },
    "title": "Cabinetmakers and bench carpenters",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "60",
        "women": "7.9",
        "white": "4.3",
        "black": "1.2",
        "asian": "20.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "40",
        "median": "-",
        "maleWorkers": "38",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Furniture finishers": {
    "ageData": {
      "2015": {
        "total": "15",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "5",
        "45to54": "1",
        "55to64": "6",
        "65+": "2",
        "medianAge": "6"
      }
    },
    "title": "Furniture finishers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Model makers and patternmakers, wood": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Model makers and patternmakers, wood",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Sawing machine setters, operators, and tenders, wood": {
    "ageData": {
      "2015": {
        "total": "29",
        "16to19": "1",
        "20to24": "2",
        "25to34": "7",
        "35to44": "6",
        "45to54": "6",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Sawing machine setters, operators, and tenders, wood",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Woodworking machine setters, operators, and tenders, except sawing": {
    "ageData": {
      "2015": {
        "total": "24",
        "16to19": "1",
        "20to24": "3",
        "25to34": "3",
        "35to44": "4",
        "45to54": "9",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Woodworking machine setters, operators, and tenders, except sawing",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "24",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "23",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Woodworkers, all other": {
    "ageData": {
      "2015": {
        "total": "31",
        "16to19": "1",
        "20to24": "1",
        "25to34": "6",
        "35to44": "6",
        "45to54": "5",
        "55to64": "9",
        "65+": "3",
        "medianAge": "9"
      }
    },
    "title": "Woodworkers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "31",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Power plant operators, distributors, and dispatchers": {
    "ageData": {
      "2015": {
        "total": "33",
        "16to19": "0",
        "20to24": "1",
        "25to34": "10",
        "35to44": "6",
        "45to54": "8",
        "55to64": "7",
        "65+": "1",
        "medianAge": "7"
      }
    },
    "title": "Power plant operators, distributors, and dispatchers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "34",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Stationary engineers and boiler operators": {
    "ageData": {
      "2015": {
        "total": "81",
        "16to19": "0",
        "20to24": "2",
        "25to34": "11",
        "35to44": "20",
        "45to54": "23",
        "55to64": "22",
        "65+": "3",
        "medianAge": "22"
      }
    },
    "title": "Stationary engineers and boiler operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "81",
        "women": "3.4",
        "white": "9.4",
        "black": "5.2",
        "asian": "10.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "84",
        "median": "996",
        "maleWorkers": "81",
        "maleMedian": "1,012",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Water and wastewater treatment plant and system operators": {
    "ageData": {
      "2015": {
        "total": "89",
        "16to19": "0",
        "20to24": "4",
        "25to34": "12",
        "35to44": "23",
        "45to54": "28",
        "55to64": "18",
        "65+": "4",
        "medianAge": "18"
      }
    },
    "title": "Water and wastewater treatment plant and system operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "89",
        "women": "4.4",
        "white": "7.1",
        "black": "1.5",
        "asian": "6.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "82",
        "median": "880",
        "maleWorkers": "79",
        "maleMedian": "868",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Miscellaneous plant and system operators": {
    "ageData": {
      "2015": {
        "total": "36",
        "16to19": "0",
        "20to24": "3",
        "25to34": "9",
        "35to44": "10",
        "45to54": "9",
        "55to64": "5",
        "65+": "1",
        "medianAge": "5"
      }
    },
    "title": "Miscellaneous plant and system operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "36",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "35",
        "median": "-",
        "maleWorkers": "33",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Chemical processing machine setters, operators, and tenders": {
    "ageData": {
      "2015": {
        "total": "63",
        "16to19": "1",
        "20to24": "3",
        "25to34": "23",
        "35to44": "11",
        "45to54": "12",
        "55to64": "12",
        "65+": "1",
        "medianAge": "12"
      }
    },
    "title": "Chemical processing machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "63",
        "women": "13.0",
        "white": "4.3",
        "black": "0.4",
        "asian": "10.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "62",
        "median": "1,052",
        "maleWorkers": "57",
        "maleMedian": "1,082",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Crushing, grinding, polishing, mixing, and blending workers": {
    "ageData": {
      "2015": {
        "total": "86",
        "16to19": "2",
        "20to24": "13",
        "25to34": "21",
        "35to44": "18",
        "45to54": "18",
        "55to64": "13",
        "65+": "2",
        "medianAge": "13"
      }
    },
    "title": "Crushing, grinding, polishing, mixing, and blending workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "86",
        "women": "11.0",
        "white": "10.5",
        "black": "3.1",
        "asian": "37.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "82",
        "median": "652",
        "maleWorkers": "75",
        "maleMedian": "668",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Cutting workers": {
    "ageData": {
      "2015": {
        "total": "64",
        "16to19": "2",
        "20to24": "10",
        "25to34": "14",
        "35to44": "17",
        "45to54": "11",
        "55to64": "8",
        "65+": "2",
        "medianAge": "8"
      }
    },
    "title": "Cutting workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "64",
        "women": "16.7",
        "white": "13.4",
        "black": "2.6",
        "asian": "24.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "51",
        "median": "685",
        "maleWorkers": "41",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Extruding, forming, pressing, and compacting machine setters, operators, and tenders": {
    "ageData": {
      "2015": {
        "total": "28",
        "16to19": "1",
        "20to24": "4",
        "25to34": "3",
        "35to44": "7",
        "45to54": "7",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Extruding, forming, pressing, and compacting machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "28",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "31",
        "median": "-",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Furnace, kiln, oven, drier, and kettle operators and tenders": {
    "ageData": {
      "2015": {
        "total": "7",
        "16to19": "1",
        "20to24": "0",
        "25to34": "1",
        "35to44": "2",
        "45to54": "2",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Furnace, kiln, oven, drier, and kettle operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Inspectors, testers, sorters, samplers, and weighers": {
    "ageData": {
      "2015": {
        "total": "752",
        "16to19": "12",
        "20to24": "54",
        "25to34": "161",
        "35to44": "157",
        "45to54": "185",
        "55to64": "148",
        "65+": "35",
        "medianAge": "148"
      }
    },
    "title": "Inspectors, testers, sorters, samplers, and weighers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "752",
        "women": "37.3",
        "white": "12.5",
        "black": "6.9",
        "asian": "17.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "701",
        "median": "710",
        "maleWorkers": "440",
        "maleMedian": "844",
        "femaleWorkers": "260",
        "femaleMedian": "583"
      }
    }
  },
  "Jewelers and precious stone and metal workers": {
    "ageData": {
      "2015": {
        "total": "44",
        "16to19": "0",
        "20to24": "2",
        "25to34": "5",
        "35to44": "10",
        "45to54": "14",
        "55to64": "10",
        "65+": "4",
        "medianAge": "10"
      }
    },
    "title": "Jewelers and precious stone and metal workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "44",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "19",
        "median": "-",
        "maleWorkers": "11",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Medical, dental, and ophthalmic laboratory technicians": {
    "ageData": {
      "2015": {
        "total": "110",
        "16to19": "1",
        "20to24": "6",
        "25to34": "24",
        "35to44": "26",
        "45to54": "27",
        "55to64": "14",
        "65+": "11",
        "medianAge": "14"
      }
    },
    "title": "Medical, dental, and ophthalmic laboratory technicians",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "110",
        "women": "48.6",
        "white": "7.8",
        "black": "13.4",
        "asian": "19.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "86",
        "median": "648",
        "maleWorkers": "44",
        "maleMedian": "-",
        "femaleWorkers": "42",
        "femaleMedian": "-"
      }
    }
  },
  "Packaging and filling machine operators and tenders": {
    "ageData": {
      "2015": {
        "total": "250",
        "16to19": "4",
        "20to24": "35",
        "25to34": "45",
        "35to44": "54",
        "45to54": "59",
        "55to64": "47",
        "65+": "6",
        "medianAge": "47"
      }
    },
    "title": "Packaging and filling machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "250",
        "women": "49.9",
        "white": "20.4",
        "black": "7.5",
        "asian": "36.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "239",
        "median": "518",
        "maleWorkers": "118",
        "maleMedian": "605",
        "femaleWorkers": "120",
        "femaleMedian": "482"
      }
    }
  },
  "Painting workers": {
    "ageData": {
      "2015": {
        "total": "151",
        "16to19": "3",
        "20to24": "16",
        "25to34": "36",
        "35to44": "44",
        "45to54": "31",
        "55to64": "17",
        "65+": "4",
        "medianAge": "17"
      }
    },
    "title": "Painting workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "151",
        "women": "12.9",
        "white": "14.2",
        "black": "5.2",
        "asian": "23.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "129",
        "median": "708",
        "maleWorkers": "110",
        "maleMedian": "733",
        "femaleWorkers": "18",
        "femaleMedian": "-"
      }
    }
  },
  "Photographic process workers and processing machine operators": {
    "ageData": {
      "2015": {
        "total": "33",
        "16to19": "0",
        "20to24": "5",
        "25to34": "13",
        "35to44": "3",
        "45to54": "8",
        "55to64": "2",
        "65+": "2",
        "medianAge": "2"
      }
    },
    "title": "Photographic process workers and processing machine operators",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "26",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "14",
        "femaleMedian": "-"
      }
    }
  },
  "Semiconductor processors": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Semiconductor processors",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1",
        "median": "-",
        "maleWorkers": "1",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Adhesive bonding machine operators and tenders": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "0",
        "25to34": "2",
        "35to44": "1",
        "45to54": "4",
        "55to64": "2",
        "65+": "1",
        "medianAge": "2"
      }
    },
    "title": "Adhesive bonding machine operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "9",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Cleaning, washing, and metal pickling equipment operators and tenders": {
    "ageData": {
      "2015": {
        "total": "4",
        "16to19": "1",
        "20to24": "0",
        "25to34": "1",
        "35to44": "0",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Cleaning, washing, and metal pickling equipment operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "2",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Cooling and freezing equipment operators and tenders": {
    "ageData": {
      "2015": {
        "total": "4",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "0",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Cooling and freezing equipment operators and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "4",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "3",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Etchers and engravers": {
    "ageData": {
      "2015": {
        "total": "19",
        "16to19": "3",
        "20to24": "0",
        "25to34": "3",
        "35to44": "2",
        "45to54": "5",
        "55to64": "5",
        "65+": "2",
        "medianAge": "5"
      }
    },
    "title": "Etchers and engravers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "19",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "12",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Molders, shapers, and casters, except metal and plastic": {
    "ageData": {
      "2015": {
        "total": "27",
        "16to19": "0",
        "20to24": "2",
        "25to34": "10",
        "35to44": "4",
        "45to54": "1",
        "55to64": "8",
        "65+": "1",
        "medianAge": "8"
      }
    },
    "title": "Molders, shapers, and casters, except metal and plastic",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "27",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "14",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Paper goods machine setters, operators, and tenders": {
    "ageData": {
      "2015": {
        "total": "30",
        "16to19": "1",
        "20to24": "1",
        "25to34": "6",
        "35to44": "11",
        "45to54": "6",
        "55to64": "4",
        "65+": "0",
        "medianAge": "4"
      }
    },
    "title": "Paper goods machine setters, operators, and tenders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "30",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "27",
        "median": "-",
        "maleWorkers": "22",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Tire builders": {
    "ageData": {
      "2015": {
        "total": "10",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "2",
        "45to54": "2",
        "55to64": "2",
        "65+": "0",
        "medianAge": "2"
      }
    },
    "title": "Tire builders",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "10",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "8",
        "median": "-",
        "maleWorkers": "8",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Helpers--production workers": {
    "ageData": {
      "2015": {
        "total": "40",
        "16to19": "5",
        "20to24": "10",
        "25to34": "7",
        "35to44": "4",
        "45to54": "7",
        "55to64": "6",
        "65+": "1",
        "medianAge": "6"
      }
    },
    "title": "Helpers--production workers",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "40",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "24",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Production workers, all other": {
    "ageData": {
      "2015": {
        "total": "944",
        "16to19": "24",
        "20to24": "95",
        "25to34": "216",
        "35to44": "200",
        "45to54": "230",
        "55to64": "148",
        "65+": "32",
        "medianAge": "148"
      }
    },
    "title": "Production workers, all other",
    "depth": 3,
    "parent": "Production occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "944",
        "women": "25.5",
        "white": "14.4",
        "black": "4.9",
        "asian": "24.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "846",
        "median": "625",
        "maleWorkers": "643",
        "maleMedian": "666",
        "femaleWorkers": "203",
        "femaleMedian": "501"
      }
    }
  },
  "Transportation and material moving occupations": {
    "ageData": {
      "2015": {
        "total": "9,125",
        "16to19": "321",
        "20to24": "933",
        "25to34": "1,742",
        "35to44": "1,836",
        "45to54": "2,121",
        "55to64": "1,637",
        "65+": "534",
        "medianAge": "1,637"
      }
    },
    "title": "Transportation and material moving occupations",
    "depth": 2,
    "parent": "Production, transportation, and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "9,125",
        "women": "15.3",
        "white": "17.8",
        "black": "3.4",
        "asian": "22.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6,953",
        "median": "646",
        "maleWorkers": "5,998",
        "maleMedian": "679",
        "femaleWorkers": "955",
        "femaleMedian": "494"
      }
    }
  },
  "Supervisors of transportation and material moving workers": {
    "ageData": {
      "2015": {
        "total": "205",
        "16to19": "1",
        "20to24": "14",
        "25to34": "46",
        "35to44": "48",
        "45to54": "56",
        "55to64": "36",
        "65+": "5",
        "medianAge": "36"
      }
    },
    "title": "Supervisors of transportation and material moving workers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "205",
        "women": "18.1",
        "white": "15.0",
        "black": "1.6",
        "asian": "20.6"
      }
    },
    "wageData": {
      "2015": {
        "workers": "186",
        "median": "894",
        "maleWorkers": "153",
        "maleMedian": "898",
        "femaleWorkers": "33",
        "femaleMedian": "-"
      }
    }
  },
  "Aircraft pilots and flight engineers": {
    "ageData": {
      "2015": {
        "total": "140",
        "16to19": "0",
        "20to24": "1",
        "25to34": "18",
        "35to44": "42",
        "45to54": "47",
        "55to64": "27",
        "65+": "6",
        "medianAge": "27"
      }
    },
    "title": "Aircraft pilots and flight engineers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "140",
        "women": "9.4",
        "white": "2.6",
        "black": "0.7",
        "asian": "5.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "114",
        "median": "1,735",
        "maleWorkers": "104",
        "maleMedian": "1,830",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Air traffic controllers and airfield operations specialists": {
    "ageData": {
      "2015": {
        "total": "30",
        "16to19": "1",
        "20to24": "2",
        "25to34": "10",
        "35to44": "2",
        "45to54": "9",
        "55to64": "4",
        "65+": "2",
        "medianAge": "4"
      }
    },
    "title": "Air traffic controllers and airfield operations specialists",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "30",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "32",
        "median": "-",
        "maleWorkers": "24",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Flight attendants": {
    "ageData": {
      "2015": {
        "total": "86",
        "16to19": "0",
        "20to24": "1",
        "25to34": "18",
        "35to44": "12",
        "45to54": "34",
        "55to64": "19",
        "65+": "2",
        "medianAge": "19"
      }
    },
    "title": "Flight attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "86",
        "women": "74.9",
        "white": "12.0",
        "black": "4.5",
        "asian": "9.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "63",
        "median": "846",
        "maleWorkers": "20",
        "maleMedian": "-",
        "femaleWorkers": "43",
        "femaleMedian": "-"
      }
    }
  },
  "Ambulance drivers and attendants, except emergency medical technicians": {
    "ageData": {
      "2015": {
        "total": "19",
        "16to19": "0",
        "20to24": "4",
        "25to34": "6",
        "35to44": "3",
        "45to54": "1",
        "55to64": "3",
        "65+": "2",
        "medianAge": "3"
      }
    },
    "title": "Ambulance drivers and attendants, except emergency medical technicians",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "19",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Bus drivers": {
    "ageData": {
      "2015": {
        "total": "550",
        "16to19": "1",
        "20to24": "11",
        "25to34": "51",
        "35to44": "96",
        "45to54": "167",
        "55to64": "149",
        "65+": "75",
        "medianAge": "149"
      }
    },
    "title": "Bus drivers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "550",
        "women": "47.1",
        "white": "28.0",
        "black": "2.7",
        "asian": "14.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "323",
        "median": "615",
        "maleWorkers": "184",
        "maleMedian": "681",
        "femaleWorkers": "138",
        "femaleMedian": "572"
      }
    }
  },
  "Driver/sales workers and truck drivers": {
    "ageData": {
      "2015": {
        "total": "3,469",
        "16to19": "45",
        "20to24": "216",
        "25to34": "593",
        "35to44": "738",
        "45to54": "919",
        "55to64": "730",
        "65+": "228",
        "medianAge": "730"
      }
    },
    "title": "Driver/sales workers and truck drivers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "3,469",
        "women": "5.1",
        "white": "15.1",
        "black": "2.7",
        "asian": "21.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "2,687",
        "median": "747",
        "maleWorkers": "2,582",
        "maleMedian": "751",
        "femaleWorkers": "105",
        "femaleMedian": "632"
      }
    }
  },
  "Taxi drivers and chauffeurs": {
    "ageData": {
      "2015": {
        "total": "446",
        "16to19": "1",
        "20to24": "16",
        "25to34": "75",
        "35to44": "98",
        "45to54": "115",
        "55to64": "84",
        "65+": "57",
        "medianAge": "84"
      }
    },
    "title": "Taxi drivers and chauffeurs",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "446",
        "women": "14.6",
        "white": "27.0",
        "black": "15.1",
        "asian": "17.0"
      }
    },
    "wageData": {
      "2015": {
        "workers": "253",
        "median": "585",
        "maleWorkers": "216",
        "maleMedian": "600",
        "femaleWorkers": "38",
        "femaleMedian": "-"
      }
    }
  },
  "Motor vehicle operators, all other": {
    "ageData": {
      "2015": {
        "total": "51",
        "16to19": "2",
        "20to24": "5",
        "25to34": "4",
        "35to44": "5",
        "45to54": "6",
        "55to64": "12",
        "65+": "18",
        "medianAge": "12"
      }
    },
    "title": "Motor vehicle operators, all other",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "51",
        "women": "9.4",
        "white": "14.2",
        "black": "5.5",
        "asian": "21.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "18",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Locomotive engineers and operators": {
    "ageData": {
      "2015": {
        "total": "50",
        "16to19": "0",
        "20to24": "0",
        "25to34": "6",
        "35to44": "17",
        "45to54": "16",
        "55to64": "11",
        "65+": "0",
        "medianAge": "11"
      }
    },
    "title": "Locomotive engineers and operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "50",
        "women": "3.5",
        "white": "21.3",
        "black": "1.4",
        "asian": "8.2"
      }
    },
    "wageData": {
      "2015": {
        "workers": "44",
        "median": "-",
        "maleWorkers": "42",
        "maleMedian": "-",
        "femaleWorkers": "2",
        "femaleMedian": "-"
      }
    }
  },
  "Railroad brake, signal, and switch operators": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "3",
        "45to54": "3",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Railroad brake, signal, and switch operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Railroad conductors and yardmasters": {
    "ageData": {
      "2015": {
        "total": "52",
        "16to19": "1",
        "20to24": "3",
        "25to34": "13",
        "35to44": "17",
        "45to54": "13",
        "55to64": "4",
        "65+": "1",
        "medianAge": "4"
      }
    },
    "title": "Railroad conductors and yardmasters",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "52",
        "women": "7.7",
        "white": "18.6",
        "black": "1.7",
        "asian": "2.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "55",
        "median": "1,117",
        "maleWorkers": "52",
        "maleMedian": "1,137",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Subway, streetcar, and other rail transportation workers": {
    "ageData": {
      "2015": {
        "total": "15",
        "16to19": "0",
        "20to24": "0",
        "25to34": "4",
        "35to44": "7",
        "45to54": "3",
        "55to64": "0",
        "65+": "1",
        "medianAge": "0"
      }
    },
    "title": "Subway, streetcar, and other rail transportation workers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "15",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "15",
        "median": "-",
        "maleWorkers": "12",
        "maleMedian": "-",
        "femaleWorkers": "3",
        "femaleMedian": "-"
      }
    }
  },
  "Sailors and marine oilers": {
    "ageData": {
      "2015": {
        "total": "11",
        "16to19": "0",
        "20to24": "5",
        "25to34": "2",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Sailors and marine oilers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "11",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "10",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Ship and boat captains and operators": {
    "ageData": {
      "2015": {
        "total": "35",
        "16to19": "0",
        "20to24": "1",
        "25to34": "5",
        "35to44": "12",
        "45to54": "8",
        "55to64": "6",
        "65+": "3",
        "medianAge": "6"
      }
    },
    "title": "Ship and boat captains and operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "35",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "29",
        "median": "-",
        "maleWorkers": "28",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Ship engineers": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "1",
        "25to34": "0",
        "35to44": "0",
        "45to54": "0",
        "55to64": "3",
        "65+": "1",
        "medianAge": "3"
      }
    },
    "title": "Ship engineers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Bridge and lock tenders": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "1",
        "65+": "2",
        "medianAge": "1"
      }
    },
    "title": "Bridge and lock tenders",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "4",
        "median": "-",
        "maleWorkers": "4",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Parking lot attendants": {
    "ageData": {
      "2015": {
        "total": "91",
        "16to19": "5",
        "20to24": "19",
        "25to34": "24",
        "35to44": "14",
        "45to54": "10",
        "55to64": "13",
        "65+": "6",
        "medianAge": "13"
      }
    },
    "title": "Parking lot attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "91",
        "women": "10.0",
        "white": "32.1",
        "black": "5.3",
        "asian": "26.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "57",
        "median": "492",
        "maleWorkers": "49",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Automotive and watercraft service attendants": {
    "ageData": {
      "2015": {
        "total": "99",
        "16to19": "16",
        "20to24": "30",
        "25to34": "26",
        "35to44": "10",
        "45to54": "7",
        "55to64": "8",
        "65+": "2",
        "medianAge": "8"
      }
    },
    "title": "Automotive and watercraft service attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "99",
        "women": "11.0",
        "white": "8.2",
        "black": "3.8",
        "asian": "12.7"
      }
    },
    "wageData": {
      "2015": {
        "workers": "63",
        "median": "452",
        "maleWorkers": "58",
        "maleMedian": "470",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  },
  "Transportation inspectors": {
    "ageData": {
      "2015": {
        "total": "29",
        "16to19": "0",
        "20to24": "0",
        "25to34": "7",
        "35to44": "4",
        "45to54": "9",
        "55to64": "8",
        "65+": "1",
        "medianAge": "8"
      }
    },
    "title": "Transportation inspectors",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "29",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "21",
        "median": "-",
        "maleWorkers": "14",
        "maleMedian": "-",
        "femaleWorkers": "7",
        "femaleMedian": "-"
      }
    }
  },
  "Transportation attendants, except flight attendants": {
    "ageData": {
      "2015": {
        "total": "22",
        "16to19": "0",
        "20to24": "1",
        "25to34": "3",
        "35to44": "5",
        "45to54": "5",
        "55to64": "4",
        "65+": "3",
        "medianAge": "4"
      }
    },
    "title": "Transportation attendants, except flight attendants",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "22",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "17",
        "median": "-",
        "maleWorkers": "9",
        "maleMedian": "-",
        "femaleWorkers": "8",
        "femaleMedian": "-"
      }
    }
  },
  "Other transportation workers": {
    "ageData": {
      "2015": {
        "total": "43",
        "16to19": "0",
        "20to24": "8",
        "25to34": "15",
        "35to44": "5",
        "45to54": "6",
        "55to64": "9",
        "65+": "0",
        "medianAge": "9"
      }
    },
    "title": "Other transportation workers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "43",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "39",
        "median": "-",
        "maleWorkers": "35",
        "maleMedian": "-",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Conveyor operators and tenders": {
    "ageData": {
      "2015": {
        "total": "7",
        "16to19": "0",
        "20to24": "0",
        "25to34": "1",
        "35to44": "1",
        "45to54": "2",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Conveyor operators and tenders",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "7",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "7",
        "median": "-",
        "maleWorkers": "7",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Crane and tower operators": {
    "ageData": {
      "2015": {
        "total": "76",
        "16to19": "0",
        "20to24": "2",
        "25to34": "13",
        "35to44": "21",
        "45to54": "18",
        "55to64": "17",
        "65+": "5",
        "medianAge": "17"
      }
    },
    "title": "Crane and tower operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "76",
        "women": "3.4",
        "white": "9.1",
        "black": "0.2",
        "asian": "10.3"
      }
    },
    "wageData": {
      "2015": {
        "workers": "75",
        "median": "988",
        "maleWorkers": "71",
        "maleMedian": "1,016",
        "femaleWorkers": "4",
        "femaleMedian": "-"
      }
    }
  },
  "Dredge, excavating, and loading machine operators": {
    "ageData": {
      "2015": {
        "total": "35",
        "16to19": "0",
        "20to24": "5",
        "25to34": "3",
        "35to44": "11",
        "45to54": "10",
        "55to64": "4",
        "65+": "2",
        "medianAge": "4"
      }
    },
    "title": "Dredge, excavating, and loading machine operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "35",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "25",
        "median": "-",
        "maleWorkers": "25",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Hoist and winch operators": {
    "ageData": {
      "2015": {
        "total": "6",
        "16to19": "0",
        "20to24": "0",
        "25to34": "3",
        "35to44": "1",
        "45to54": "0",
        "55to64": "1",
        "65+": "1",
        "medianAge": "1"
      }
    },
    "title": "Hoist and winch operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "6",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "5",
        "median": "-",
        "maleWorkers": "5",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Industrial truck and tractor operators": {
    "ageData": {
      "2015": {
        "total": "589",
        "16to19": "5",
        "20to24": "60",
        "25to34": "145",
        "35to44": "131",
        "45to54": "136",
        "55to64": "97",
        "65+": "15",
        "medianAge": "97"
      }
    },
    "title": "Industrial truck and tractor operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "589",
        "women": "7.1",
        "white": "21.6",
        "black": "2.3",
        "asian": "25.9"
      }
    },
    "wageData": {
      "2015": {
        "workers": "579",
        "median": "609",
        "maleWorkers": "541",
        "maleMedian": "612",
        "femaleWorkers": "37",
        "femaleMedian": "-"
      }
    }
  },
  "Cleaners of vehicles and equipment": {
    "ageData": {
      "2015": {
        "total": "338",
        "16to19": "40",
        "20to24": "60",
        "25to34": "72",
        "35to44": "63",
        "45to54": "65",
        "55to64": "31",
        "65+": "7",
        "medianAge": "31"
      }
    },
    "title": "Cleaners of vehicles and equipment",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "338",
        "women": "11.1",
        "white": "12.3",
        "black": "1.4",
        "asian": "39.4"
      }
    },
    "wageData": {
      "2015": {
        "workers": "222",
        "median": "485",
        "maleWorkers": "200",
        "maleMedian": "498",
        "femaleWorkers": "22",
        "femaleMedian": "-"
      }
    }
  },
  "Laborers and freight, stock, and material movers, hand": {
    "ageData": {
      "2015": {
        "total": "1,908",
        "16to19": "126",
        "20to24": "360",
        "25to34": "447",
        "35to44": "338",
        "45to54": "322",
        "55to64": "255",
        "65+": "59",
        "medianAge": "255"
      }
    },
    "title": "Laborers and freight, stock, and material movers, hand",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1,908",
        "women": "17.6",
        "white": "19.0",
        "black": "2.9",
        "asian": "24.1"
      }
    },
    "wageData": {
      "2015": {
        "workers": "1,433",
        "median": "526",
        "maleWorkers": "1,214",
        "maleMedian": "547",
        "femaleWorkers": "219",
        "femaleMedian": "455"
      }
    }
  },
  "Machine feeders and offbearers": {
    "ageData": {
      "2015": {
        "total": "33",
        "16to19": "1",
        "20to24": "9",
        "25to34": "9",
        "35to44": "3",
        "45to54": "5",
        "55to64": "7",
        "65+": "0",
        "medianAge": "7"
      }
    },
    "title": "Machine feeders and offbearers",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "33",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "30",
        "median": "-",
        "maleWorkers": "21",
        "maleMedian": "-",
        "femaleWorkers": "9",
        "femaleMedian": "-"
      }
    }
  },
  "Packers and packagers, hand": {
    "ageData": {
      "2015": {
        "total": "505",
        "16to19": "70",
        "20to24": "76",
        "25to34": "89",
        "35to44": "94",
        "45to54": "92",
        "55to64": "66",
        "65+": "18",
        "medianAge": "66"
      }
    },
    "title": "Packers and packagers, hand",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "505",
        "women": "51.9",
        "white": "19.0",
        "black": "5.6",
        "asian": "37.5"
      }
    },
    "wageData": {
      "2015": {
        "workers": "385",
        "median": "438",
        "maleWorkers": "158",
        "maleMedian": "462",
        "femaleWorkers": "227",
        "femaleMedian": "424"
      }
    }
  },
  "Pumping station operators": {
    "ageData": {
      "2015": {
        "total": "23",
        "16to19": "0",
        "20to24": "3",
        "25to34": "8",
        "35to44": "2",
        "45to54": "5",
        "55to64": "2",
        "65+": "3",
        "medianAge": "2"
      }
    },
    "title": "Pumping station operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "23",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "18",
        "median": "-",
        "maleWorkers": "17",
        "maleMedian": "-",
        "femaleWorkers": "1",
        "femaleMedian": "-"
      }
    }
  },
  "Refuse and recyclable material collectors": {
    "ageData": {
      "2015": {
        "total": "97",
        "16to19": "3",
        "20to24": "13",
        "25to34": "18",
        "35to44": "18",
        "45to54": "24",
        "55to64": "18",
        "65+": "4",
        "medianAge": "18"
      }
    },
    "title": "Refuse and recyclable material collectors",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "97",
        "women": "10.4",
        "white": "19.1",
        "black": "2.1",
        "asian": "30.8"
      }
    },
    "wageData": {
      "2015": {
        "workers": "72",
        "median": "501",
        "maleWorkers": "66",
        "maleMedian": "496",
        "femaleWorkers": "6",
        "femaleMedian": "-"
      }
    }
  },
  "Mine shuttle car operators": {
    "ageData": {
      "2015": {
        "total": "1",
        "16to19": "0",
        "20to24": "0",
        "25to34": "0",
        "35to44": "1",
        "45to54": "0",
        "55to64": "0",
        "65+": "0",
        "medianAge": "0"
      }
    },
    "title": "Mine shuttle car operators",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "1",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "0",
        "median": "-",
        "maleWorkers": "0",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Tank car, truck, and ship loaders": {
    "ageData": {
      "2015": {
        "total": "5",
        "16to19": "0",
        "20to24": "1",
        "25to34": "1",
        "35to44": "2",
        "45to54": "1",
        "55to64": "1",
        "65+": "0",
        "medianAge": "1"
      }
    },
    "title": "Tank car, truck, and ship loaders",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "5",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "6",
        "median": "-",
        "maleWorkers": "6",
        "maleMedian": "-",
        "femaleWorkers": "0",
        "femaleMedian": "-"
      }
    }
  },
  "Material moving workers, all other": {
    "ageData": {
      "2015": {
        "total": "43",
        "16to19": "3",
        "20to24": "6",
        "25to34": "9",
        "35to44": "9",
        "45to54": "7",
        "55to64": "8",
        "65+": "2",
        "medianAge": "8"
      }
    },
    "title": "Material moving workers, all other",
    "depth": 3,
    "parent": "Transportation and material moving occupations",
    "sexRaceEthnicityData": {
      "2015": {
        "total": "43",
        "women": "-",
        "white": "-",
        "black": "-",
        "asian": "-"
      }
    },
    "wageData": {
      "2015": {
        "workers": "37",
        "median": "-",
        "maleWorkers": "32",
        "maleMedian": "-",
        "femaleWorkers": "5",
        "femaleMedian": "-"
      }
    }
  }
}